import React, { Component } from "react";
import InputMask from "react-input-mask";
import Moment from "moment";
import $ from "jquery";
import {
  ListaDadosProposta,
  ListaClientes,
  ListaContato,
  ListaTotalOrcamentoPedido,
  ListaEmpresas,
  ListaCondicaoPagamento,
  ListaItensPropostas,
  ListaConfigProdutos,
  buscaProdutoPorParametros,
  buscaInfoProdSelecionado,
  inserirDadosProposta,
  ListaFunilDeVenda,
  ListaMotivoPerda,
  ListaHistorico,
  InserirHistoricoTMK,
  dadosParceiro,
  ListaConfigEmbalagem,
  buscaValorProduto,
  DeletarEmbalagemProduto,
  DeletarProduto,
  ListaTabelaPrecoEmbalagem,
  EnviarPropostaParaCliente,
  UploadFileDrive,
  ListaLayoutProduto,
  runVerificaAutenticacao,
} from "../../../services/api";
import Header from "../../../components/Header";
import {
  BudgetFooter,
  BudgetFooterContent,
  BudgetFooterContentDivisor,
  BudgetFooterContentItem,
  ContentMarginBottom,
  InputDataRetorno,
  ModalContentGrid,
  ModalContentGridColumn,
  ModalContentGridLoading,
  ModalContentGridLoadingContent,
  RegisterBudget,
  RegisterBudgetContent,
  RegisterBudgetContentDataCustomer,
  RegisterBudgetContentDataCustomerBody,
  RegisterBudgetContentDataCustomerBodyContent,
  RegisterBudgetContentDataCustomerBodyContentRow,
  RegisterBudgetContentDataCustomerBodyContentRowButton,
  RegisterBudgetContentDataCustomerBodyContentRowButtonBTN,
  RegisterBudgetContentDataCustomerBodyContentRowButtonMedium,
  RegisterBudgetContentDataCustomerBodyContentRowButtonRegister,
  RegisterBudgetContentDataCustomerBodyContentRowGray,
  RegisterBudgetContentDataCustomerBodyContentRowInformation,
  RegisterBudgetContentDataCustomerBodyContentRowInformationPlus,
  RegisterBudgetContentDataCustomerBodyContentRowSelectField,
  RegisterBudgetContentDataCustomerBodyContentRowSelectFieldField,
  RegisterBudgetContentDataCustomerBodyContentRowSelectFieldFieldText,
  RegisterBudgetContentDataCustomerBodyContentRowTextField,
  RegisterBudgetContentDataCustomerBodyContentRowTextFieldSmall,
  RegisterBudgetContentDataCustomerHeader,
  RegisterBudgetContentDataCustomerHeaderTitle,
  RegisterBudgetContentDataProduct,
  RegisterBudgetContentDataProductBody,
  RegisterBudgetContentDataProductBodyAbaProducts,
  RegisterBudgetContentDataProductBodyAbaProductsContent,
  RegisterBudgetContentDataProductBodyAbaProductsContentBody,
  RegisterBudgetContentDataProductBodyAbaProductsContentBodyProduct,
  RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductConfig,
  RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductConfigColumn,
  RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductConfigColumnField,
  RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductConfigColumnFieldCep,
  RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductConfigColumnLarge,
  RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductEmb,
  RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductEmbConfig,
  RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductEmbConfigColumn,
  RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductEmbConfigColumnField,
  RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductEmbConfigColumnLarge,
  RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductEmbHeader,
  RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductEmbHeaderConfig,
  RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductEmbHeaderConfigImage,
  RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductEmbHeaderConfigOptions,
  RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductEmbHeaderConfigOptionsCub,
  RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductEmbHeaderConfigOptionsField,
  RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductEmbHeaderLoading,
  RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductEmbHeaderTitle,
  RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductFrete,
  RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductFreteDigiteCep,
  RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductFreteDigiteCepColumn,
  RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductFreteDigiteCepColumnField,
  RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductFreteDigiteCepColumnFieldCep,
  RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductFreteDigiteCepColumnFieldLarge,
  RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductFreteGrid,
  RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductFreteGridContent,
  RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductFreteGridContentColumn,
  RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductFreteGridContentColumnCel,
  RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductFreteGridContentColumnCelColorGray,
  RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductFreteGridResumo,
  RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductFreteGridResumoContent,
  RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductFreteGridResumoContentRow,
  RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductHeader,
  RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductHeaderDados,
  RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductHeaderDadosDescricao,
  RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductHeaderDadosVerifiqueCubagem,
  RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductHeaderDadosVerifiqueEstoque,
  RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductHeaderImage,
  RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductHeaderTitle,
  RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductSubtitle,
  RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductTicket,
  RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductTicketLayout,
  RegisterBudgetContentDataProductBodyAbaProductsContentItem,
  RegisterBudgetContentDataProductBodyAbaProductsContentItemTitle,
  RegisterBudgetContentDataProductBodyAbaProductsEmpty,
  RegisterBudgetContentDataProductBodyAbaProductsLoading,
  RegisterBudgetContentDataProductBodyFooter,
  RegisterBudgetContentDataProductBodyFooterContent,
  RegisterBudgetContentDataProductBodyFooterContentDataTMK,
  RegisterBudgetContentDataProductBodyFooterContentDataTMKBody,
  RegisterBudgetContentDataProductBodyFooterContentDataTMKBodyContent,
  RegisterBudgetContentDataProductBodyFooterContentDataTMKBodyContentGrid,
  RegisterBudgetContentDataProductBodyFooterContentDataTMKBodyContentGridContent,
  RegisterBudgetContentDataProductBodyFooterContentDataTMKBodyContentGridContentCard,
  RegisterBudgetContentDataProductBodyFooterContentDataTMKBodyContentGridContentCardHeader,
  RegisterBudgetContentDataProductBodyFooterContentDataTMKBodyContentGridContentCardHeaderColumn,
  RegisterBudgetContentDataProductBodyFooterContentDataTMKBodyContentGridContentCardObs,
  RegisterBudgetContentDataProductBodyFooterContentDataTMKBodyContentGridContentCardObsHighlights,
  RegisterBudgetContentDataProductBodyFooterContentDataTMKBodyContentHeader,
  RegisterBudgetContentDataProductBodyFooterContentDataTMKBodyContentHeaderContent,
  RegisterBudgetContentDataProductBodyFooterContentDataTMKBodyContentHeaderContentField,
  RegisterBudgetContentDataProductBodyFooterContentDataTMKBodyContentRow,
  RegisterBudgetContentDataProductBodyFooterContentDataTMKBodyContentRowContent,
  RegisterBudgetContentDataProductBodyFooterContentDataTMKBodyContentRowContentButton,
  RegisterBudgetContentDataProductBodyFooterContentDataTMKBodyContentRowContentHighlight,
  RegisterBudgetContentDataProductBodyFooterContentDataTMKBodyContentRowContentInput,
  RegisterBudgetContentDataProductBodyFooterContentDataTMKBodyContentRowInformationPlus,
  RegisterBudgetContentDataProductBodyFooterContentDataTMKHeader,
  RegisterBudgetContentDataProductBodyFooterContentDataTMKHeaderTitle,
  RegisterBudgetContentDataProductControl,
  RegisterBudgetContentDataProductControlGrid,
  RegisterBudgetContentDataProductControlGridColumn,
  RegisterBudgetContentDataProductControlGridColumnItem,
  RegisterBudgetContentDataProductControlGridColumnItemLast,
  RegisterBudgetContentDataProductControlLoading,
  RegisterBudgetContentDataProductHeader,
  RegisterBudgetContentDataProductHeaderTitle,
  RegisterBudgetContentHeader,
  RegisterBudgetContentHeaderBudget,
  RegisterBudgetContentHeaderBudgetLinDiv,
  RegisterBudgetContentLoading,
  RegisterBudgetContentLoadingContent,
  RegisterBudgetContentProposal,
  RegisterBudgetContentProposalBody,
  RegisterBudgetContentProposalBodyContent,
  RegisterBudgetContentProposalBodyContentColumn,
  RegisterBudgetContentProposalBodyContentColumnField,
  RegisterBudgetContentProposalBodyContentColumnFunnel,
  RegisterBudgetContentProposalBodyContentColumnFunnelContent,
  RegisterBudgetContentProposalBodyContentColumnFunnelContentDetailsDivisor,
  RegisterBudgetContentProposalBodyContentColumnFunnelContentDetailsRow,
  RegisterBudgetContentProposalBodyContentColumnInfo,
  RegisterBudgetContentProposalBodyContentColumnInfoInputsObs,
  RegisterBudgetContentProposalBodyContentColumnInfoInputsObsTextarea,
  RegisterBudgetContentProposalBodyContentColumnInfoTextFixedWidth,
  RegisterBudgetContentProposalBodyContentColumnInfoTextHighlights,
  RegisterBudgetContentProposalBodyContentColumnLarge,
  RegisterBudgetContentProposalBodyContentColumnSelectFieldCustom,
  RegisterBudgetContentProposalBodyContentColumnSelectFieldField,
  RegisterBudgetContentProposalBodyContentColumnSelectFieldFieldArrow,
  RegisterBudgetContentProposalBodyContentColumnSelectFieldFieldBorderNone,
  RegisterBudgetContentProposalBodyContentColumnSelectFieldFieldSelect,
  RegisterBudgetContentProposalBodyContentColumnSelectFieldFieldText,
  RegisterBudgetContentProposalHeader,
  RegisterBudgetContentProposalHeaderTitle,
  RegisterBudgetModal,
  RegisterBudgetModalAbaProduto,
  RegisterBudgetModalContent,
  RegisterBudgetModalContentAbaProduto,
  RegisterBudgetModalContentDadosParceiro,
  RegisterBudgetModalContentDadosParceiroColumn,
  RegisterBudgetModalContentDadosParceiroColumnItem,
  RegisterBudgetModalContentDadosParceiroColumnSublinhado,
  RegisterBudgetModalContentDadosParceiroColumnSubtitle,
  RegisterBudgetModalContentDadosParceiroColumnTitle,
  RegisterBudgetModalContentDataGrid,
  RegisterBudgetModalContentDataGridControl,
  RegisterBudgetModalContentDataGridTable,
  RegisterBudgetModalContentDataProduct,
  RegisterBudgetModalContentDataProductCardImage,
  RegisterBudgetModalContentDataProductInfos,
  RegisterBudgetModalContentDataProductInfosLine,
  RegisterBudgetModalContentDataProductInfosLineBlock,
  RegisterBudgetModalContentDataProductInfosLineBlockNoneBgColor,
  RegisterBudgetModalContentDataProductInfosTitle,
  RegisterBudgetModalContentFilter,
  RegisterBudgetModalContentFilterParceiro,
  RegisterBudgetModalContentFilterProduct,
  RegisterBudgetModalContentFilterSelector,
  RegisterBudgetModalContentFooter,
  RegisterBudgetModalContentHeader,
  RegisterBudgetModalContentLayout,
  RegisterBudgetModalContentParceiro,
  RegisterBudgetModalContentProposta,
  RegisterBudgetModalContentPropostaButtonClose,
  RegisterBudgetModalContentPropostaCard,
  RegisterBudgetModalContentPropostaCardConfiguracaoItem,
  RegisterBudgetModalContentPropostaCardContainer,
  RegisterBudgetModalContentPropostaCardContainerObservacoes,
  RegisterBudgetModalContentPropostaCardContainerObservacoesCondicao,
  RegisterBudgetModalContentPropostaCardContainerObservacoesCondicaoData,
  RegisterBudgetModalContentPropostaCardContainerObservacoesCondicaoDataLarge,
  RegisterBudgetModalContentPropostaCardContainerObservacoesCondicaoDataMedium,
  RegisterBudgetModalContentPropostaCardContainerObservacoesCondicaoLarge,
  RegisterBudgetModalContentPropostaCardContainerObservacoesCondicaoTitle,
  RegisterBudgetModalContentPropostaCardContainerObservacoesTitle,
  RegisterBudgetModalContentPropostaCardContainerObservacoesValor,
  RegisterBudgetModalContentPropostaCardContent,
  RegisterBudgetModalContentPropostaCardContentDados,
  RegisterBudgetModalContentPropostaCardContentDadosDescricao,
  RegisterBudgetModalContentPropostaCardContentDadosDescricaoSubtitle,
  RegisterBudgetModalContentPropostaCardContentDadosDescricaoTitle,
  RegisterBudgetModalContentPropostaCardContentDadosDimensao,
  RegisterBudgetModalContentPropostaCardContentDadosDimensaoSubtitle,
  RegisterBudgetModalContentPropostaCardContentDadosDimensaoTitle,
  RegisterBudgetModalContentPropostaCardContentImageCard,
  RegisterBudgetModalContentPropostaCardContentTitle,
  RegisterBudgetModalContentPropostaClass,
  RegisterBudgetModalContentPropostaHeader,
  RegisterBudgetModalContentPropostaHeaderDataProp,
  RegisterBudgetModalContentPropostaHeaderNumeroProp,
  RegisterBudgetModalContentPropostaSubheader,
  RegisterBudgetModalContentPropostaSubheaderContent,
  RegisterBudgetModalContentPropostaSubheaderContentLine1,
  RegisterBudgetModalContentPropostaSubheaderContentLine2,
  RegisterBudgetModalContentPropostaSubheaderContentLine3,
  RegisterBudgetProdutoGridProdutos,
  RegisterBudgetProdutoGridProdutosCardProd,
  RegisterBudgetProdutoGridProdutosCardProdCores,
  RegisterBudgetProdutoGridProdutosCardProdCoresGridCores,
  RegisterBudgetProdutoGridProdutosCardProdCoresGridCoresContent,
  RegisterBudgetProdutoGridProdutosCardProdCoresGridCoresContentCor,
  RegisterBudgetProdutoGridProdutosCardProdCoresTitle,
  RegisterBudgetProdutoGridProdutosCardProdDesc,
  RegisterBudgetProdutoGridProdutosCardProdImageProd,
  RegisterBudgetProdutoGridProdutosCardProdValor,
  RegisterBudgetProdutoGridProdutosCardProdValorContent,
  RegisterBudgetProdutoGridProdutosProduto,
  RegisterBudgetProdutoGridProdutosProdutoBNTConferir,
  RegisterBudgetProdutoGridProdutosProdutoBNTConferirDisponivel,
  RegisterBudgetProdutoGridProdutosTitle,
  RegisterBudgetResume,
  RegisterBudgetResumeContent,
  RegisterBudgetResumeContentFilter,
  RegisterBudgetResumeContentFilterButton,
  RegisterBudgetResumeContentFilterButtonWhite,
  RegisterBudgetResumeContentFilterSelector,
  RegisterBudgetResumeContentFilterSelectorProduct,
  RegisterBudgetResumeContentModalFilterButton,
  RegisterBudgetResumeContentModalFilterButtonWhite,
  RegisterBudgetResumeContentSubtext,
  RegisterBudgetResumeLoading,
  RegisterBudgetResumeLoadingContent,
  SubtitleEnd,
} from "./styles";
import {
  Box,
  Button,
  Input,
  InputGroup,
  InputLeftAddon,
  LinkOverlay,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Select,
  useDisclosure,
} from "@chakra-ui/react";
import { BsArrowBarLeft } from "react-icons/bs";
import { ModalVisualizarProposta } from "./ModalVisualizarProposta";

const loading = "/images/loading-blue.gif";
const selorapido = "/images/table-mais-rapido.png";
const selobarato = "/images/table-mais-barato.png";
const clienteRetira = "/images/cliente-retira-banner.png";
const nossoCarro = "/images/nosso-carro-banner.png";
const selogratisverde = "/images/gratis.png";
const selogratislaranja = "/images/gratis-laranja.png";
const loadingBall = "/images/loading-three-ball.gif";
const images_frete = {
  "mais-rapido": selorapido,
  "mais-barato": selobarato,
  gratis: selogratisverde,
};
const letra = { 0: "A", 1: "B", 2: "C", 3: "D", 4: "E", 5: "F", 6: "G" };

const maisRapido = "/images/table-mais-rapido.png";
const maisBarato = "/images/table-mais-barato.png";

class CadastroOrcamento extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dados: [],
      listaDeEmpresa: [],
      items: [],
      boxproduto: [],
      produto_selecionado: [],
      cores_produto: [],
      gravacao_produto: [],
      batidas_produto: [],
      prazos_produto: [],
      dadosHistorico: [],
      funilVendas: [],
      motivo_perda: [],
      cores_embalagem: [],
      gravacao_embalagem: [],
      data_layout: [],
      opcao_selecionada: 0,
      cidade_cep: "São Paulo",
      funil_venda_selecionado: 0,
      estimativa_selecionada: 0,
      loading_adiciona_embalagem: { status: false, sequencia: 0 },
      loading_salvar_item: { status: false, sequencia: 0 },
      loading_busca_produto: false,
      loading_save_item: false,
      loading_tmk: false,
      quantidade_alterada: false,
      step_by_step: false,
      novo_produto_adicionado: { codigo_produto: null, alterado: false },
      codigo_impressao_embalagem_selecionada: null,
      codigo_cor_embalagem_selecionada: null,
      tipo_motivo_selecionado: null,
      data_retorno: null,
      descricao_tmk: null,
      prod_possui_emb: false,
      nova_proposta: false,
      view_visualizar_parceiro: false,
      view_data_customer: false,
      view_data_proposal: false,
      view_data_product: false,
      view_data_tmk: false,
      view_parceiros_modal: false,
      view_contatos_modal: false,
      view_condicao_modal: false,
      view_modal_layout: false,

      view_loading: false,
      codigo_proposta: null,
      codigo_usuario: JSON.parse(localStorage.getItem("authentication")).codigo_usuario,
      codigo_insert: parseInt(localStorage.getItem("codigo_insert")),
      codigo_vendedor: JSON.parse(localStorage.getItem("authentication")).codigo_vendedor,
    };
  }

  componentDidMount() {
    const queryParams = new URLSearchParams(window.location.search);

    const numero_proposta = queryParams.get("p");

    if (numero_proposta != null) {
      this.setState({ codigo_proposta: numero_proposta });
      this.filtrarProposta();
    }
    runVerificaAutenticacao();
    localStorage.removeItem("codigo_proposta");
    localStorage.removeItem("codigo_insert");
    this.getListaEmpresas();
  }

  getFunilVendas = async () => {
    try {
      const response = await ListaFunilDeVenda.post("", {});
      var data = response.data;

      this.setState({ funilVendas: data });
    } catch (error) {
      console.log(Object.keys(error), error.message);
    }
  };

  getMotivoPerda = async () => {
    try {
      const response = await ListaMotivoPerda.get();
      var data = response.data;

      this.setState({ motivo_perda: data });
    } catch (error) {
      console.log(Object.keys(error), error.message);
    }
  };

  getDadosHistorico = async () => {
    try {
      this.setState({ view_loading: true });
      const response = await ListaHistorico.post("", {
        numero_proposta: this.state.codigo_proposta,
      });
      var data = response.data;

      this.setState({ dadosHistorico: data, view_loading: false });
    } catch (error) {
      console.log(Object.keys(error), error.message);
    }
  };

  getDadosParceiros = async () => {
    try {
      const response = await dadosParceiro.get(
        this.state.dados.codigo_parceiro + "/" + this.state.dados.codigo_contato + "/" + this.state.codigo_proposta
      );
      var dados = response.data;

      await this.setState({ dados_parceiro: dados });
      this.getInformacoesEndereco();
    } catch (error) {
      console.log(Object.keys(error), error.message);
    }
  };

  getInformacoesEndereco = async (e) => {
    try {
      // var CEP_API = await fetch(`https://api.postmon.com.br/v1/cep/`+this.state.dados_parceiro.cep);
      var CEP_API = await fetch(`https://viacep.com.br/ws/${this.state.dados_parceiro.cep}/json/`);
      var CEP_API_REST = await CEP_API.json();

      var dados_parceiro = this.state.dados_parceiro;

      dados_parceiro.bairro = CEP_API_REST.bairro;
      dados_parceiro.municipio = CEP_API_REST.localidade;
      dados_parceiro.uf = CEP_API_REST.uf;
      dados_parceiro.logradouro = CEP_API_REST.logradouro;

      await this.setState({
        dados_parceiro: dados_parceiro,
      });
    } catch (error) {
      console.log(Object.keys(error), error.message);
    }
  };

  getListaEmpresas = async () => {
    try {
      const response = await ListaEmpresas.get();
      var data = response.data;

      this.setState({
        listaDeEmpresa: data,
        empresa_selecionada: data[0].codigo_empresa,
      });
    } catch (error) {
      console.log(Object.keys(error), error.message);
    }
  };

  getDadosProposta = async () => {
    try {
      var param = {
        codigo_proposta: parseInt(this.state.codigo_proposta),
        codigo_vendedor: parseInt(this.state.codigo_vendedor),
      };

      const response = await ListaDadosProposta.post("", param);
      var data = response.data;

      await this.setState({
        dados: data,
        estimativa_selecionada: data.estimativa_valor,
        empresa_selecionada: data.codigo_empresa,
        view_data_customer: true,
        view_data_proposal: true,
      });

      $("#selectEstimativa").val(data.estimativa_valor);
      $("#selectEmpresa").val(data.codigo_empresa);

      this.setState({ view_loading: false });
    } catch (error) {
      alert("Proposta não encontrada.");
      this.setState({ view_loading: false });
      console.log(Object.keys(error), error.message);
    }
  };

  getItens = async (obj = null) => {
    try {
      this.setState({ loading_busca_produto: true });

      var param = {
        codigo_proposta: this.state.codigo_proposta,
        codigo_vendedor: "",
      };
      const response = await ListaItensPropostas.post("", param);
      var data = response.data;

      var combobox_produto = [];
      data.map((dados) => {
        if (dados.tipo_produto != "EMB") {
          var split_data = dados.url_seo.split("-");
          split_data.pop();
          var url = split_data.join("-");
          var img =
            "https://innovationbrindes.com.br/images/produtos/" +
            dados.referencia.toString().substr(dados.referencia.length - 4) +
            "/" +
            url +
            "-1-1.jpg";

          combobox_produto.push({
            codigo_produto: dados.codigo_produto,
            nome_produto: dados.nome_produto,
            referencia: dados.referencia,
            descricao: dados.descricao,
            dimensoes: dados.dimensao,
            img: img,
          });
        }

        console.log(combobox_produto);
      });

      var dadosCombobox = combobox_produto.filter((data, index) => {
        const _data = JSON.stringify(data);
        return (
          index ===
          combobox_produto.findIndex((obj) => {
            return JSON.stringify(obj) === _data;
          })
        );
      });

      if (data.length < 1) {
        this.setState({ loading_busca_produto: false });
      }

      await this.setState({ items: data, boxproduto: dadosCombobox });
      this.setState({
        loading_salvar_item: { status: false, sequencia: 0 },
      });
      // console.log("LOG");

      this.state.items.map((item) => {
        item.item_carregado = true;
        item.item_salvo = true;
        if (item.token_embalagem != null && item.tipo_produto == "PROD") {
          // console.log(item);
          this.state.items.map(async (obj) => {
            if (obj.token_embalagem == item.token_embalagem && obj.tipo_produto == "EMB") {
              // console.log(obj);
              const response = await ListaConfigEmbalagem.post("", {
                codigo_produto: obj.codigo_produto,
                quantidade: item.qtd_negociada,
                prazo: item.id_prazo_entrega,
              });
              var result = response.data;

              const dadosEmbalagem = await ListaConfigProdutos.get(result[0].codigo_produto);
              var dados_embalagem = dadosEmbalagem.data;

              var tipo = [];
              var cores = [];
              result.map((data) => {
                tipo.push({
                  codigo_impressao: data.codigo_impressao,
                  descricao_impressao: data.descricao,
                });
                cores.push({
                  codigo_cor: data.codigo_cor,
                  descricao_cor: data.nome_cor,
                  imagem_box: data.imagem_box,
                  imagem_print: data.imagem_print,
                  imagem_plus: data.imagem_plus,
                });

                dados_embalagem.valor_total = parseFloat(data.CubagemTotal);
                dados_embalagem.valor_unitario = parseFloat(data.CubagemUnitaria);
              });

              var tipoUniqueArray = tipo.filter((tip, index) => {
                const _tip = JSON.stringify(tip);
                return (
                  index ===
                  tipo.findIndex((obj) => {
                    return JSON.stringify(obj) === _tip;
                  })
                );
              });

              var corUniqueArray = cores.filter((cor, index) => {
                const _cor = JSON.stringify(cor);
                return (
                  index ===
                  cores.findIndex((obj) => {
                    return JSON.stringify(obj) === _cor;
                  })
                );
              });

              tipo = tipoUniqueArray;
              cores = corUniqueArray;
              var cubagem = result[0];

              var valor_por_tipo = await this.getInfosEmbalagem(obj);
              tipo.map((tip, idx) => {
                tip.valor = valor_por_tipo.valores_embalagem[idx];
              });

              item.cores_embalagem = cores;
              item.gravacao_embalagem = tipo;

              cores.map((data) => {
                if (data.codigo_cor == obj.id_cor) {
                  item.codigo_cor_embalagem_selecionada = data;
                }
              });
              tipo.map((data) => {
                if (data.codigo_impressao == obj.id_impressao) {
                  item.codigo_impressao_embalagem_selecionada = data;
                }
              });

              item.cubagem_embalagem = cubagem;
              item.dados_embalagem = dados_embalagem;

              await this.setState({ update: true });
            }
          });
        }
      });
      this.setState({ loading_busca_produto: false });
      this.setState({
        loading_salvar_item: { status: false, sequencia: 0 },
      });
    } catch (error) {
      this.setState({ loading_busca_produto: false });
      this.setState({
        loading_salvar_item: { status: false, sequencia: 0 },
      });
      console.log(error);
      // console.log(Object.keys(error), error.message);
    }
  };

  FecharModalParceiro = async () => {
    this.setState({ view_parceiros_modal: false });
  };

  selecionaParceiro = async (e) => {
    var data = JSON.parse(e.target.value);
    this.setState({
      dados: data,
      view_parceiros_modal: false,
      view_contatos_modal: true,
    });
  };

  FecharModalContato = async () => {
    this.setState({ view_contatos_modal: false });
  };

  selecionaContato = async (e) => {
    // delete this.state.dados_proposta.codigo_contato;
    delete this.state.dados.nome_contato;
    delete this.state.dados.email_contato;
    delete this.state.dados.telefone_contato;
    delete this.state.dados.celular_contato;

    var dados = Object.assign(JSON.parse(e.target.value), this.state.dados);

    this.setState({
      dados: dados,
      view_contatos_modal: false,
      view_data_proposal: true,
    });
  };

  FecharModalCondicao = async () => {
    this.setState({ view_condicao_modal: false });
  };

  selecionaCondicao = async (e) => {
    delete this.state.dados.codigo_tipo_venda;
    delete this.state.dados.condicao_pagamento;

    var dados = Object.assign(JSON.parse(e.target.value), this.state.dados);
    this.setState({
      dados: dados,
      view_condicao_modal: false,
    });
  };

  selectEstimativa = async (e) => {
    this.setState({
      estimativa_selecionada: e.target.options[e.target.options.selectedIndex].value,
    });
  };

  selectEmpresa = async (e) => {
    this.setState({
      empresa_selecionada: e.target.options[e.target.options.selectedIndex].value,
    });
  };

  FecharModalTotalPedido = async () => {
    this.setState({ view_total_pedidos_modal: false });
  };

  fecharModalProduto = async () => {
    this.setState({ view_lista_produtos_modal: false });
  };

  FecharModalVisualizarParceiro = async () => {
    this.setState({ view_visualizar_parceiro: false });
  };

  filtrarProposta = async () => {
    await this.setState({ view_loading: true });
    localStorage.setItem("codigo_proposta", this.state.codigo_proposta);
    localStorage.setItem("codigo_insert", this.state.codigo_insert);
    await this.getDadosProposta();
  };

  visualizarDadosParceiro = async () => {
    this.setState({ view_visualizar_parceiro: true });
  };

  AbrirItensPropostas = async () => {
    await this.setState({
      view_data_product: !this.state.view_data_product,
      count_config: 0,
    });

    if (this.state.view_data_product) {
      await this.getItens();
      this.state.boxproduto.map((data) => {
        var count = 0;
        this.state.items.map((item, idx) => {
          if (data.codigo_produto == item.codigo_produto && item.tipo_produto == "PROD") {
            item.num_order = count;
            count++;
          }
        });
      });
    } else {
      this.setState({
        items: [],
        boxproduto: [],
        produto_selecionado: [],
        cores_produto: [],
        gravacao_produto: [],
        batidas_produto: [],
        prazos_produto: [],
      });
    }

    if (this.state.view_data_product && this.state.boxproduto.length == 0) {
      this.setState({ view_lista_produtos_modal: true });
    }
  };

  AbrirHistoricoTMK = async () => {
    this.getFunilVendas();
    this.getMotivoPerda();
    await this.getDadosHistorico();
    this.setState({ view_data_tmk: !this.state.view_data_tmk });
  };

  novaProposta = async () => {
    // localStorage.setItem("codigo_proposta","");
    await this.setState({
      nova_proposta: true,
      dados: [],
      items: [],
    });
    await this.setState({ view_data_customer: true });
    this.setState({ view_parceiros_modal: true });
  };

  changeInputField = async (e, value) => {
    this.setState({ [value]: e.target.value });
    if (e.key == "Enter") {
      this.filtrarProposta();
    }
  };

  changePasso = async (e, value, type) => {
    if (type == "select") {
      var option = e.target.options[e.target.options.selectedIndex].value.replace("R$ ", "");
    } else {
      var option = e.target.value.replace("R$ ", "");
    }

    var item = JSON.parse(fromBase64(e.target.attributes.data.value));

    option = option == "" ? "0" : option;

    this.state.items.map(async (data) => {
      if (parseInt(data.codigo_produto) == parseInt(item.codigo_produto) && data.sequencia == item.sequencia) {
        eval("data." + value + " = option");
        data.frete_site = null;
        data.item_carregado = false;
        data.item_salvo = false;
        this.setState({ update: true });
      }
    });

    if (
      value != "qtd_negociada" &&
      value != "valor_unitario" &&
      value != "cep_selecionado" &&
      value != "cif_fob" &&
      this.state.novo_produto_adicionado.codigo_produto != this.state.produto_selecionado.codigo_produto
    ) {
      await this.gerarPrecoBase(null, item);
    }

    if (
      value != "qtd_negociada" &&
      value != "valor_unitario" &&
      value != "cep_selecionado" &&
      value != "cif_fob" &&
      this.state.quantidade_alterada
    ) {
      // console.log("entrou na lista");
      await this.gerarPrecoBase(null, item);
    }

    if (this.state.step_by_step && value != "qtd_negociada") {
      this.validaStepByStep(value);
    }

    if (value == "qtd_negociada") {
      var corprod = this.state.produto_selecionado.codigo_produto;
      var order = this.state.opcao_selecionada;
      document.getElementById("base-brinde-title-" + corprod + "-" + order).style.transition = "0.3s";
      document.getElementById("base-brinde-title-" + corprod + "-" + order).style.transform = "scale(0.80,0.80)";
      document.getElementById("base-brinde-title-" + corprod + "-" + order).style.opacity = "0.7";

      document.getElementById("base-brinde-field-" + corprod + "-" + order).style.transition = "0.3s";
      document.getElementById("base-brinde-field-" + corprod + "-" + order).style.transform = "scale(0.80,0.80)";
      document.getElementById("base-brinde-field-" + corprod + "-" + order).style.opacity = "0.7";

      document.getElementById("preco-brinde-title-" + corprod + "-" + order).style.transition = "0.3s";
      document.getElementById("preco-brinde-title-" + corprod + "-" + order).style.transform = "scale(0.80,0.80)";
      document.getElementById("preco-brinde-title-" + corprod + "-" + order).style.opacity = "0.7";

      document.getElementById("preco-brinde-field-" + corprod + "-" + order).style.transition = "0.3s";
      document.getElementById("preco-brinde-field-" + corprod + "-" + order).style.transform = "scale(0.80,0.80)";
      document.getElementById("preco-brinde-field-" + corprod + "-" + order).style.opacity = "0.7";

      document.getElementById("unit-brinde-title-" + corprod + "-" + order).style.transition = "0.3s";
      document.getElementById("unit-brinde-title-" + corprod + "-" + order).style.transform = "scale(0.80,0.80)";
      document.getElementById("unit-brinde-title-" + corprod + "-" + order).style.opacity = "0.7";

      document.getElementById("unit-brinde-field-" + corprod + "-" + order).style.transition = "0.3s";
      document.getElementById("unit-brinde-field-" + corprod + "-" + order).style.transform = "scale(0.80,0.80)";
      document.getElementById("unit-brinde-field-" + corprod + "-" + order).style.opacity = "0.7";
      document.getElementById("unit-brinde-field-" + corprod + "-" + order).children[0].disabled = false;

      document.getElementById("total-brinde-title-" + corprod + "-" + order).style.transition = "0.3s";
      document.getElementById("total-brinde-title-" + corprod + "-" + order).style.transform = "scale(0.80,0.80)";
      document.getElementById("total-brinde-title-" + corprod + "-" + order).style.opacity = "0.7";

      document.getElementById("total-brinde-field-" + corprod + "-" + order).style.transition = "0.3s";
      document.getElementById("total-brinde-field-" + corprod + "-" + order).style.transform = "scale(0.80,0.80)";
      document.getElementById("total-brinde-field-" + corprod + "-" + order).style.opacity = "0.7";

      // console.log($("button#quantidade-brinde-field-"+corprod+"-"+order)[0]);

      $("button#quantidade-brinde-field-" + corprod + "-" + order)[0].style.transition = "0.4s";
      $("button#quantidade-brinde-field-" + corprod + "-" + order)[0].style.transform = "scale(1.6,1.6)";
      $("button#quantidade-brinde-field-" + corprod + "-" + order)[0].style.boxShadow =
        "2px 2px 15px 2px rgb(0,0,0,0.4)";
    }
  };

  validaStepByStep = async (value) => {
    var corprod = this.state.produto_selecionado.codigo_produto;
    var order = this.state.opcao_selecionada;

    if (this.state.produto_selecionado.codigo_produto == this.state.novo_produto_adicionado.codigo_produto) {
      if (value == "id_cor") {
        document.getElementById("gravacao-brinde-title-" + corprod + "-" + order).style.transition = "0.3s";
        document.getElementById("gravacao-brinde-title-" + corprod + "-" + order).style.transform = "scale(1,1)";
        document.getElementById("gravacao-brinde-title-" + corprod + "-" + order).style.opacity = "1";

        document.getElementById("gravacao-brinde-field-" + corprod + "-" + order).style.transition = "0.3s";
        document.getElementById("gravacao-brinde-field-" + corprod + "-" + order).style.transform = "scale(1,1)";
        document.getElementById("gravacao-brinde-field-" + corprod + "-" + order).style.opacity = "1";
        document.getElementById("gravacao-brinde-field-" + corprod + "-" + order).children[0].disabled = false;
      } else if (value == "id_impressao") {
        document.getElementById("impressao-brinde-title-" + corprod + "-" + order).style.transition = "0.3s";
        document.getElementById("impressao-brinde-title-" + corprod + "-" + order).style.transform = "scale(1,1)";
        document.getElementById("impressao-brinde-title-" + corprod + "-" + order).style.opacity = "1";

        document.getElementById("impressao-brinde-field-" + corprod + "-" + order).style.transition = "0.3s";
        document.getElementById("impressao-brinde-field-" + corprod + "-" + order).style.transform = "scale(1,1)";
        document.getElementById("impressao-brinde-field-" + corprod + "-" + order).style.opacity = "1";
        document.getElementById("impressao-brinde-field-" + corprod + "-" + order).children[0].disabled = false;
      } else if (value == "qtd_batida") {
        document.getElementById("prazo-brinde-title-" + corprod + "-" + order).style.transition = "0.3s";
        document.getElementById("prazo-brinde-title-" + corprod + "-" + order).style.transform = "scale(1,1)";
        document.getElementById("prazo-brinde-title-" + corprod + "-" + order).style.opacity = "1";

        document.getElementById("prazo-brinde-field-" + corprod + "-" + order).style.transition = "0.3s";
        document.getElementById("prazo-brinde-field-" + corprod + "-" + order).style.transform = "scale(1,1)";
        document.getElementById("prazo-brinde-field-" + corprod + "-" + order).style.opacity = "1";
        document.getElementById("prazo-brinde-field-" + corprod + "-" + order).children[0].disabled = false;
      } else if (value == "id_prazo_entrega") {
        document.getElementById("quantidade-brinde-title-" + corprod + "-" + order).style.transition = "0.3s";
        document.getElementById("quantidade-brinde-title-" + corprod + "-" + order).style.transform = "scale(1,1)";
        document.getElementById("quantidade-brinde-title-" + corprod + "-" + order).style.opacity = "1";

        document.getElementById("quantidade-brinde-field-" + corprod + "-" + order).style.transition = "0.3s";
        document.getElementById("quantidade-brinde-field-" + corprod + "-" + order).style.transform = "scale(1,1)";
        document.getElementById("quantidade-brinde-field-" + corprod + "-" + order).style.opacity = "1";
        document.getElementById("quantidade-brinde-field-" + corprod + "-" + order).children[0].disabled = false;
        document.getElementById("quantidade-brinde-field-" + corprod + "-" + order).children[1].disabled = false;
      } else if (value == "qtd_negociada") {
        console.log(value + " valid");
        document.getElementById("base-brinde-title-" + corprod + "-" + order).style.transition = "0.3s";
        document.getElementById("base-brinde-title-" + corprod + "-" + order).style.transform = "scale(1,1)";
        document.getElementById("base-brinde-title-" + corprod + "-" + order).style.opacity = "1";

        document.getElementById("base-brinde-field-" + corprod + "-" + order).style.transition = "0.3s";
        document.getElementById("base-brinde-field-" + corprod + "-" + order).style.transform = "scale(1,1)";
        document.getElementById("base-brinde-field-" + corprod + "-" + order).style.opacity = "1";

        document.getElementById("preco-brinde-title-" + corprod + "-" + order).style.transition = "0.3s";
        document.getElementById("preco-brinde-title-" + corprod + "-" + order).style.transform = "scale(1,1)";
        document.getElementById("preco-brinde-title-" + corprod + "-" + order).style.opacity = "1";

        document.getElementById("preco-brinde-field-" + corprod + "-" + order).style.transition = "0.3s";
        document.getElementById("preco-brinde-field-" + corprod + "-" + order).style.transform = "scale(1,1)";
        document.getElementById("preco-brinde-field-" + corprod + "-" + order).style.opacity = "1";

        document.getElementById("unit-brinde-title-" + corprod + "-" + order).style.transition = "0.3s";
        document.getElementById("unit-brinde-title-" + corprod + "-" + order).style.transform = "scale(1,1)";
        document.getElementById("unit-brinde-title-" + corprod + "-" + order).style.opacity = "1";

        document.getElementById("unit-brinde-field-" + corprod + "-" + order).style.transition = "0.3s";
        document.getElementById("unit-brinde-field-" + corprod + "-" + order).style.transform = "scale(1,1)";
        document.getElementById("unit-brinde-field-" + corprod + "-" + order).style.opacity = "1";
        document.getElementById("unit-brinde-field-" + corprod + "-" + order).children[0].disabled = false;

        document.getElementById("total-brinde-title-" + corprod + "-" + order).style.transition = "0.3s";
        document.getElementById("total-brinde-title-" + corprod + "-" + order).style.transform = "scale(1,1)";
        document.getElementById("total-brinde-title-" + corprod + "-" + order).style.opacity = "1";

        document.getElementById("total-brinde-field-" + corprod + "-" + order).style.transition = "0.3s";
        document.getElementById("total-brinde-field-" + corprod + "-" + order).style.transform = "scale(1,1)";
        document.getElementById("total-brinde-field-" + corprod + "-" + order).style.opacity = "1";
      } else {
        console.log("else");
      }
    }
  };

  selecionaProduto = async (e, type = "element") => {
    if (type == "element") {
      var data = JSON.parse(fromBase64(e.target.attributes.data.value));
    } else if (type == "object") {
      console.log([e, type]);
      var data = e;
    }

    if (this.state.produto_selecionado != []) {
      if (data.codigo_produto == this.state.produto_selecionado.codigo_produto) {
        await this.setState({
          produto_selecionado: [],
          opcao_selecionada: 0,
        });
      } else {
        const response = await ListaConfigProdutos.get(data.codigo_produto);
        var result = response.data;
        if (result.ad_embalagem != "" && result.ad_embalagem != null && result.ad_embalagem != undefined) {
          data.ad_embalagem = result.ad_embalagem;
          await this.setState({
            prod_possui_emb: true,
            opcao_selecionada: 0,
          });
        } else {
          data.ad_embalagem = null;
          await this.setState({
            prod_possui_emb: false,
            opcao_selecionada: 0,
          });
        }

        await this.setState({
          produto_selecionado: data,
          opcao_selecionada: 0,
        });
        await this.selectProduto(data.codigo_produto);
      }
    } else {
      const response = await ListaConfigProdutos.get(data.codigo_produto);
      var result = response.data;
      if (result.ad_embalagem != "" && result.ad_embalagem != null && result.ad_embalagem != undefined) {
        data.ad_embalagem = result.ad_embalagem;
        await this.setState({
          prod_possui_emb: true,
          opcao_selecionada: 0,
        });
      } else {
        data.ad_embalagem = null;
        await this.setState({
          prod_possui_emb: false,
          opcao_selecionada: 0,
        });
      }

      await this.setState({
        produto_selecionado: data,
        opcao_selecionada: 0,
      });
      await this.selectProduto(data.codigo_produto);
    }

    if (this.state.novo_produto_adicionado.codigo_produto != this.state.produto_selecionado.codigo_produto) {
      this.state.novo_produto_adicionado.alterado = true;
      this.setState({ update: true });
    }
    if (this.state.step_by_step && !this.state.novo_produto_adicionado.alterado) {
      await this.initialStepByStep();
    }
  };

  selecionaNovoProduto = async (cod_prod) => {
    try {
      this.setState({ loading_busca_produto: true });
      this.fecharModalProduto();

      const response = await buscaInfoProdSelecionado.post("", {
        codigo_produto: cod_prod.toString().substr(cod_prod.length - 4),
        quantidade: null,
      });
      var data = response.data;

      var produto_config = {
        numero_nota: "",
        sequencia: this.state.items.length + 1,
        codigo_produto: data.codigo_produto,
        referencia: data.referencia,
        nome_produto: data.nome_produto,
        descricao: data.descricao,
        caracteristicas: data.caracteristicas,
        dimensao: data.dimensao,
        url_seo: data.url_seo,
        qtd_imagem: data.qtd_imagem,
        id_prazo_entrega: "10",
        qtd_batida: data.Batidas,
        negocped: "",
        status_produto_aprovacao: "",
        id_cor: data.IDCORES,
        descricao_cor: "",
        descricao_impressao: "",
        id_impressao: data.CodigoImpressao,
        descricao_formato: "",
        descricao_material: "",
        descricao_acabamento: "",
        descricao_borda: "",
        descricao_extra: "",
        descricao_corte: "",
        observacao: "",
        informacao_estoque: data.informacoes_estoque,
        qtd_negociada: data.QuantidadeProduto,
        data_alteracao_preco_fornecedor: data.dtalterprecofornec,
        preco_base: data.preco_home,
        valor_unitario: data.preco_home,
        preco_loja: data.preco_home,
        valor_frete: 0,
        valor_total: data.ValorTotalVenda,
        perccom: "",
        valor_comis: "",
        valor_dif20: "",
        dimensao_caixa: data.Caixa,
        valor_cubagem_total: "",
        valor_cubagem_unitario: "",
        qtd_caixa: "",
        qtd_por_caixa: "",
        nao_exibe_proposta: "N",
        utiliza_preco_site: "N",
        tipo_produto: "PROD",
        Altura: data.Altura,
        Caixa: data.Caixa,
        Comprimento: data.Comprimento,
        CubagemTotal: data.CubagemTotal,
        CubagemUnitaria: data.CubagemUnitaria,
        Largura: data.Largura,
        PesoCaixa: data.PesoCaixa,
        QtdCaixa: data.QtdCaixa,
        QtdPorCaixa: data.QtdPorCaixa,
        num_order: 0,
      };

      var produtos = this.state.items;
      produtos.push(produto_config);

      produtos.sort(function (a, b) {
        if (parseInt(a.codigo_produto) < parseInt(b.codigo_produto)) {
          return -1;
        } else {
          return 1;
        }
      });

      var combobox_produto = [];
      produtos.map((dados) => {
        if (combobox_produto.length == 0 && dados.tipo_produto != "EMB") {
          var split_data = dados.url_seo.split("-");
          split_data.pop();
          var url = split_data.join("-");
          var img =
            "https://innovationbrindes.com.br/images/produtos/" +
            dados.referencia.toString().substr(dados.referencia.length - 4) +
            "/" +
            url +
            "-1-1.jpg";

          combobox_produto.push({
            codigo_produto: dados.codigo_produto,
            nome_produto: dados.nome_produto,
            referencia: dados.referencia,
            descricao: dados.descricao,
            dimensoes: dados.dimensao,
            img: img,
          });
        } else if (
          combobox_produto[combobox_produto.length - 1].codigo_produto != dados.codigo_produto &&
          dados.tipo_produto != "EMB"
        ) {
          var split_data = dados.url_seo.split("-");
          split_data.pop();
          var url = split_data.join("-");
          var img =
            "https://innovationbrindes.com.br/images/produtos/" +
            dados.referencia.toString().substr(dados.referencia.length - 4) +
            "/" +
            url +
            "-1-1.jpg";

          combobox_produto.push({
            codigo_produto: dados.codigo_produto,
            nome_produto: dados.nome_produto,
            referencia: dados.referencia,
            descricao: dados.descricao,
            dimensoes: dados.dimensao,
            img: img,
          });
        }
      });

      await this.setState({ items: produtos });
      this.setState({ loading_busca_produto: false });

      var prod_selecionado = [];
      this.state.items.map((data) => {
        if (parseInt(data.codigo_produto) == parseInt(data.codigo_produto)) {
          prod_selecionado.push(data);
        }
      });

      this.state.items.map(async (data) => {
        await this.gerarPrecoBase(null, data);
      });

      var split_data = prod_selecionado[0].url_seo.split("-");
      split_data.pop();
      var url = split_data.join("-");
      var img =
        "https://innovationbrindes.com.br/images/produtos/" +
        prod_selecionado[0].referencia.toString().substr(prod_selecionado[0].referencia.length - 4) +
        "/" +
        url +
        "-1-1.jpg";

      const responseCor = await ListaConfigProdutos.get(
        prod_selecionado[0].referencia.toString().substr(prod_selecionado[0].referencia.length - 4) +
          "/cores-disponiveis"
      );
      var dataCor = responseCor.data;

      const responseGravacao = await ListaConfigProdutos.get(
        prod_selecionado[0].referencia.toString().substr(prod_selecionado[0].referencia.length - 4) + "/tipo-gravacao"
      );
      var dataGravacao = responseGravacao.data;

      const responseProd = await ListaConfigProdutos.get(
        prod_selecionado[0].referencia.toString().substr(prod_selecionado[0].referencia.length - 4)
      );
      var dataProd = responseProd.data;

      var batidas = [];
      var cont = 1;
      while (parseInt(dataProd.batidadas_maximas) >= cont) {
        batidas.push(cont);
        cont++;
      }

      var prazos = [];
      [1, 3, 5, 7, 10].map((data) => {
        if (data >= parseInt(dataProd.prazo_minimo_entrega)) {
          if (data == 1) {
            prazos.push({ codigo: data, descricao: "1 DIA" });
          } else {
            prazos.push({
              codigo: data,
              descricao: data + " DIAS",
            });
          }
        }
      });

      await this.setState({
        cores_produto: dataCor,
        gravacao_produto: dataGravacao,
        batidas_produto: batidas,
        prazos_produto: prazos,
        img_produto: img,
      });

      this.state.items.map((item) => {
        if (item.codigo_produto == data.codigo_produto) {
          this.state.cores_produto.map((cor) => {
            if (parseInt(cor.codigo_cor) == parseInt(item.id_cor)) {
              item.descricao_cor = cor.descricao_cor;
            }
          });
          this.state.gravacao_produto.map((imp) => {
            if (parseInt(imp.codigo_impressao) == parseInt(item.id_impressao)) {
              item.descricao_impressao = imp.descricao_site;
            }
          });
        }
      });

      var objitem = [];
      this.state.items.map(async (item) => {
        if (item.codigo_produto == data.codigo_produto) {
          await this.selecionaProduto(item, "object");
        }
      });

      await this.setState({ boxproduto: combobox_produto });

      await this.setState({
        step_by_step: true,
        loading_busca_produto: false,
        update: true,
        quantidade_alterada: false,
      });
      await this.setState({
        novo_produto_adicionado: {
          codigo_produto: produto_config.codigo_produto,
          alterado: false,
        },
      });

      this.state.items.map((item) => {
        document.querySelectorAll("#cor-brinde-field-" + item.codigo_produto + "-" + item.num_order)[1].value =
          item.id_cor;
        document.querySelectorAll("#gravacao-brinde-field-" + item.codigo_produto + "-" + item.num_order)[1].value =
          item.id_impressao;
        document.querySelectorAll("#impressao-brinde-field-" + item.codigo_produto + "-" + item.num_order)[1].value =
          item.qtd_batida;
        document.querySelectorAll("#prazo-brinde-field-" + item.codigo_produto + "-" + item.num_order)[1].value =
          item.id_prazo_entrega;
        document.querySelectorAll("#cif-fob-" + item.codigo_produto + "-" + item.num_order)[0].value = item.cif_fob;
      });
    } catch (error) {
      this.setState({ loading_busca_produto: false });
      console.log(Object.keys(error), error.message);
    }
  };

  sleep(milliseconds) {
    var start = new Date().getTime();
    for (var i = 0; i < 1e7; i++) {
      if (new Date().getTime() - start > milliseconds) {
        break;
      }
    }
  }

  duplicarProduto = async (e) => {
    var data = JSON.parse(fromBase64(e.target.attributes.data.value));

    var sequencia = parseInt(this.state.items.length) + 1;

    var rand = function () {
      return Math.random().toString(36).substr(2); // remove `0.`
    };

    var token = rand() + rand();

    var produto_config = data;
    produto_config.sequencia = sequencia;

    if (data.dados_embalagem != undefined) {
      produto_config.token_embalagem = token;
      produto_config.codigo_cor_embalagem_selecionada = data.codigo_cor_embalagem_selecionada;
      produto_config.codigo_impressao_embalagem_selecionada = data.codigo_impressao_embalagem_selecionada;
      produto_config.cores_embalagem = data.cores_embalagem;
      produto_config.cubagem_embalagem = data.cubagem_embalagem;
      produto_config.dados_embalagem = data.dados_embalagem;
      produto_config.gravacao_embalagem = data.gravacao_embalagem;
    } else {
      produto_config.token_embalagem = null;
    }

    if (data.cep_selecionado != undefined) {
      produto_config.cep_selecionado = data.cep_selecionado;
      produto_config.cidade = data.cidade;
      produto_config.endereco_selecionado = data.endereco_selecionado;
      produto_config.cotacao_frete = data.cotacao_frete;
    }
    if (data.frete_selecionado != undefined) {
      produto_config.frete_selecionado = data.frete_selecionado;
      produto_config.config_frete = data.config_frete;
    }

    if (data.frete_site != undefined) {
      produto_config.frete_site = data.frete_site;
    }

    produto_config.item_carregado = true;
    produto_config.item_salvo = false;

    this.setState({
      opcao_selecionada: parseInt(produto_config.num_order) + 1,
    });

    var produtos = this.state.items;
    produtos.push(produto_config);
    // console.log(produtos)
    await this.setState({ items: produtos });

    this.state.boxproduto.map((data) => {
      var count = 0;
      this.state.items.map((item, idx) => {
        if (data.codigo_produto == item.codigo_produto && item.tipo_produto == "PROD") {
          item.num_order = count;
          count++;
        }
      });
    });

    // this.sleep(1000);

    await this.setState({ update: true });
    this.state.items.map((item) => {
      if (parseInt(item.codigo_produto) == parseInt(data.codigo_produto)) {
        document.querySelectorAll("#cor-brinde-field-" + item.codigo_produto + "-" + item.num_order)[1].value =
          item.id_cor;
        document.querySelectorAll("#gravacao-brinde-field-" + item.codigo_produto + "-" + item.num_order)[1].value =
          item.id_impressao;
        document.querySelectorAll("#impressao-brinde-field-" + item.codigo_produto + "-" + item.num_order)[1].value =
          item.qtd_batida;
        document.querySelectorAll("#prazo-brinde-field-" + item.codigo_produto + "-" + item.num_order)[1].value =
          item.id_prazo_entrega;
        document.querySelectorAll("#cif-fob-" + item.codigo_produto + "-" + item.num_order)[0].value = item.cif_fob;
      }
    });
  };

  selectProduto = async (codigo_produto) => {
    this.setState({ view_loading: true });
    var option = codigo_produto;
    var prod_selecionado = [];

    this.state.items.map((data) => {
      if (parseInt(data.codigo_produto) == parseInt(option)) {
        prod_selecionado.push(data);
      }
    });

    var split_data = prod_selecionado[0].url_seo.split("-");
    split_data.pop();
    var url = split_data.join("-");
    var img =
      "https://innovationbrindes.com.br/images/produtos/" +
      prod_selecionado[0].referencia.toString().substr(prod_selecionado[0].referencia.length - 4) +
      "/" +
      url +
      "-1-1.jpg";

    const responseCor = await ListaConfigProdutos.get(
      prod_selecionado[0].referencia.toString().substr(prod_selecionado[0].referencia.length - 4) + "/cores-disponiveis"
    );
    var dataCor = responseCor.data;

    const responseGravacao = await ListaConfigProdutos.get(
      prod_selecionado[0].referencia.toString().substr(prod_selecionado[0].referencia.length - 4) + "/tipo-gravacao"
    );
    var dataGravacao = responseGravacao.data;

    const responseProd = await ListaConfigProdutos.get(
      prod_selecionado[0].referencia.toString().substr(prod_selecionado[0].referencia.length - 4)
    );
    var dataProd = responseProd.data;

    var batidas = [];
    var cont = 1;
    while (parseInt(dataProd.batidadas_maximas) >= cont) {
      batidas.push(cont);
      cont++;
    }

    var prazos = [];
    [1, 3, 5, 7, 10].map((data) => {
      if (data >= parseInt(dataProd.prazo_minimo_entrega)) {
        if (data == 1) {
          prazos.push({ codigo: data, descricao: "1 DIA" });
        } else {
          prazos.push({ codigo: data, descricao: data + " DIAS" });
        }
      }
    });

    await this.setState({
      cores_produto: dataCor,
      gravacao_produto: dataGravacao,
      batidas_produto: batidas,
      prazos_produto: prazos,
    });

    this.state.items.map((item) => {
      if (parseInt(item.codigo_produto) == parseInt(codigo_produto)) {
        document.querySelectorAll("#cor-brinde-field-" + item.codigo_produto + "-" + item.num_order)[1].value =
          item.id_cor;
        document.querySelectorAll("#gravacao-brinde-field-" + item.codigo_produto + "-" + item.num_order)[1].value =
          item.id_impressao;
        document.querySelectorAll("#impressao-brinde-field-" + item.codigo_produto + "-" + item.num_order)[1].value =
          item.qtd_batida;
        document.querySelectorAll("#prazo-brinde-field-" + item.codigo_produto + "-" + item.num_order)[1].value =
          item.id_prazo_entrega;
        document.querySelectorAll("#cif-fob-" + item.codigo_produto + "-" + item.num_order)[0].value = item.cif_fob;
      }
    });
  };

  changeObs = async (e, value) => {
    if (value == "observacao") {
      this.state.dados.observacao = e.target.value;
    } else if (value == "observacao_cliente") {
      this.state.dados.observacao_cliente = e.target.value;
    } else if (value == "detalhe_proposta") {
      this.state.dados.detalhe_proposta = e.target.value;
    }

    this.setState({ update: true });
  };

  ifnull(a, b) {
    if (a == undefined || a == null || a == "") {
      return b;
    } else {
      return a;
    }
  }

  salvarCabecalho = async () => {
    try {
      this.setState({ view_loading_save: true });
      var param = {
        sequencia: "0",
        codigo_parceiro: this.ifnull(this.state.dados.codigo_parceiro, ""),
        observacao_cliente: this.ifnull(this.state.dados.observacao_cliente, ""),
        codigo_produto: "",
        quantidade_negociada: "",
        valor_unitario: "",
        valor_total: "",
        preco_base: "",
        id_impressao: "",
        id_cor: "",
        id_prazo_entrega: "",
        qtd_batidas: "",
        frete_site: "",
        numero_nota: this.ifnull(this.state.dados.numero_nota, ""),
        email: this.ifnull(this.state.dados.email_contato, "").trim(),
        contato_site: "",
        codigo_vendedor: this.ifnull(this.state.codigo_vendedor, ""),
        codigo_contato: this.ifnull(this.state.dados.codigo_contato, ""),
        proposta_especial: this.state.dados.proposta_especial,
        estimativa_valor: this.ifnull(this.state.estimativa_selecionada, ""),
        codigo_tipo_operacao: "32",
        codigo_tipo_venda: this.ifnull(this.state.dados.codigo_tipo_venda, ""),
        codigo_empresa: this.ifnull(this.state.empresa_selecionada, ""),
        observacao: this.ifnull(this.state.dados.observacao, ""),
        observacao_interna: this.ifnull(this.state.dados.observacao_cliente, ""),
        observacao_detalhada_proposta: this.ifnull(this.state.dados.detalhe_proposta, ""),
        perdido: "",
        observacao_perda: "",
        observacao_item: "",
        negociacao_perdida: "",
        status_produto_aprovado: "",
        utiliza_preco_site: "",
        id_formato: "",
        id_material: "",
        id_acabamento: "",
        id_borda: "",
        id_extra: "",
        id_tipo_corte: "",
        status_qualificacao: this.ifnull(this.state.dados.qualificacao_st, ""),
        percentual_comissao: "",
        codigo_parceiro_transportadora: "",
        via_transportadora: "",
        tipo_frete: "",
        valor_frete: "",
        cotacao_frete: "",
        valor_real_frete: "",
        codigo_parceiro_destino: "",
      };

      const response = await inserirDadosProposta.post("", param);
      var data = response.data;

      if (data.AD_NUMINNO == null) {
        alert(data.MENSAGEM);
        this.setState({ view_loading_save: false });
      } else {
        if (this.ifnull(this.state.dados.numero_nota, "") != "") {
          await this.setState({
            codigo_proposta: parseInt(this.state.codigo_proposta),
            codigo_insert: null,
          });
          await this.filtrarProposta();
          this.setState({
            view_data_customer: false,
            view_data_proposal: false,
            view_data_product: false,
            view_data_tmk: false,
          });
          this.setState({
            view_data_product: true,
            view_lista_produtos_modal: true,
          });
        } else {
          await this.setState({
            codigo_proposta: data.AD_NUMINNO,
            codigo_insert: data.IDINSERT,
          });
          await this.filtrarProposta();
          this.setState({
            view_data_customer: false,
            view_data_proposal: false,
            view_data_product: false,
            view_data_tmk: false,
          });
          this.setState({
            view_data_product: true,
            view_lista_produtos_modal: true,
          });
        }
      }

      this.setState({ view_loading_save: false });
    } catch (error) {
      alert("Erro ao criar proposta.");
      this.setState({ view_loading_save: false });
      console.log(Object.keys(error), error.message);
    }
  };

  enviarTMK = async () => {
    try {
      this.setState({ loading_tmk: true });
      var data =
        this.state.data_retorno.split("/")[2] +
        "-" +
        this.state.data_retorno.split("/")[1] +
        "-" +
        this.state.data_retorno.split("/")[0];

      const response = await InserirHistoricoTMK.post("", {
        data_retorno: data,
        codigo_usuario: this.state.codigo_usuario,
        codigo_proposta: this.state.codigo_proposta,
        funil_de_venda: this.state.funil_venda_selecionado,
        descricao: this.state.descricao_tmk,
        codigo_motivo: this.state.tipo_motivo_selecionado,
      });

      var data = response.data;
      await this.getDadosHistorico();
      document.getElementById("desc-tmk").value = "";
      $("#funil-tmk").val(0);
      this.setState({ loading_tmk: false });
    } catch (error) {
      console.log(Object.keys(error), error.message);
    }
  };

  selectTipoMotivo = async (e) => {
    var option = e.target.options[e.target.options.selectedIndex].value;
    this.setState({ tipo_motivo_selecionado: option });
  };

  selectFunilVenda = async (e) => {
    var option = e.target.options[e.target.options.selectedIndex].value;
    this.setState({ funil_venda_selecionado: option });
  };

  handleDataRetorno = async (e) => {
    this.setState({ data_retorno: e.target.value });
  };

  handleDescricaoTMK = async (e) => {
    this.setState({ descricao_tmk: e.target.value });
  };

  selecionaCorEmbalagem = async (e) => {
    var option = e.target.options[e.target.options.selectedIndex].value;
    var produto = JSON.parse(fromBase64(e.target.attributes.data.value));

    var cor = [];
    produto.cores_embalagem.map((data) => {
      if (data.codigo_cor == option) {
        cor = data;
      }
    });

    this.state.items.map((data) => {
      if (produto.codigo_produto == data.codigo_produto && produto.sequencia == data.sequencia) {
        data.codigo_cor_embalagem_selecionada = cor;
        data.frete_site = null;
        data.item_carregado = false;
        data.item_salvo = false;
        this.setState({ update: true });
      }
    });

    this.setState({ update: true });
  };

  selecionaGravacaoEmbalagem = async (e) => {
    var option = e.target.options[e.target.options.selectedIndex].value;
    var produto = JSON.parse(fromBase64(e.target.attributes.data.value));

    var desc = [];
    produto.gravacao_embalagem.map((data) => {
      if (data.codigo_impressao == option) {
        desc = data;
      }
    });

    this.state.items.map((data) => {
      if (produto.codigo_produto == data.codigo_produto && produto.sequencia == data.sequencia) {
        data.codigo_impressao_embalagem_selecionada = desc;
        data.frete_site = null;
        data.item_carregado = false;
        data.item_salvo = false;
        this.setState({ update: true });
      }
    });

    this.setState({ update: true });
  };

  buscaCotacao = async (e) => {
    try {
      var item = JSON.parse(fromBase64(e.target.attributes.data.value));

      var cep = item.cep_selecionado;

      var CEP_API = await fetch(`https://viacep.com.br/ws/${cep.trim()}/json/`);

      var CEP_API_REST = await CEP_API.json();
      var cidade = CEP_API_REST.localidade;

      var endereco =
        CEP_API_REST.logradouro +
        " - " +
        CEP_API_REST.bairro +
        ", " +
        CEP_API_REST.localidade +
        " - " +
        CEP_API_REST.uf +
        ", " +
        CEP_API_REST.cep;

      this.state.items.map((data) => {
        if (data.codigo_produto === item.codigo_produto && data.sequencia === item.sequencia) {
          data.endereco_selecionado = endereco;
        }
      });

      this.setState({ update: true });

      var myInit = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          username: "rodrigo@innovationbrindes.com.br",
          password: "123456",
        }),
        cors: "none",
        cache: "default",
      };

      var CARGO_API = await fetch(`https://api.cargobr.com/v1/auth/`, myInit);
      var CARGO_API_REST = await CARGO_API.json();

      var volumes = [];
      if (CARGO_API_REST.access_token !== "") {
        if (item.dados_embalagem !== undefined) {
          volumes.push({
            width: parseInt(item.cubagem_embalagem.Largura) / 100,
            height: parseInt(item.cubagem_embalagem.Altura) / 100,
            length: parseInt(item.cubagem_embalagem.Comprimento) / 100,
            weight:
              parseFloat(item.cubagem_embalagem.PesoCaixa) == 0 ? 1 : parseFloat(item.cubagem_embalagem.PesoCaixa),
            value:
              Math.round(
                ((parseFloat(item.valor_total) +
                  parseFloat(item.codigo_impressao_embalagem_selecionada.valor.replace(",", ".")) *
                    parseFloat(item.qtd_negociada)) /
                  parseInt(item.cubagem_embalagem.QtdCaixa)) *
                  100
              ) / 100,
            amount: parseInt(item.cubagem_embalagem.QtdCaixa),
            object_types: ["sobconsulta"],
          });
        } else {
          volumes.push({
            width: parseInt(item.Largura) / 100,
            height: parseInt(item.Altura) / 100,
            length: parseInt(item.Comprimento) / 100,
            weight: parseFloat(item.PesoCaixa) == 0 ? 1 : parseFloat(item.PesoCaixa),
            value: parseFloat(item.CubagemTotal),
            amount: parseInt(item.QtdCaixa),
            object_types: ["sobconsulta"],
          });
        }
      }

      var myInit = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + CARGO_API_REST.access_token,
        },
        body: JSON.stringify({
          origin_zipcode: "02285020",
          destination_zipcode: cep,
          volumes: volumes,
        }),
        cors: "none",
        cache: "default",
      };

      var CARGO_TRANS_API = await fetch(`https://api.cargobr.com/v1/freights/quotations/`, myInit);
      var CARGO_TRANS_API_REST = await CARGO_TRANS_API.json();

      var cotacao = [];
      for (var transportadora of CARGO_TRANS_API_REST.options) {
        cotacao.push({
          name: transportadora.company.name,
          prazo_producao: item.id_prazo_entrega,
          max: transportadora.delivery_time.max + 1,
          min: transportadora.delivery_time.min + 1,
          price: parseFloat(parseFloat(transportadora.price) * 1.35).toLocaleString("pt-BR", {
            style: "currency",
            currency: "BRL",
          }),
        });
      }

      cotacao.sort(function (a, b) {
        if (a.price > b.price) {
          return 1;
        }
        if (a.price < b.price) {
          return -1;
        }
      });

      var cotacao_barato = cotacao[0];

      cotacao.sort(function (a, b) {
        if (a.max > b.max) {
          return 1;
        }
        if (a.max < b.max) {
          return -1;
        }
      });

      if (cotacao_barato.name == cotacao[0].name) {
        var cotacao_rapido = cotacao[1];
      } else {
        var cotacao_rapido = cotacao[0];
      }

      var cotacao_final = [];

      if (cidade != "São Paulo") {
        cotacao_final.push(cotacao_barato);
        cotacao_final.push(cotacao_rapido);
        cotacao_final[0].type = "mais-rapido";
        cotacao_final[1].type = "mais-barato";
      }

      cotacao_final.push({
        name: "CLIENTE RETIRA",
        prazo_producao: item.id_prazo_entrega,
        type: "gratis-cliente-retira",
        max: 1,
        min: 1,
        price: "R$ 0,00",
      });

      if (cidade == "São Paulo") {
        cotacao_final.push({
          name: "NOSSO CARRO",
          prazo_producao: item.id_prazo_entrega,
          type: "gratis-nosso-carro",
          max: 1,
          min: 1,
          price: "R$ 0,00",
        });
      }

      this.state.items.map((data) => {
        if (data.codigo_produto == item.codigo_produto && data.sequencia == item.sequencia) {
          data.endereco_selecionado = endereco;
          data.cotacao_frete = cotacao_final;
          data.cidade = cidade;
        }
      });

      this.setState({ update: true });
    } catch (error) {
      console.log(Object.keys(error), error.message);
    }
  };

  changeCEP = async (e) => {
    // this.setState({cep_})
  };

  gerarPrecoBase = async (e, obj_item = null) => {
    if (obj_item != null) {
      var item = obj_item;
    } else {
      var item = JSON.parse(fromBase64(e.target.attributes.data.value));
    }

    this.state.items.map(async (data) => {
      if (parseInt(data.codigo_produto) == parseInt(item.codigo_produto) && data.sequencia == item.sequencia) {
        var param = {
          codigo_produto: data.codigo_produto,
          codigo_impressao: data.id_impressao,
          quantidade: parseInt(data.qtd_negociada),
          codigo_cor: data.id_cor,
          batidas: data.qtd_batida,
          prazo_entrega: data.id_prazo_entrega,
        };

        const response = await buscaValorProduto.post("", param);
        var result = response.data;

        data.preco_base = Math.round(parseFloat(result.valor_unitario) * 100) / 100;
        data.valor_unitario = Math.round(parseFloat(result.valor_unitario) * 100) / 100;
        data.preco_loja = Math.round(parseFloat(result.valor_unitario) * 100) / 100;
        data.valor_total = Math.round(parseFloat(result.valor_total) * 100) / 100;
        data.valor_unitario_revendedor = Math.round(parseFloat(result.valor_venda_revendor) * 100) / 100;
        data.valor_unitario_site = Math.round(parseFloat(result.valor_venda_site) * 100) / 100;

        this.setState({ update: true });

        if (data.gravacao_embalagem != undefined) {
          var valor_por_tipo = await this.getInfosEmbalagem(data);
          data.gravacao_embalagem.map((tip, idx) => {
            tip.valor = valor_por_tipo.valores_embalagem[idx];
          });

          data.gravacao_embalagem.map((data2) => {
            if (data2.codigo_impressao == data.codigo_impressao_embalagem_selecionada.codigo_impressao) {
              data.codigo_impressao_embalagem_selecionada = data2;
            }
          });
          this.setState({ update: true });
        }
        this.setState({ update: true });
      }
    });

    if (this.state.step_by_step) {
      this.validaStepByStep("qtd_negociada");
    }

    if (this.state.quantidade_alterada) {
      console.log("qtd_negociada");
      await this.validaStepByStep("qtd_negociada");
    }
  };

  getInfosEmbalagem = async (data) => {
    try {
      if (this.state.produto_selecionado.ad_embalagem != undefined) {
        var codprod = this.state.produto_selecionado.ad_embalagem;
        console.log("1");
      } else {
        var codprod = data.codigo_produto;
        console.log("2");
      }

      console.log(codprod);

      const response = await ListaTabelaPrecoEmbalagem.get(codprod + "/tipo-gravacao");
      var dados = await response.data;

      if (dados[0].descricao_produto.trim() == "EMBALAGEM PARA CANETA") {
        this.setState({ tipo_embalagem: "caneta" });
      } else {
        this.setState({ tipo_embalagem: "box" });
      }

      var qtd = parseInt(data.qtd_negociada);
      var prazo = parseInt(data.id_prazo_entrega);

      var valores = [];
      var valoresTotais = [];
      var altura = [];
      var largura = [];
      var comprimento = [];
      var peso = [];
      var qtdcaixa = [];
      var codigo_impressao = [];

      for (var d of dados) {
        const response = await ListaTabelaPrecoEmbalagem.post("listar-tabela-preco/" + codprod + "/" + qtd, {
          ad_embalagem: codprod,
          codigo_impressao: d.codigo_impressao,
          prazo_entrega: prazo,
          codigo_cor: 1,
          batidas: 1,
        });
        var dados = await response.data[0];
        if (dados.mensagem != null) {
          var valor = dados.mensagem.split(",");
        } else {
          var valor = [];
        }

        codigo_impressao.push(d.codigo_impressao);

        for (var v of valor) {
          if (v.indexOf("ValorVenda") != -1) {
            valores.push(v.replace("ValorVenda=", "").replace(".", ","));
          }
          if (v.indexOf("ValorTotalVenda") != -1) {
            valoresTotais.push(v.replace("ValorTotalVenda=", "").replace(".", ","));
          }
          if (v.indexOf("Altura") != -1) {
            altura.push({
              valor: v.replace("Altura=", "").replace(".", ","),
            });
          }
          if (v.indexOf("Largura") != -1) {
            largura.push({
              valor: v.replace("Largura=", "").replace(".", ","),
            });
          }
          if (v.indexOf("Comprimento") != -1) {
            comprimento.push({
              valor: v.replace("Comprimento=", "").replace(".", ","),
            });
          }
          if (v.indexOf("PesoCaixa") != -1) {
            peso.push({
              valor: v.replace("PesoCaixa=", "").replace(".", ","),
            });
          }
          if (v.indexOf("QtdCaixa") != -1) {
            qtdcaixa.push({
              valor: v.replace("QtdCaixa=", "").replace(".", ","),
            });
          }
        }
      }

      return {
        valores_embalagem: valores,
        valores_embalagem_total: valoresTotais,
        altura_embalagem: altura[0],
        largura_embalagem: largura[0],
        comprimento_embalagem: comprimento[0],
        peso_embalagem: peso[0],
        qtd_caixa_embalagem: qtdcaixa[0],
        codigo_impressao_embalagem: codigo_impressao,
      };
    } catch (error) {
      console.log(Object.keys(error), error.message);
    }
  };

  adicionaEmbalagem = async (e) => {
    try {
      var data = JSON.parse(fromBase64(e.target.attributes.data.value));

      this.setState({
        loading_adiciona_embalagem: {
          status: true,
          sequencia: data.sequencia,
        },
      });
      const response = await ListaConfigEmbalagem.post("", {
        codigo_produto: this.state.produto_selecionado.ad_embalagem,
        quantidade: data.qtd_negociada,
        prazo: data.id_prazo_entrega,
      });
      var result = response.data;

      const dadosEmbalagem = await ListaConfigProdutos.get(result[0].codigo_produto);
      var dados_embalagem = dadosEmbalagem.data;

      var tipo = [];
      var cores = [];
      result.map((data) => {
        tipo.push({
          codigo_impressao: data.codigo_impressao,
          descricao_impressao: data.descricao,
        });
        cores.push({
          codigo_cor: data.codigo_cor,
          descricao_cor: data.nome_cor,
          imagem_box: data.imagem_box,
          imagem_print: data.imagem_print,
          imagem_plus: data.imagem_plus,
        });

        dados_embalagem.valor_total = parseFloat(data.CubagemTotal);
        dados_embalagem.valor_unitario = parseFloat(data.CubagemUnitaria);
      });

      var tipoUniqueArray = tipo.filter((tip, index) => {
        const _tip = JSON.stringify(tip);
        return (
          index ===
          tipo.findIndex((obj) => {
            return JSON.stringify(obj) === _tip;
          })
        );
      });

      var corUniqueArray = cores.filter((cor, index) => {
        const _cor = JSON.stringify(cor);
        return (
          index ===
          cores.findIndex((obj) => {
            return JSON.stringify(obj) === _cor;
          })
        );
      });

      tipo = tipoUniqueArray;
      cores = corUniqueArray;
      var cubagem = result[0];

      var valor_por_tipo = await this.getInfosEmbalagem(data);
      tipo.map((tip, idx) => {
        tip.valor = valor_por_tipo.valores_embalagem[idx];
      });

      var rand = function () {
        return Math.random().toString(36).substr(2); // remove `0.`
      };

      var token = rand() + rand();

      this.state.items.map((obj) => {
        if (obj.codigo_produto == data.codigo_produto && obj.sequencia == data.sequencia) {
          obj.cores_embalagem = cores;
          obj.gravacao_embalagem = tipo;
          obj.codigo_cor_embalagem_selecionada = cores[0];
          obj.codigo_impressao_embalagem_selecionada = tipo[0];
          obj.cubagem_embalagem = cubagem;
          obj.dados_embalagem = dados_embalagem;
          obj.token_embalagem = token;
          obj.frete_site = null;
          obj.item_carregado = false;
          obj.item_salvo = false;
        }
      });
      this.setState({
        loading_adiciona_embalagem: { status: false, sequencia: 0 },
      });
      await this.setState({ update: true });
    } catch (error) {
      console.log(Object.keys(error), error.message);
    }
  };

  addCountConfig = async () => {
    this.setState({ count_config: this.state.count_config + 1 });
  };

  selecionaOpcao = async (e) => {
    console.log(e);
    if (typeof e == "number") {
      var option = parseInt(e);
      this.setState({ opcao_selecionada: option });
    }
  };

  deletaEmbalagem = async (e) => {
    var item = JSON.parse(fromBase64(e.target.attributes.data.value));
    if (window.confirm("Deseja deletar a embalagem deste item?")) {
      this.state.items.map(async (data) => {
        if (
          data.codigo_produto == item.codigo_produto &&
          data.sequencia == item.sequencia &&
          data.num_order == item.num_order
        ) {
          var response = await this.excluirEmbalagem(item);

          if (response.result) {
            delete data.codigo_cor_embalagem_selecionada;
            delete data.codigo_impressao_embalagem_selecionada;
            delete data.cores_embalagem;
            delete data.cubagem_embalagem;
            delete data.dados_embalagem;
            delete data.gravacao_embalagem;
            data.token_embalagem = null;
            data.frete_site = null;
            data.item_carregado = false;
            data.item_salvo = false;

            this.setState({ update: true });
            alert("Embalagem deletada.");
          } else {
            alert("Erro ao deletar embalagem: " + response.mensagem);
          }
        }
      });
    }
    this.setState({ update: true });
  };

  excluirEmbalagem = async (item) => {
    try {
      // console.log(item);

      if (item.numero_nota != "") {
        var param = {
          codigo_produto:
            item.dados_embalagem.ad_embalagem != null
              ? item.dados_embalagem.ad_embalagem
              : item.dados_embalagem.codigo_produto,
          numero_nota: item.numero_nota,
          token_embalagem: item.token_embalagem,
        };
        const response = await DeletarEmbalagemProduto.post("", param);
        var data = response.data;

        if (data.result) {
          return data;
        } else {
          return data;
        }
      } else {
        return { result: true, mensagem: "Não salvo" };
      }
    } catch (error) {
      console.log(Object.keys(error), error.message);
    }
  };

  excluirProduto = async (item) => {
    try {
      // console.log(item);

      if (item.numero_nota != "") {
        var param = {
          codigo_produto: item.codigo_produto,
          codigo_embalagem:
            item.dados_embalagem != undefined
              ? item.dados_embalagem.ad_embalagem != null
                ? item.dados_embalagem.ad_embalagem
                : item.dados_embalagem.codigo_produto
              : null,
          numero_nota: item.numero_nota,
          sequencia: item.sequencia,
          token_embalagem: item.token_embalagem,
        };
        const response = await DeletarProduto.post("", param);
        var data = response.data;

        // console.log(data);

        if (data.result) {
          return data;
        } else {
          return data;
        }
      } else {
        return { result: true, mensagem: "Não salvo" };
      }
    } catch (error) {
      console.log(Object.keys(error), error.message);
    }
  };

  deletarConfigProduto = async (e) => {
    if (window.confirm("Deseja deletar este item da proposta?\n\n**Todas as configuração do item serão deletadas**")) {
      var item = JSON.parse(fromBase64(e.target.attributes.data.value));
      await this.setState({ loading_busca_produto: true });
      var pos;
      this.state.items.map((data, idx) => {
        if (
          data.codigo_produto == item.codigo_produto &&
          item.sequencia == item.sequencia &&
          data.num_order == item.num_order
        ) {
          pos = idx;
        }
      });

      var response = await this.excluirProduto(item);
      // console.log(response);

      if (response.result) {
        this.state.items.splice(pos, 1);

        this.state.boxproduto.map((data) => {
          var count = 0;
          this.state.items.map((item, idx) => {
            if (data.codigo_produto == item.codigo_produto && item.tipo_produto == "PROD") {
              item.num_order = count;
              count++;
            }
          });
        });

        var find_product = false;
        this.state.items.map((data) => {
          if (data.codigo_produto == item.codigo_produto) {
            find_product = true;
          }
        });

        if (!find_product) {
          this.setState({ produto_selecionado: [] });
          var comboproduto = [];
          this.state.boxproduto.map((data) => {
            if (data.codigo_produto != item.codigo_produto) {
              comboproduto.push(data);
            }
          });
          this.setState({ boxproduto: comboproduto });
        }
        await this.setState({ loading_busca_produto: false });
        await this.setState({ update: true });
        alert("Produto deletado.");
      } else {
        alert("Erro ao deletar produto: " + response.mensagem);
      }

      await this.setState({ loading_busca_produto: false });
      await this.setState({ update: true });
    }
  };

  verProposta = async () => {
    this.setState({ view_proposta_modal: true });
  };

  sumValuesObject(cod, dados) {
    var valor = 0;
    dados.map((obj) => {
      if (parseInt(obj.codigo_produto.toString().trim()) == cod) {
        valor = valor + parseFloat(obj.valor_total) + parseFloat(obj.valor_frete);
      }
    });
    return valor;
  }

  changeInputFrete = async (e) => {
    var data = JSON.parse(fromBase64(e.target.attributes.data.value));
    var frete = JSON.parse(e.target.value);

    var nome_transportadora = JSON.parse(e.target.value).name;
    var prazo_entrega = JSON.parse(e.target.value).prazo_producao;
    var preco = JSON.parse(e.target.value).price;
    var type = JSON.parse(e.target.value).type;
    this.state.items.map((item) => {
      if (item.codigo_produto == data.codigo_produto && item.sequencia == data.sequencia) {
        item.frete_selecionado =
          "Transportadora: " + nome_transportadora + ", Prazo de entrega:" + prazo_entrega + ", Preço: " + preco;
        item.config_frete = frete;
        item.config_frete.preco_formatado = preco.replaceAll("R$", "").replaceAll(".", "").replaceAll(",", ".").trim();
      }
    });

    if (nome_transportadora == "CLIENTE RETIRA") {
      this.changePasso(
        {
          target: {
            options: { selectedIndex: 1, 1: { value: "F" } },
            attributes: {
              data: { value: e.target.attributes.data.value },
            },
          },
        },
        "cif_fob",
        "select"
      );
      document.querySelectorAll("#cif-fob-" + data.codigo_produto + "-" + data.num_order)[0].value = "F";
    } else {
      this.changePasso(
        {
          target: {
            options: { selectedIndex: 1, 1: { value: "T" } },
            attributes: {
              data: { value: e.target.attributes.data.value },
            },
          },
        },
        "cif_fob",
        "select"
      );
      document.querySelectorAll("#cif-fob-" + data.codigo_produto + "-" + data.num_order)[0].value = "T";
    }

    this.setState({ update: true });
    this.setState({ frete_selecionado: "" });
  };

  salvarItemProposta = async (e) => {
    try {
      var item = JSON.parse(fromBase64(e.target.attributes.data.value));

      console.log(item);

      const { id_cor, id_impressao, qtd_negociada, valor_unitario } = item;

      if (id_cor === undefined && id_impressao === undefined && qtd_negociada === "" && valor_unitario === "") {
        alert("Preencha os campos corretamente.");
        return;
      }

      console.log(id_cor);

      var proposta = this.state.dados;
      await this.setState({
        loading_salvar_item: { status: true, sequencia: item.sequencia },
      });
      this.setState({ update: true });

      var produto = [
        {
          id: null,
          codigo_contato: proposta.codigo_contato,
          codigo_empresa: proposta.codigo_empresa,
          codigo_parceiro: proposta.codigo_parceiro,
          codigo_parceiro_destino: proposta.codigo_parceiro_destino,
          codigo_parceiro_transportadora: proposta.codigo_parceiro_transporte,
          codigo_produto: item.codigo_produto,
          codigo_tipo_operacao: proposta.codigo_tipo_operacao,
          codigo_tipo_venda: proposta.codigo_tipo_venda,
          codigo_vendedor: this.state.codigo_vendedor,
          email: proposta.email_contato,
          estimativa_valor: proposta.estimativa_valor,
          id_cor: item.id_cor,
          id_impressao: item.id_impressao,
          id_prazo_entrega: item.id_prazo_entrega,
          nao_exibe_proposta: item.nao_exibe_proposta,
          negociacao_perdida: item.negocped,
          numero_nota: proposta.numero_nota,
          observacao: proposta.observacao,
          observacao_cliente: proposta.observacao_cliente,
          observacao_detalhada_proposta: proposta.detalhe_proposta,
          observacao_interna: proposta.observacao_admin,
          observacao_item: item.observacao,
          observacao_perda: proposta.observacao_perda,
          percentual_comissao: item.perccom,
          preco_base: Math.round(parseFloat(item.preco_base) * 100) / 100,
          proposta_especial: proposta.proposta_especial,
          qtd_batidas: item.qtd_batida,
          quantidade_negociada: item.qtd_negociada,
          sequencia: item.sequencia,
          status_produto_aprovado: item.status_produto_aprovacao,
          status_qualificacao: proposta.qualificacao_st,
          tipo_frete: proposta.tipo_frete,
          cif_fob: item.cif_fob,
          token_embalagem: item.token_embalagem,
          utiliza_preco_site: item.utiliza_preco_site,
          valor_frete: proposta.valor_frete,
          valor_frete_item: item.valor_frete,
          valor_total: Math.round(parseFloat(item.valor_total) * 100) / 100,
          valor_unitario: Math.round(parseFloat(item.valor_unitario) * 100) / 100,
          frete_site: item.frete_selecionado == undefined ? item.frete_site : item.frete_selecionado,
        },
      ];
      if (item.dados_embalagem != undefined) {
        produto.push({
          id: null,
          codigo_contato: proposta.codigo_contato,
          codigo_empresa: proposta.codigo_empresa,
          codigo_parceiro: proposta.codigo_parceiro,
          codigo_parceiro_destino: proposta.codigo_parceiro_destino,
          codigo_parceiro_transportadora: proposta.codigo_parceiro_transporte,
          codigo_produto:
            item.dados_embalagem.ad_embalagem != undefined
              ? item.dados_embalagem.ad_embalagem
              : item.dados_embalagem.codigo_produto,
          codigo_tipo_operacao: proposta.codigo_tipo_operacao,
          codigo_tipo_venda: proposta.codigo_tipo_venda,
          codigo_vendedor: this.state.codigo_vendedor,
          email: proposta.email_contato,
          estimativa_valor: proposta.estimativa_valor,
          id_cor: item.codigo_cor_embalagem_selecionada.codigo_cor,
          id_impressao: item.codigo_impressao_embalagem_selecionada.codigo_impressao,
          id_prazo_entrega: item.id_prazo_entrega,
          nao_exibe_proposta: item.nao_exibe_proposta,
          negociacao_perdida: item.negocped,
          numero_nota: proposta.numero_nota,
          observacao: proposta.observacao,
          observacao_cliente: proposta.observacao_cliente,
          observacao_detalhada_proposta: proposta.detalhe_proposta,
          observacao_interna: proposta.observacao_admin,
          observacao_item: item.dados_embalagem.descricao,
          observacao_perda: proposta.observacao_perda,
          percentual_comissao: item.perccom,
          preco_base:
            Math.round(parseFloat(item.codigo_impressao_embalagem_selecionada.valor.replace(",", ".")) * 100) / 100,
          proposta_especial: proposta.proposta_especial,
          qtd_batidas: 1,
          quantidade_negociada: item.qtd_negociada,
          sequencia: item.sequencia == 1 ? parseInt(item.sequencia) + 1 : this.state.items.length + 1,
          status_produto_aprovado: item.status_produto_aprovacao,
          status_qualificacao: proposta.qualificacao_st,
          tipo_frete: proposta.tipo_frete,
          cif_fob: item.cif_fob,
          token_embalagem: item.token_embalagem,
          utiliza_preco_site: item.utiliza_preco_site,
          valor_frete: proposta.valor_frete,
          valor_frete_item: item.valor_frete,
          valor_total:
            Math.round(
              parseFloat(
                item.codigo_impressao_embalagem_selecionada.valor.replace(",", ".") * parseInt(item.qtd_negociada)
              ) * 100
            ) / 100,
          valor_unitario:
            Math.round(parseFloat(item.codigo_impressao_embalagem_selecionada.valor.replace(",", ".")) * 100) / 100,
          frete_site: item.frete_selecionado == undefined ? item.frete_site : item.frete_selecionado,
        });
      }

      var idx = 0;
      for await (let prod of produto) {
        const response = await inserirDadosProposta.post("", prod);
        var result = response.data;

        if (result.AD_NUMINNO != "") {
          if (idx == 1 || item.dados_embalagem == undefined) {
            await this.getItens();
            this.state.boxproduto.map((data) => {
              var count = 0;
              this.state.items.map((it) => {
                if (data.codigo_produto == it.codigo_produto && it.tipo_produto == "PROD") {
                  it.num_order = count;
                  count++;
                }
              });
            });
          }
        } else {
          alert("Erro ao salvar");
        }
        idx++;
      }

      // produto.map(async (data,idx)=>{
      //     const response = await inserirDadosProposta.post('',data);
      //     var data = response.data;

      //     if(data.AD_NUMINNO != ""){
      //         if(idx == 1 || item.dados_embalagem == undefined){
      //             await this.getItens();
      //             this.state.boxproduto.map(data=>{
      //                 var count = 0;
      //                 this.state.items.map((item,idx)=>{
      //                     if(data.codigo_produto == item.codigo_produto && item.tipo_produto == "PROD"){
      //                         item.num_order = count;
      //                         count++;
      //                     }
      //                 })
      //             });
      //         }
      //     }else{
      //         alert("Erro ao salvar");
      //     }
      // });

      if (this.state.step_by_step) {
        delete this.state.cores_produto[this.state.cores_produto.length - 1];
        delete this.state.gravacao_produto[this.state.gravacao_produto.length - 1];
        delete this.state.prazos_produto[this.state.prazos_produto.length - 1];
        delete this.state.batidas_produto[this.state.batidas_produto.length - 1];
      }

      this.setState({
        novo_produto_adicionado: {
          codigo_produto: null,
          alterado: false,
        },
        step_by_step: false,
      });
    } catch (error) {
      console.log(Object.keys(error), error.message);
    }
  };

  initialStepByStep = async () => {
    this.setState({ quantidade_alterada: false });
    var corprod = this.state.produto_selecionado.codigo_produto;
    var order = this.state.opcao_selecionada;

    if (
      this.state.step_by_step &&
      this.state.produto_selecionado.codigo_produto == this.state.novo_produto_adicionado.codigo_produto
    ) {
      document.getElementById("cor-brinde-title-" + corprod + "-" + order).style.transition = "0.3s";
      document.getElementById("cor-brinde-title-" + corprod + "-" + order).style.transform = "scale(1,1)";
      document.getElementById("cor-brinde-title-" + corprod + "-" + order).style.opacity = "1";

      document.getElementById("cor-brinde-field-" + corprod + "-" + order).style.transition = "0.3s";
      document.getElementById("cor-brinde-field-" + corprod + "-" + order).style.transform = "scale(1,1)";
      document.getElementById("cor-brinde-field-" + corprod + "-" + order).style.opacity = "1";

      this.state.cores_produto.push({
        codigo_cor: "X",
        codigo_produto: 337,
        descricao_cor: "Selecionar cor",
        estoque_disponivel: null,
        imagem_box: null,
        imagem_plus: null,
        imagem_print: null,
        rgb_cores: null,
      });
      this.setState({ update: true });

      var o = document.querySelectorAll("#cor-brinde-field-" + corprod + "-" + order)[1];
      o.value = "X";

      document.getElementById("gravacao-brinde-title-" + corprod + "-" + order).style.transition = "0.3s";
      document.getElementById("gravacao-brinde-title-" + corprod + "-" + order).style.transform = "scale(0.80,0.80)";
      document.getElementById("gravacao-brinde-title-" + corprod + "-" + order).style.opacity = "0.7";

      document.getElementById("gravacao-brinde-field-" + corprod + "-" + order).style.transition = "0.3s";
      document.getElementById("gravacao-brinde-field-" + corprod + "-" + order).style.transform = "scale(0.80,0.80)";
      document.getElementById("gravacao-brinde-field-" + corprod + "-" + order).style.opacity = "0.7";
      document.getElementById("gravacao-brinde-field-" + corprod + "-" + order).children[0].disabled = true;

      this.state.gravacao_produto.push({
        codigo_impressao: "X",
        codigo_produto: 337,
        descricao_impressao: null,
        descricao_produto: null,
        descricao_site: "Selecionar gravação",
        nome_img: null,
        referencia_produto: null,
        texto_impressao: null,
      });
      this.setState({ update: true });

      var o = document.querySelectorAll("#gravacao-brinde-field-" + corprod + "-" + order)[1];
      o.value = "X";

      document.getElementById("impressao-brinde-title-" + corprod + "-" + order).style.transition = "0.3s";
      document.getElementById("impressao-brinde-title-" + corprod + "-" + order).style.transform = "scale(0.80,0.80)";
      document.getElementById("impressao-brinde-title-" + corprod + "-" + order).style.opacity = "0.7";

      document.getElementById("impressao-brinde-field-" + corprod + "-" + order).style.transition = "0.3s";
      document.getElementById("impressao-brinde-field-" + corprod + "-" + order).style.transform = "scale(0.80,0.80)";
      document.getElementById("impressao-brinde-field-" + corprod + "-" + order).style.opacity = "0.7";
      document.getElementById("impressao-brinde-field-" + corprod + "-" + order).children[0].disabled = true;

      this.state.batidas_produto.push("Selecionar Nº de impressões");
      this.setState({ update: true });

      var o = document.querySelectorAll("#impressao-brinde-field-" + corprod + "-" + order)[1];
      o.value = "Selecionar Nº de impressões";

      document.getElementById("prazo-brinde-title-" + corprod + "-" + order).style.transition = "0.3s";
      document.getElementById("prazo-brinde-title-" + corprod + "-" + order).style.transform = "scale(0.80,0.80)";
      document.getElementById("prazo-brinde-title-" + corprod + "-" + order).style.opacity = "0.7";

      document.getElementById("prazo-brinde-field-" + corprod + "-" + order).style.transition = "0.3s";
      document.getElementById("prazo-brinde-field-" + corprod + "-" + order).style.transform = "scale(0.80,0.80)";
      document.getElementById("prazo-brinde-field-" + corprod + "-" + order).style.opacity = "0.7";
      document.getElementById("prazo-brinde-field-" + corprod + "-" + order).children[0].disabled = true;

      this.state.prazos_produto.push({
        codigo: "X",
        descricao: "Selecionar prazo",
      });
      this.setState({ update: true });

      var o = document.querySelectorAll("#prazo-brinde-field-" + corprod + "-" + order)[1];
      o.value = "X";

      document.getElementById("quantidade-brinde-title-" + corprod + "-" + order).style.transition = "0.3s";
      document.getElementById("quantidade-brinde-title-" + corprod + "-" + order).style.transform = "scale(0.80,0.80)";
      document.getElementById("quantidade-brinde-title-" + corprod + "-" + order).style.opacity = "0.7";
      // $("#quantidade-brinde-field-"+corprod+"-"+order).children[0].disabled = true;
      // $("#quantidade-brinde-field-"+corprod+"-"+order).children[1].disabled = true;

      document.getElementById("base-brinde-title-" + corprod + "-" + order).style.transition = "0.3s";
      document.getElementById("base-brinde-title-" + corprod + "-" + order).style.transform = "scale(0.80,0.80)";
      document.getElementById("base-brinde-title-" + corprod + "-" + order).style.opacity = "0.7";

      document.getElementById("preco-brinde-title-" + corprod + "-" + order).style.transition = "0.3s";
      document.getElementById("preco-brinde-title-" + corprod + "-" + order).style.transform = "scale(0.80,0.80)";
      document.getElementById("preco-brinde-title-" + corprod + "-" + order).style.opacity = "0.7";

      document.getElementById("unit-brinde-title-" + corprod + "-" + order).style.transition = "0.3s";
      document.getElementById("unit-brinde-title-" + corprod + "-" + order).style.transform = "scale(0.80,0.80)";
      document.getElementById("unit-brinde-title-" + corprod + "-" + order).style.opacity = "0.7";

      document.getElementById("total-brinde-title-" + corprod + "-" + order).style.transition = "0.3s";
      document.getElementById("total-brinde-title-" + corprod + "-" + order).style.transform = "scale(0.80,0.80)";
      document.getElementById("total-brinde-title-" + corprod + "-" + order).style.opacity = "0.7";

      document.getElementById("cor-brinde-field-" + corprod + "-" + order).style.transition = "0.3s";
      document.getElementById("cor-brinde-field-" + corprod + "-" + order).style.transform = "scale(1,1)";
      document.getElementById("cor-brinde-field-" + corprod + "-" + order).style.opacity = "1";

      // document.getElementById("prazo-brinde-field-"+corprod+"-"+order).disabled = true;

      document.getElementById("quantidade-brinde-field-" + corprod + "-" + order).style.transition = "0.3s";
      document.getElementById("quantidade-brinde-field-" + corprod + "-" + order).style.transform = "scale(0.80,0.80)";
      document.getElementById("quantidade-brinde-field-" + corprod + "-" + order).style.opacity = "0.7";
      document.getElementById("quantidade-brinde-field-" + corprod + "-" + order).children[0].disabled = true;
      document.getElementById("quantidade-brinde-field-" + corprod + "-" + order).children[1].disabled = true;
      // document.getElementById("quantidade-brinde-field-"+corprod+"-"+order).disabled = true;

      document.getElementById("base-brinde-field-" + corprod + "-" + order).style.transition = "0.3s";
      document.getElementById("base-brinde-field-" + corprod + "-" + order).style.transform = "scale(0.80,0.80)";
      document.getElementById("base-brinde-field-" + corprod + "-" + order).style.opacity = "0.7";

      document.getElementById("preco-brinde-field-" + corprod + "-" + order).style.transition = "0.3s";
      document.getElementById("preco-brinde-field-" + corprod + "-" + order).style.transform = "scale(0.80,0.80)";
      document.getElementById("preco-brinde-field-" + corprod + "-" + order).style.opacity = "0.7";

      document.getElementById("unit-brinde-field-" + corprod + "-" + order).style.transition = "0.3s";
      document.getElementById("unit-brinde-field-" + corprod + "-" + order).style.transform = "scale(0.80,0.80)";
      document.getElementById("unit-brinde-field-" + corprod + "-" + order).style.opacity = "0.7";
      document.getElementById("unit-brinde-field-" + corprod + "-" + order).children[0].disabled = true;
      // document.getElementById("unit-brinde-field-"+corprod+"-"+order).disabled = true;

      document.getElementById("total-brinde-field-" + corprod + "-" + order).style.transition = "0.3s";
      document.getElementById("total-brinde-field-" + corprod + "-" + order).style.transform = "scale(0.80,0.80)";
      document.getElementById("total-brinde-field-" + corprod + "-" + order).style.opacity = "0.7";
    }
  };

  EnviarPropostaCliente = async () => {
    try {
      var param = {
        numero_pedido: null,
        numero_nota: null,
        texto_email: null,
      };

      const response = await EnviarPropostaParaCliente.post("", param);
      var data = response.data;
    } catch (error) {
      console.log(Object.keys(error), error.message);
    }
  };

  GerarPedidoCliente = async () => {
    try {
      this.setState({
        view_data_customer: false,
        view_data_proposal: false,
        view_data_product: false,
        view_data_tmk: false,
        view_loading_save: true,
        view_loading: true,
      });

      var cab = {
        sequencia: "0",
        codigo_parceiro: this.ifnull(this.state.dados.codigo_parceiro, ""),
        observacao_cliente: this.ifnull(this.state.dados.observacao_cliente, ""),
        codigo_produto: "",
        quantidade_negociada: "",
        valor_unitario: "",
        valor_total: "",
        preco_base: "",
        id_impressao: "",
        id_cor: "",
        id_prazo_entrega: "",
        qtd_batidas: "",
        frete_site: "",
        numero_nota: "",
        email: this.ifnull(this.state.dados.email_contato, "").trim(),
        contato_site: "",
        codigo_vendedor: this.ifnull(this.state.codigo_vendedor, ""),
        codigo_contato: this.ifnull(this.state.dados.codigo_contato, ""),
        proposta_especial: this.state.dados.proposta_especial,
        estimativa_valor: this.ifnull(this.state.estimativa_selecionada, ""),
        codigo_tipo_operacao: "33",
        codigo_tipo_venda: this.ifnull(this.state.dados.codigo_tipo_venda, ""),
        codigo_empresa: this.ifnull(this.state.empresa_selecionada, ""),
        observacao: this.ifnull(this.state.dados.observacao, ""),
        observacao_interna: this.ifnull(this.state.dados.observacao_cliente, ""),
        observacao_detalhada_proposta: this.ifnull(this.state.dados.detalhe_proposta, ""),
        perdido: "",
        observacao_perda: "",
        observacao_item: "",
        negociacao_perdida: "",
        status_produto_aprovado: "",
        utiliza_preco_site: "",
        id_formato: "",
        id_material: "",
        id_acabamento: "",
        id_borda: "",
        id_extra: "",
        id_tipo_corte: "",
        status_qualificacao: this.ifnull(this.state.dados.qualificacao_st, ""),
        percentual_comissao: "",
        codigo_parceiro_transportadora: "",
        via_transportadora: "",
        tipo_frete: "",
        valor_frete: "",
        cotacao_frete: "",
        valor_real_frete: "",
        codigo_parceiro_destino: "",
        numero_nota_original: this.ifnull(this.state.dados.numero_nota, ""),
        sequencia_original: "0",
      };

      const responseCab = await inserirDadosProposta.post("", cab);
      var resultCab = responseCab.data;

      var proposta = this.state.dados;

      for await (let item of this.state.items) {
        var produto = {
          id: null,
          codigo_contato: proposta.codigo_contato,
          codigo_empresa: proposta.codigo_empresa,
          codigo_parceiro: proposta.codigo_parceiro,
          codigo_parceiro_destino: proposta.codigo_parceiro_destino,
          codigo_parceiro_transportadora: proposta.codigo_parceiro_transporte,
          codigo_produto: item.codigo_produto,
          codigo_tipo_operacao: 33,
          codigo_tipo_venda: proposta.codigo_tipo_venda,
          codigo_vendedor: this.state.codigo_vendedor,
          email: proposta.email_contato,
          estimativa_valor: proposta.estimativa_valor,
          id_cor: item.id_cor,
          id_impressao: item.id_impressao,
          id_prazo_entrega: item.id_prazo_entrega,
          nao_exibe_proposta: item.nao_exibe_proposta,
          negociacao_perdida: item.negocped,
          numero_nota: resultCab.NUNOTA,
          observacao: proposta.observacao,
          observacao_cliente: proposta.observacao_cliente,
          observacao_detalhada_proposta: proposta.detalhe_proposta,
          observacao_interna: proposta.observacao_admin,
          observacao_item: item.observacao,
          observacao_perda: proposta.observacao_perda,
          percentual_comissao: item.perccom,
          preco_base: Math.round(parseFloat(item.preco_base) * 100) / 100,
          proposta_especial: proposta.proposta_especial,
          qtd_batidas: item.qtd_batida,
          quantidade_negociada: item.qtd_negociada,
          sequencia: item.sequencia,
          status_produto_aprovado: item.status_produto_aprovacao,
          status_qualificacao: proposta.qualificacao_st,
          tipo_frete: proposta.tipo_frete,
          token_embalagem: item.token_embalagem,
          utiliza_preco_site: item.utiliza_preco_site,
          valor_frete: proposta.valor_frete,
          valor_frete_item: item.valor_frete,
          valor_total: Math.round(parseFloat(item.valor_total) * 100) / 100,
          valor_unitario: Math.round(parseFloat(item.valor_unitario) * 100) / 100,
          frete_site: item.frete_selecionado == undefined ? item.frete_site : item.frete_selecionado,
          numero_nota_original: proposta.numero_nota,
          sequencia_original: item.sequencia,
        };

        var responseProd = await inserirDadosProposta.post("", produto);
        var resultProd = responseProd.data;

        console.log("RESPONSE responseProd", responseCab)
        console.log("RESPONSE CAB", responseCab)
      }

      if (window.confirm("Pedido gerado com sucesso. deseja ir para tela de pedido?")) {
        window.location.href = "/pedidos?p=" + this.state.codigo_proposta;
      }
    } catch (error) {
      console.log(Object.keys(error), error.message);
    }
  };

  getEmbalagens = async (codprod) => {
    try {
      // this.setState({loadingValor:true});
      const response = await ListaConfigProdutos.get(codprod + "/tipo-gravacao");
      var dados = await response.data;

      if (dados[0].descricao_produto.trim() == "EMBALAGEM PARA CANETA") {
        this.setState({ tipo_embalagem: "caneta" });
      } else {
        this.setState({ tipo_embalagem: "box" });
      }

      var qtd = this.state.qtd_selecionadas;
      var prazo = this.state.prazo_selecionadas[0];

      var valores = [];
      var valoresTotais = [];
      var altura = [];
      var largura = [];
      var comprimento = [];
      var peso = [];
      var qtdcaixa = [];
      var codigo_impressao = [];

      for (var d of dados) {
        const response = await ListaConfigProdutos.post("listar-tabela-preco/" + codprod + "/" + qtd, {
          ad_embalagem: codprod,
          codigo_impressao: d.codigo_impressao,
          prazo_entrega: prazo,
          codigo_cor: 1,
          batidas: 1,
        });
        var dados = await response.data[0];
        if (dados.mensagem != null) {
          var valor = dados.mensagem.split(",");
        } else {
          var valor = [];
        }

        codigo_impressao.push(d.codigo_impressao);

        for (var v of valor) {
          if (v.indexOf("ValorVenda") != -1) {
            valores.push(v.replace("ValorVenda=", "").replace(".", ","));
          }
          if (v.indexOf("ValorTotalVenda") != -1) {
            valoresTotais.push(v.replace("ValorTotalVenda=", "").replace(".", ","));
          }
          if (v.indexOf("Altura") != -1) {
            altura.push({
              valor: v.replace("Altura=", "").replace(".", ","),
            });
          }
          if (v.indexOf("Largura") != -1) {
            largura.push({
              valor: v.replace("Largura=", "").replace(".", ","),
            });
          }
          if (v.indexOf("Comprimento") != -1) {
            comprimento.push({
              valor: v.replace("Comprimento=", "").replace(".", ","),
            });
          }
          if (v.indexOf("PesoCaixa") != -1) {
            peso.push({
              valor: v.replace("PesoCaixa=", "").replace(".", ","),
            });
          }
          if (v.indexOf("QtdCaixa") != -1) {
            qtdcaixa.push({
              valor: v.replace("QtdCaixa=", "").replace(".", ","),
            });
          }
        }
      }

      this.setState({
        valores_embalagem: valores,
        valores_embalagem_total: valoresTotais,
        altura_embalagem: altura[0],
        largura_embalagem: largura[0],
        comprimento_embalagem: comprimento[0],
        peso_embalagem: peso[0],
        qtd_caixa_embalagem: qtdcaixa[0],
        codigo_impressao_embalagem: codigo_impressao,
        loadingValor: false,
      });
    } catch (error) {
      console.log(Object.keys(error), error.message);
    }
  };

  showAllFields = async () => {
    var corprod = this.state.produto_selecionado.codigo_produto;
    var order = this.state.opcao_selecionada;

    $("button#quantidade-brinde-field-" + corprod + "-" + order)[0].style.transition = "0.2s";
    $("button#quantidade-brinde-field-" + corprod + "-" + order)[0].style.transform = "scale(1,1)";
    $("button#quantidade-brinde-field-" + corprod + "-" + order)[0].style.boxShadow = "none";

    document.getElementById("base-brinde-title-" + corprod + "-" + order).style.transition = "0.3s";
    document.getElementById("base-brinde-title-" + corprod + "-" + order).style.transform = "scale(1,1)";
    document.getElementById("base-brinde-title-" + corprod + "-" + order).style.opacity = "1";

    document.getElementById("base-brinde-field-" + corprod + "-" + order).style.transition = "0.3s";
    document.getElementById("base-brinde-field-" + corprod + "-" + order).style.transform = "scale(1,1)";
    document.getElementById("base-brinde-field-" + corprod + "-" + order).style.opacity = "1";

    document.getElementById("preco-brinde-title-" + corprod + "-" + order).style.transition = "0.3s";
    document.getElementById("preco-brinde-title-" + corprod + "-" + order).style.transform = "scale(1,1)";
    document.getElementById("preco-brinde-title-" + corprod + "-" + order).style.opacity = "1";

    document.getElementById("preco-brinde-field-" + corprod + "-" + order).style.transition = "0.3s";
    document.getElementById("preco-brinde-field-" + corprod + "-" + order).style.transform = "scale(1,1)";
    document.getElementById("preco-brinde-field-" + corprod + "-" + order).style.opacity = "1";

    document.getElementById("unit-brinde-title-" + corprod + "-" + order).style.transition = "0.3s";
    document.getElementById("unit-brinde-title-" + corprod + "-" + order).style.transform = "scale(1,1)";
    document.getElementById("unit-brinde-title-" + corprod + "-" + order).style.opacity = "1";

    document.getElementById("unit-brinde-field-" + corprod + "-" + order).style.transition = "0.3s";
    document.getElementById("unit-brinde-field-" + corprod + "-" + order).style.transform = "scale(1,1)";
    document.getElementById("unit-brinde-field-" + corprod + "-" + order).style.opacity = "1";
    document.getElementById("unit-brinde-field-" + corprod + "-" + order).children[0].disabled = false;

    document.getElementById("total-brinde-title-" + corprod + "-" + order).style.transition = "0.3s";
    document.getElementById("total-brinde-title-" + corprod + "-" + order).style.transform = "scale(1,1)";
    document.getElementById("total-brinde-title-" + corprod + "-" + order).style.opacity = "1";

    document.getElementById("total-brinde-field-" + corprod + "-" + order).style.transition = "0.3s";
    document.getElementById("total-brinde-field-" + corprod + "-" + order).style.transform = "scale(1,1)";
    document.getElementById("total-brinde-field-" + corprod + "-" + order).style.opacity = "1";
  };

  listaLayoutProduto = async () => {
    try {
      var param = {
        numero_nota: this.state.data_product_layout_modal.numero_nota,
        codigo_produto: this.state.data_product_layout_modal.codigo_produto,
      };
      const response = await ListaLayoutProduto.post("", param);
      var data = response.data;

      var count = 0;
      data.map((item) => {
        if (item.link_drive != "") {
          count++;
        }
      });
      var layout = { quantidade: count, link_drive: data[0].link_drive };
      this.setState({ data_layout: layout });
    } catch (error) {
      console.log(Object.keys(error), error.message);
    }
  };

  uploadFileDrive = async (e) => {
    try {
      var file = new Blob([document.getElementById("input-upload-file").files[0]], { type: "image/jpg" });
      var form = new FormData();

      form.append("file", file);
      form.append("numero_nota", this.state.data_product_layout_modal.numero_nota);
      form.append("codigo_produto", this.state.data_product_layout_modal.codigo_produto);
      form.append("sequencia", this.state.data_product_layout_modal.sequencia);
      form.append("numero_pedido", this.state.codigo_proposta);
      form.append("codigo_parceiro", this.state.dados.codigo_parceiro);
      form.append("codigo_vendedor", this.state.codigo_vendedor);

      const response = await UploadFileDrive.post("", form);
      var data = response.data;

      this.listaLayoutProduto();
    } catch (error) {
      console.log(Object.keys(error), error.message);
    }
  };

  closeModalLayout = async () => {
    this.setState({ view_modal_layout: false, data_layout: [] });
  };

  selecionaLayout = async (e) => {
    var data = JSON.parse(fromBase64(e.target.attributes.data.value));
    await this.setState({
      view_modal_layout: true,
      data_product_layout_modal: data,
    });
    this.listaLayoutProduto();
  };

  abrirPedidoSelecionado = async (e) => {
    var data = JSON.parse(e.target.value);
    console.log(data);
    window.open("/pedidos?p=" + data.numero_proposta, "__blank");
  };

  loadQuantidade = async (e) => {
    await this.setState({ quantidade_alterada: true });
    await this.gerarPrecoBase(e);
    this.showAllFields();
  };

  render() {
    const {
      dados,
      items,
      produto_selecionado,
      nova_proposta,
      cores_embalagem,
      gravacao_embalagem,
      codigo_cor_embalagem_selecionada,
      codigo_impressao_embalagem_selecionada,
      boxproduto,
      listaDeEmpresa,
      dadosHistorico,
      funilVendas,
      motivo_perda,
      view_data_customer,
      view_data_proposal,
      view_data_product,
      view_data_tmk,
    } = this.state;

    var control_css = {
      data_customer: {
        arrow: view_data_customer
          ? { transition: "0.4s", transform: "rotate(180deg)" }
          : { transition: "0.3s", transform: "rotate(0deg)" },
        body: view_data_customer ? { transition: "0.4s", height: "180px" } : { transition: "0.4s", height: "0px" },
        content: view_data_customer ? { transition: "1s", display: "block" } : { transition: "0.2s", display: "none" },
        field_1:
          dados.razao_social_parceiro == null
            ? { transition: "0.6s", border: "0.8px solid #80bd01" }
            : { transition: "0.6s" },
        field_2:
          dados.razao_social_parceiro == null
            ? { transition: "0.6s", filter: "grayscale(0%)" }
            : dados.nome_contato == null
            ? { transition: "0.6s", border: "0.8px solid #80bd01" }
            : { transition: "0.6s" },
        custom:
          dados.nome_contato == null
            ? {
                transition: "0.6s",
                filter: "grayscale(100%)",
                transform: "scale(0.97,0.97)",
              }
            : {
                transition: "0.6s",
                filter: "grayscale(0%)",
                transform: "scale(1,1)",
              },
      },
      data_proposal: {
        arrow: view_data_proposal
          ? { transition: "0.4s", transform: "rotate(180deg)" }
          : { transition: "0.3s", transform: "rotate(0deg)" },
        header: dados.nome_contato == null ? { backgroundColor: "#bebebe" } : {},
        body: view_data_proposal ? { transition: "0.4s", height: "295px" } : { transition: "0.4s", height: "0px" },
        content: view_data_proposal ? { transition: "1s", display: "flex" } : { transition: "0.2s", display: "none" },
        field_1:
          dados.condicao_pagamento == null
            ? { transition: "0.6s", border: "0.8px solid #80bd01" }
            : { transition: "0.6s" },
        field_2:
          dados.condicao_pagamento == null
            ? { transition: "0.6s", filter: "grayscale(100%)" }
            : this.state.estimativa_selecionada == 0
            ? {
                transition: "0.6s",
                filter: "grayscale(0%)",
                border: "0.8px solid #80bd01",
              }
            : { transition: "0.6s" },
        custom:
          this.state.estimativa_selecionada == 0
            ? {
                transition: "0.6s",
                filter: "grayscale(100%)",
                transform: "scale(0.97,0.97)",
              }
            : {
                transition: "0.6s",
                filter: "grayscale(0%)",
                transform: "scale(1,1)",
              },
      },
      data_product: {
        arrow: view_data_product
          ? { transition: "0.4s", transform: "rotate(180deg)" }
          : { transition: "0.3s", transform: "rotate(0deg)" },
        body: view_data_product
          ? produto_selecionado == [] && items == []
            ? { transition: "0.4s", height: "auto" }
            : { transition: "0.4s", minHeight: "auto" }
          : { transition: "0.4s", height: "0px" },
        content: view_data_product
          ? {
              transition: "1s",
              display: "flex",
              width: 5 * 360 + "px",
            }
          : { transition: "0.2s", display: "none" },
        footer: view_data_product ? { transition: "1s", display: "block" } : { transition: "0.2s", display: "none" },
        header: this.state.codigo_proposta == null ? { backgroundColor: "#bebebe" } : {},
      },
      data_tmk: {
        arrow: view_data_tmk
          ? { transition: "0.4s", transform: "rotate(180deg)" }
          : { transition: "0.3s", transform: "rotate(0deg)" },
        body: view_data_tmk
          ? {
              transition: "0.4s",
              height: parseInt(dadosHistorico.length) * 125 + 300 + "px",
            }
          : { transition: "0.4s", height: "0px" },
        content: view_data_tmk ? { transition: "1s", display: "block" } : { transition: "0.2s", display: "none" },
        header: this.state.codigo_proposta == null ? { backgroundColor: "#bebebe" } : {},
      },
      footer: {
        body:
          items.length > 0 && view_data_product
            ? { transition: "0.6s", top: "calc(100vh - 73px)" }
            : { transition: "0.6s", top: "100vh" },
      },
    };

    return (
      <>
        <RegisterBudget>
          {dados.length == 0 && !nova_proposta ? (
            <Box>
              <RegisterBudgetResume>
                <RegisterBudgetResumeLoading
                  style={this.state.view_loading ? { display: "block" } : { display: "none" }}
                >
                  <RegisterBudgetResumeLoadingContent>
                    <img alt="loading" src={loading} />
                  </RegisterBudgetResumeLoadingContent>
                </RegisterBudgetResumeLoading>
                <RegisterBudgetResumeContent>
                  <RegisterBudgetResumeContentFilter>
                    <RegisterBudgetResumeContentFilterSelector>
                      <InputGroup>
                        <InputLeftAddon bgColor="#ff7e00" color="white" children="Nº PROPOSTA:" />
                        <Input
                          focusBorderColor="#ff7e00"
                          bgColor="white"
                          autoFocus
                          placeholder="Digite o número..."
                          name="numero_proposta"
                          type="text"
                          onChange={(e) => this.changeInputField(e, "codigo_proposta")}
                          onKeyPressCapture={(e) => this.changeInputField(e, "codigo_proposta")}
                        />
                      </InputGroup>
                    </RegisterBudgetResumeContentFilterSelector>
                    <RegisterBudgetResumeContentFilterButton onClick={() => this.filtrarProposta()}>
                      BUSCAR
                    </RegisterBudgetResumeContentFilterButton>
                    <RegisterBudgetResumeContentFilterButton onClick={() => this.novaProposta()}>
                      NOVA PROPOSTA
                    </RegisterBudgetResumeContentFilterButton>
                  </RegisterBudgetResumeContentFilter>
                </RegisterBudgetResumeContent>
              </RegisterBudgetResume>
              <RegisterBudgetResume>
                <RegisterBudgetResumeContentSubtext>
                  <h1>Busque por uma proposta existente ou crie uma nova proposta.</h1>
                </RegisterBudgetResumeContentSubtext>
              </RegisterBudgetResume>
            </Box>
          ) : (
            <>
              {this.state.view_parceiros_modal ? (
                <Modal
                  FecharModal={this.FecharModalParceiro}
                  seleciona={this.selecionaParceiro}
                  title_filter={{
                    data: [
                      {
                        title: "Nome",
                        field: "nome_parceiro",
                      },
                      {
                        title: "CPFCNPJ",
                        field: "cpfcnpj_parceiro",
                      },
                      {
                        title: "CODPARC",
                        field: "codigo_parceiro",
                      },
                    ],
                  }}
                  call={{
                    endpoint: ListaClientes,
                    param: [
                      {
                        field: "nome_parceiro",
                        find: "state",
                      },
                      {
                        field: "cpfcnpj_parceiro",
                        find: "state",
                      },
                      {
                        field: "codigo_parceiro",
                        find: "state",
                      },
                    ],
                  }}
                  config={{}}
                  checkboxField={[
                    {
                      title: "codigo_parceiro",
                      field: "codigo_parceiro",
                    },
                    {
                      title: "razao_social_parceiro",
                      field: "razao_social",
                    },
                    {
                      title: "cliente_especial",
                      field: "cliente_especial",
                    },
                    {
                      title: "numero_contrato",
                      field: "numero_contrato",
                    },
                    {
                      title: "quantidade_total_proposta",
                      field: "quantidade_total_proposta",
                    },
                    {
                      title: "quantidade_total_pedido",
                      field: "quantidade_total_pedido",
                    },
                    {
                      title: "valor_total_pedido",
                      field: "valor_total_pedido",
                    },
                    {
                      title: "situacao_pagamento",
                      field: "situacao_pagamento",
                    },
                  ]}
                  grid={[
                    {
                      title: "Codigo",
                      field: "codigo_parceiro",
                      function: "",
                    },

                    {
                      title: "Razão social",
                      field: "razao_social",
                      function: "",
                    },

                    {
                      title: "CPF / CNPJ",
                      field: "cpf_cnpj",
                      function: "",
                    },

                    {
                      title: "Vendedor",
                      field: "apelido",
                      function: "",
                    },
                  ]}
                />
              ) : (
                <div></div>
              )}
              {this.state.view_contatos_modal ? (
                <Modal
                  FecharModal={this.FecharModalContato}
                  seleciona={this.selecionaContato}
                  title_filter="NOME DO CONTATO"
                  autosearch={true}
                  call={{
                    endpoint: ListaContato,
                    param: [
                      {
                        field: "codigo_parceiro",
                        find: "config",
                      },
                      {
                        field: "texto_buscado",
                        find: "state",
                      },
                    ],
                  }}
                  config={{
                    codigo_parceiro: dados.codigo_parceiro,
                  }}
                  checkboxField={[
                    {
                      title: "codigo_contato",
                      field: "codigo_contato",
                    },
                    {
                      title: "nome_contato",
                      field: "nome_contato",
                    },
                    {
                      title: "email_contato",
                      field: "email_contato",
                    },
                    {
                      title: "telefone_contato",
                      field: "telefone_contato",
                    },
                    {
                      title: "celular_contato",
                      field: "celular_contato",
                    },
                  ]}
                  grid={[
                    {
                      title: "Nome",
                      field: "nome_contato",
                      function: "",
                    },

                    {
                      title: "Email",
                      field: "email_contato",
                      function: "",
                    },

                    {
                      title: "Telefone",
                      field: "telefone_contato",
                      function: "",
                    },

                    {
                      title: "Celular",
                      field: "celular_contato",
                      function: "",
                    },
                  ]}
                />
              ) : (
                <div></div>
              )}

              {this.state.view_total_pedidos_modal ? (
                <Modal
                  FecharModal={this.FecharModalTotalPedido}
                  seleciona={this.abrirPedidoSelecionado}
                  title_filter="sem filtro"
                  call={{
                    endpoint: ListaTotalOrcamentoPedido,
                    param: [
                      {
                        field: "codigo_tipo_venda",
                        find: "config",
                      },
                      {
                        field: "codigo_parceiro",
                        find: "config",
                      },
                    ],
                  }}
                  config={{
                    codigo_tipo_venda: "33,36",
                    codigo_parceiro: dados.codigo_parceiro,
                  }}
                  checkboxField={[
                    {
                      title: "numero_proposta",
                      field: "numero_proposta",
                    },
                  ]}
                  width={{ width: "1368px" }}
                  redirect_to_request={true}
                  grid={[
                    {
                      title: "Nº Proposta",
                      field: "numero_proposta",
                      function: "",
                    },
                    {
                      title: "Empresa",
                      field: "nome_fantasia",
                      function: "",
                    },
                    {
                      title: "Contato",
                      field: "nome_contato",
                      function: "",
                    },
                    {
                      title: "Email",
                      field: "email_contato",
                      function: "",
                    },
                    {
                      title: "Telefone",
                      field: "telefone_contato",
                      function: "",
                    },
                    {
                      title: "Data Negociação",
                      field: "data_negociacao",
                      function: "",
                    },
                    {
                      title: "Condição pagamento",
                      field: "condicao_pagamento",
                      function: "",
                    },
                    {
                      title: "Situação pagamento",
                      field: "situacao_pagamento",
                      function: "",
                    },
                  ]}
                />
              ) : (
                <div></div>
              )}
              {this.state.view_condicao_modal ? (
                <Modal
                  FecharModal={this.FecharModalCondicao}
                  seleciona={this.selecionaCondicao}
                  title_filter="CONDIÇÃO"
                  autosearch={true}
                  call={{
                    endpoint: ListaCondicaoPagamento,
                    param: [],
                  }}
                  config={{}}
                  checkboxField={[
                    {
                      title: "codigo_tipo_venda",
                      field: "codigo_tipo_venda",
                    },
                    {
                      title: "condicao_pagamento",
                      field: "condicao_pagamento",
                    },
                  ]}
                  grid={[
                    {
                      title: "Tipo",
                      field: "condicao_pagamento",
                      function: "",
                    },
                  ]}
                />
              ) : (
                <div></div>
              )}
              {this.state.view_visualizar_parceiro ? (
                <ModalParceiro
                  FecharModal={this.FecharModalVisualizarParceiro}
                  config={{
                    codigo_parceiro: dados.codigo_parceiro,
                    codigo_contato: dados.codigo_contato,
                    numero_pedido: this.state.codigo_proposta == null ? "" : this.state.codigo_proposta,
                  }}
                />
              ) : (
                <div></div>
              )}
              {this.state.view_lista_produtos_modal ? (
                <ModalCustom
                  fecharModalProduto={this.fecharModalProduto}
                  selecionaProduto={this.selecionaNovoProduto}
                />
              ) : (
                <div></div>
              )}

              {this.state.view_modal_layout ? (
                <ModalLayout
                  uploadFileDrive={this.uploadFileDrive}
                  closeModalLayout={this.closeModalLayout}
                  data_product={this.state.data_product_layout_modal}
                  data_layout={this.state.data_layout}
                />
              ) : (
                <></>
              )}
              {this.state.view_proposta_modal ? (
                <ModalVisualizarProposta
                  boxproduto={this.state.boxproduto}
                  proposal={this.state}
                  close={() => this.setState({ view_proposta_modal: false })}
                  items={items}
                />
              ) : (
                <></>
              )}
              <RegisterBudgetContent>
                {this.state.view_loading_save ? (
                  <RegisterBudgetContentLoading>
                    <RegisterBudgetContentLoadingContent>
                      <img alt="loading" src={loading} />
                    </RegisterBudgetContentLoadingContent>
                  </RegisterBudgetContentLoading>
                ) : (
                  <></>
                )}

                <RegisterBudgetContentHeader>
                  <RegisterBudgetContentHeaderBudget>
                    <p>
                      PROPOSTA: <strong>{dados.numero_proposta}</strong>{" "}
                      {Moment(dados.data_negociacao).format("DD/MM/YYYY HH:mm:ss")}
                    </p>
                    <RegisterBudgetContentHeaderBudgetLinDiv />
                  </RegisterBudgetContentHeaderBudget>
                </RegisterBudgetContentHeader>

                <DataCustomer this={this} dados={dados} control_css={control_css} />

                <DataProposal
                  this={this}
                  dados={dados}
                  control_css={control_css}
                  listaDeEmpresa={listaDeEmpresa}
                  changeFieldSpecialProposal={(e) => {
                    this.state.dados.proposta_especial = this.state.dados.proposta_especial == "S" ? "N" : "S";
                    this.setState({ updated: true });
                  }}
                />

                <RegisterBudgetContentDataProduct>
                  <RegisterBudgetContentDataProductHeader
                    style={control_css.data_product.header}
                    onClick={this.state.codigo_proposta != null ? () => this.AbrirItensPropostas() : () => {}}
                  >
                    <RegisterBudgetContentDataProductHeaderTitle
                      onClick={this.state.codigo_proposta != null ? () => this.AbrirItensPropostas() : () => {}}
                    >
                      <p>
                        DADOS <strong>DO PRODUTO</strong>
                      </p>
                    </RegisterBudgetContentDataProductHeaderTitle>
                    <span
                      onClick={this.state.codigo_proposta != null ? () => this.AbrirItensPropostas() : () => {}}
                      style={control_css.data_product.arrow}
                      className="icon icon-20 icon-arrow-down-white"
                    ></span>
                  </RegisterBudgetContentDataProductHeader>
                  <RegisterBudgetContentDataProductBody
                    style={
                      view_data_product
                        ? produto_selecionado.length == 0
                          ? {
                              transition: "0.4s",
                              height: "auto",
                            }
                          : {
                              transition: "0.4s",
                              height: "auto",
                            }
                        : {
                            transition: "0.4s",
                            height: "0px",
                          }
                    }
                  >
                    {/* <div className="innovation-crm-register-budget__content__data-product__body__steps">

                                        </div> */}
                    <RegisterBudgetContentDataProductBodyAbaProducts>
                      {this.state.loading_busca_produto ? (
                        <RegisterBudgetContentDataProductBodyAbaProductsLoading>
                          <img alt="loading" src={loadingBall} />
                        </RegisterBudgetContentDataProductBodyAbaProductsLoading>
                      ) : (
                        <></>
                      )}

                      {!this.state.loading_busca_produto && boxproduto.length == 0 ? (
                        <RegisterBudgetContentDataProductBodyAbaProductsEmpty>
                          <p>
                            Esta proposta ainda não possui itens, <strong>adicione um novo produto.</strong>
                          </p>
                        </RegisterBudgetContentDataProductBodyAbaProductsEmpty>
                      ) : (
                        <></>
                      )}

                      {boxproduto.map((data, idx) => {
                        return (
                          <RegisterBudgetContentDataProductBodyAbaProductsContent>
                            <RegisterBudgetContentDataProductBodyAbaProductsContentItem
                              style={
                                produto_selecionado != []
                                  ? produto_selecionado.codigo_produto == data.codigo_produto
                                    ? {
                                        backgroundColor: "#80bd01",
                                      }
                                    : {}
                                  : {}
                              }
                            >
                              <RegisterBudgetContentDataProductBodyAbaProductsContentItemTitle
                                data={toBase64(JSON.stringify(data))}
                                onClick={(e) => this.selecionaProduto(e)}
                              >
                                <p data={toBase64(JSON.stringify(data))} onClick={(e) => this.selecionaProduto(e)}>
                                  {data.nome_produto} - {data.referencia}
                                </p>
                              </RegisterBudgetContentDataProductBodyAbaProductsContentItemTitle>
                              <span
                                data={toBase64(JSON.stringify(data))}
                                onClick={(e) => this.selecionaProduto(e)}
                                style={
                                  produto_selecionado != []
                                    ? produto_selecionado.codigo_produto == data.codigo_produto
                                      ? {
                                          transition: "0.4s",
                                          transform: "rotate(180deg)",
                                        }
                                      : {
                                          transition: "0.3s",
                                          transform: "rotate(0deg)",
                                        }
                                    : {
                                        transition: "0.3s",
                                        transform: "rotate(0deg)",
                                      }
                                }
                                className="icon icon-20 icon-arrow-down-white"
                              ></span>
                            </RegisterBudgetContentDataProductBodyAbaProductsContentItem>

                            <RegisterBudgetContentDataProductBodyAbaProductsContentBody
                              style={
                                produto_selecionado != []
                                  ? produto_selecionado.codigo_produto == data.codigo_produto
                                    ? {
                                        transition: "1s",
                                        display: "flex",
                                        width: 5 * 360 + "px",
                                      }
                                    : {
                                        transition: "0.2s",
                                        display: "none",
                                      }
                                  : {
                                      transition: "0.2s",
                                      display: "none",
                                    }
                              }
                            >
                              {items?.map((item, idx) => {
                                // var height = this.state.prod_possui_emb ?
                                //                 item.token_embalagem == null ?
                                //                     item.cotacao_frete == undefined ? '930px' : '1215px':
                                //                         item.cotacao_frete == undefined ? '1155px' : '1435px':
                                //                             item.cotacao_frete == undefined ? '890px' : '1165px';

                                var minHeight = "auto";
                                var css =
                                  this.state.opcao_selecionada == item.num_order
                                    ? {
                                        transition: "0.6s",
                                        transform: "scale(1,1)",
                                        zIndex: 99,
                                        height: minHeight,
                                      }
                                    : {
                                        opacity: "0.6",
                                        transition: "0.3s",
                                        transform: "scale(0.95,0.95)",
                                        zIndex: 9,
                                        height: minHeight,
                                      };

                                if (data.codigo_produto == item.codigo_produto && item.tipo_produto == "PROD") {
                                  return (
                                    <RegisterBudgetContentDataProductBodyAbaProductsContentBodyProduct style={css}>
                                      <LinkOverlay onClick={() => this.selecionaOpcao(item.num_order)}>
                                        <RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductTicket>
                                          <p>
                                            opção <strong>{letra[item.num_order]}</strong>
                                          </p>
                                        </RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductTicket>
                                        <RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductTicketLayout
                                          data={toBase64(JSON.stringify(item))}
                                          onClick={(e) => this.selecionaLayout(e)}
                                        >
                                          <p data={toBase64(JSON.stringify(item))}>
                                            Selecionar <strong>Layout</strong>
                                          </p>
                                        </RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductTicketLayout>

                                        <RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductHeader>
                                          <RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductHeaderTitle>
                                            <p>
                                              {item.nome_produto} - {item.referencia}
                                            </p>
                                            <span
                                              data={toBase64(JSON.stringify(item))}
                                              onClick={(e) => this.deletarConfigProduto(e)}
                                              className="icon icon-20 icon-garbage-orange"
                                            ></span>
                                          </RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductHeaderTitle>
                                          <RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductHeaderImage>
                                            <img alt="data-img" src={data.img} />
                                          </RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductHeaderImage>
                                          <RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductHeaderDados>
                                            <RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductHeaderDadosDescricao>
                                              <p>
                                                {item.descricao !== null && item.descricao.length > 100
                                                  ? item.descricao.substring(0, 50) + "..."
                                                  : item.descricao}
                                              </p>
                                            </RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductHeaderDadosDescricao>
                                            <RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductHeaderDadosVerifiqueCubagem>
                                              <button>
                                                <span className="icon icon-40 icon-box-check-in"></span>
                                                <p>
                                                  VER CUBAGEM
                                                  <span className="tooltiptext">
                                                    <table>
                                                      <thead>
                                                        <tr>
                                                          <th>Qtd de Caixas</th>
                                                          <th>Dimensões caixa</th>
                                                          <th>Qtd por Caixa</th>
                                                          <th>Cubagem Unitaria</th>
                                                          <th>Cubagem Total</th>
                                                        </tr>
                                                      </thead>
                                                      <tbody>
                                                        <tr>
                                                          <td>{item.QtdCaixa}</td>
                                                          <td>{item.Caixa}</td>
                                                          <td>{item.QtdCaixa}</td>
                                                          <td>{item.CubagemUnitaria}</td>
                                                          <td>{item.CubagemTotal}</td>
                                                        </tr>
                                                      </tbody>
                                                    </table>
                                                  </span>
                                                </p>
                                              </button>
                                            </RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductHeaderDadosVerifiqueCubagem>
                                            <RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductHeaderDadosVerifiqueEstoque>
                                              <button>
                                                <span className="icon icon-40 icon-box-check-in"></span>
                                                <p>
                                                  VERIFICAR ESTOQUE
                                                  <span className="tooltiptext">
                                                    <table>
                                                      {item.informacao_estoque.split("ATUALIZADO:").map((data, idx) => {
                                                        if (data != "" && idx >= 4) {
                                                          return (
                                                            <tr>
                                                              <td>Atualizado:</td>
                                                              <td>{data.split("\t")[0].trim()}</td>
                                                              <td>Atende:</td>
                                                              <td>
                                                                {data.split("\t")[1].replace("ATENDE:", "").trim()}
                                                              </td>
                                                              <td>COR:</td>
                                                              <td>{data.split("\t")[2].replace("COR:", "").trim()}</td>
                                                            </tr>
                                                          );
                                                        }
                                                      })}
                                                    </table>
                                                  </span>
                                                </p>
                                              </button>
                                            </RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductHeaderDadosVerifiqueEstoque>
                                          </RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductHeaderDados>
                                        </RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductHeader>

                                        <RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductConfig>
                                          <RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductConfigColumn>
                                            <RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductConfigColumnField
                                              id={"cor-brinde-title-" + item.codigo_produto + "-" + item.num_order}
                                            >
                                              <p>COR DO BRINDE:</p>
                                            </RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductConfigColumnField>
                                            <RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductConfigColumnField
                                              id={"gravacao-brinde-title-" + item.codigo_produto + "-" + item.num_order}
                                            >
                                              <p>GRAVAÇÃO</p>
                                            </RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductConfigColumnField>
                                            <RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductConfigColumnField
                                              id={
                                                "impressao-brinde-title-" + item.codigo_produto + "-" + item.num_order
                                              }
                                            >
                                              <p>IMPRESSÕES</p>
                                            </RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductConfigColumnField>
                                            <RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductConfigColumnField
                                              id={"prazo-brinde-title-" + item.codigo_produto + "-" + item.num_order}
                                            >
                                              <p>PRAZO:</p>
                                            </RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductConfigColumnField>
                                            <RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductConfigColumnField
                                              id={
                                                "quantidade-brinde-title-" + item.codigo_produto + "-" + item.num_order
                                              }
                                            >
                                              <p>QUANTIDADE:</p>
                                            </RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductConfigColumnField>
                                            <RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductConfigColumnField
                                              id={"base-brinde-title-" + item.codigo_produto + "-" + item.num_order}
                                            >
                                              <p>REVENDEDOR:</p>
                                            </RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductConfigColumnField>
                                            {/* <RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductConfigColumnField className="innovation-crm-register-budget__content__data-product__body__aba-products__content__body__product__config__column__field">
                                                                                                    <p>COMISSÃO:</p>
                                                                                                </RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductConfigColumnField> */}
                                            <RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductConfigColumnField
                                              id={"preco-brinde-title-" + item.codigo_produto + "-" + item.num_order}
                                            >
                                              <p>PREÇO SITE:</p>
                                            </RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductConfigColumnField>
                                            {/* <RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductConfigColumnField className="innovation-crm-register-budget__content__data-product__body__aba-products__content__body__product__config__column__field">
                                                                                                    <p>VALOR COM ST:</p>
                                                                                                </RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductConfigColumnField> */}
                                            <RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductConfigColumnField
                                              id={"unit-brinde-title-" + item.codigo_produto + "-" + item.num_order}
                                            >
                                              <p>VALOR UNITÁRIO:</p>
                                            </RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductConfigColumnField>
                                            <RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductConfigColumnField
                                              id={"total-brinde-title-" + item.codigo_produto + "-" + item.num_order}
                                            >
                                              <p>VALOR TOTAL:</p>
                                            </RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductConfigColumnField>
                                          </RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductConfigColumn>
                                          <RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductConfigColumnLarge>
                                            <RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductConfigColumnField
                                              id={"cor-brinde-field-" + item.codigo_produto + "-" + item.num_order}
                                            >
                                              <select
                                                data={toBase64(JSON.stringify(item))}
                                                onChange={(e) => this.changePasso(e, "id_cor", "select")}
                                                id={"cor-brinde-field-" + item.codigo_produto + "-" + item.num_order}
                                              >
                                                {/* {this.state.cores_produto.map(data=>{
                                                                                                            if(parseInt(data.codigo_cor) != parseInt(item.id_cor)){
                                                                                                                return <option value={data.codigo_cor}>{data.descricao_cor}</option>
                                                                                                            }
                                                                                                        })} */}

                                                {this.state.cores_produto.map((data) => {
                                                  // if(parseInt(data.codigo_cor) == parseInt(item.id_cor)){
                                                  return <option value={data.codigo_cor}>{data.descricao_cor}</option>;
                                                  // }
                                                })}
                                              </select>
                                            </RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductConfigColumnField>
                                            <RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductConfigColumnField
                                              id={"gravacao-brinde-field-" + item.codigo_produto + "-" + item.num_order}
                                            >
                                              <select
                                                data={toBase64(JSON.stringify(item))}
                                                onChange={(e) => this.changePasso(e, "id_impressao", "select")}
                                                id={
                                                  "gravacao-brinde-field-" + item.codigo_produto + "-" + item.num_order
                                                }
                                              >
                                                {/* {this.state.gravacao_produto.map(data=>{
                                                                                                            if(parseInt(data.codigo_impressao) != parseInt(item.id_impressao)){
                                                                                                                return <option value={data.codigo_impressao}>{data.descricao_site}</option>
                                                                                                            }
                                                                                                        })} */}

                                                {this.state.gravacao_produto.map((data) => {
                                                  // if(parseInt(data.codigo_impressao) == parseInt(item.id_impressao)){
                                                  return (
                                                    <option value={data.codigo_impressao}>{data.descricao_site}</option>
                                                  );
                                                  // }
                                                })}
                                              </select>
                                            </RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductConfigColumnField>
                                            <RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductConfigColumnField
                                              id={
                                                "impressao-brinde-field-" + item.codigo_produto + "-" + item.num_order
                                              }
                                            >
                                              <select
                                                data={toBase64(JSON.stringify(item))}
                                                onChange={(e) => this.changePasso(e, "qtd_batida", "select")}
                                                id={
                                                  "impressao-brinde-field-" + item.codigo_produto + "-" + item.num_order
                                                }
                                              >
                                                {/*
                                                                                                        {this.state.batidas_produto.map(data=>{
                                                                                                            if(data != parseInt(item.qtd_batida)){
                                                                                                                return <option value={data}>{data}</option>
                                                                                                            }
                                                                                                        })} */}

                                                {this.state.batidas_produto.map((data) => {
                                                  // if(data == parseInt(item.qtd_batida)){
                                                  return <option value={data}>{data}</option>;
                                                  // }
                                                })}
                                              </select>
                                            </RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductConfigColumnField>
                                            <RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductConfigColumnField
                                              id={"prazo-brinde-field-" + item.codigo_produto + "-" + item.num_order}
                                            >
                                              <select
                                                data={toBase64(JSON.stringify(item))}
                                                onChange={(e) => this.changePasso(e, "id_prazo_entrega", "select")}
                                                id={"prazo-brinde-field-" + item.codigo_produto + "-" + item.num_order}
                                              >
                                                {/* {this.state.prazos_produto.map(data=>{
                                                                                                            if(parseInt(data.codigo) != parseInt(item.id_prazo_entrega)){
                                                                                                                return <option value={data.codigo}>{data.descricao}</option>
                                                                                                            }
                                                                                                        })} */}

                                                {this.state.prazos_produto.map((data) => {
                                                  // if(parseInt(data.codigo) == parseInt(item.id_prazo_entrega)){
                                                  return <option value={data.codigo}>{data.descricao}</option>;
                                                  // }
                                                })}
                                              </select>
                                            </RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductConfigColumnField>
                                            <RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductConfigColumnFieldCep
                                              id={
                                                "quantidade-brinde-field-" + item.codigo_produto + "-" + item.num_order
                                              }
                                            >
                                              <input
                                                data={toBase64(JSON.stringify(item))}
                                                onChange={(e) => this.changePasso(e, "qtd_negociada", "input")}
                                                onKeyPress={(e) => (e.key == "Enter" ? this.loadQuantidade(e) : null)}
                                                value={parseInt(item.qtd_negociada)}
                                                id={
                                                  "quantidade-brinde-field-" +
                                                  item.codigo_produto +
                                                  "-" +
                                                  item.num_order
                                                }
                                                type="text"
                                              />
                                              <button
                                                data={toBase64(JSON.stringify(item))}
                                                id={
                                                  "quantidade-brinde-field-" +
                                                  item.codigo_produto +
                                                  "-" +
                                                  item.num_order
                                                }
                                                onClick={(e) => this.loadQuantidade(e)}
                                              >
                                                OK
                                              </button>
                                            </RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductConfigColumnFieldCep>
                                            <RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductConfigColumnField
                                              id={"base-brinde-field-" + item.codigo_produto + "-" + item.num_order}
                                            >
                                              <p id={"base-brinde-field-" + item.codigo_produto + "-" + item.num_order}>
                                                R$ {Math.round(parseFloat(item.valor_unitario_revendedor) * 100) / 100}
                                              </p>
                                            </RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductConfigColumnField>
                                            {/* <div className="innovation-crm-register-budget__content__data-product__body__aba-products__content__body__product__config__column__field">
                                                                                                    <input  data={toBase64(JSON.stringify(item))}
                                                                                                            onChange={(e)=>this.changePasso(e,'valor_comis','input')}
                                                                                                            value={item.valor_comis}
                                                                                                            type="text"/>
                                                                                                </div> */}
                                            <RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductConfigColumnField
                                              id={"preco-brinde-field-" + item.codigo_produto + "-" + item.num_order}
                                            >
                                              {/* <p id={"preco-brinde-field-"+item.codigo_produto+"-"+item.num_order}>{(Math.round(parseFloat(item.preco_loja) * 100) / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</p> */}
                                              <p
                                                id={"preco-brinde-field-" + item.codigo_produto + "-" + item.num_order}
                                              >
                                                R$ {Math.round(parseFloat(item.valor_unitario_site) * 100) / 100}
                                              </p>
                                            </RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductConfigColumnField>
                                            {/* <div className="innovation-crm-register-budget__content__data-product__body__aba-products__content__body__product__config__column__field">
                                                                                                    <p>{(Math.round(parseFloat(item.preco_base) * 100) / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })} <strong>(14%)</strong></p>
                                                                                                </div> */}
                                            <RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductConfigColumnField
                                              id={"unit-brinde-field-" + item.codigo_produto + "-" + item.num_order}
                                            >
                                              <label>R$ </label>
                                              <input
                                                data={toBase64(JSON.stringify(item))}
                                                onChange={(e) => this.changePasso(e, "valor_unitario", "input")}
                                                value={Math.round(parseFloat(item.valor_unitario) * 100) / 100}
                                                id={"unit-brinde-field-" + item.codigo_produto + "-" + item.num_order}
                                                type="number"
                                              />
                                            </RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductConfigColumnField>
                                            <RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductConfigColumnField
                                              id={"total-brinde-field-" + item.codigo_produto + "-" + item.num_order}
                                            >
                                              <p
                                                id={"total-brinde-field-" + item.codigo_produto + "-" + item.num_order}
                                              >
                                                <stong>
                                                  {isNaN(Math.round(parseFloat(item.valor_total)))
                                                    ? "R$ 0,00"
                                                    : Math.round(parseFloat(item.valor_total)).toLocaleString("pt-BR", {
                                                        style: "currency",
                                                        currency: "BRL",
                                                      })}
                                                </stong>
                                              </p>
                                            </RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductConfigColumnField>
                                          </RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductConfigColumnLarge>
                                        </RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductConfig>

                                        <RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductEmb
                                          style={
                                            this.state.prod_possui_emb
                                              ? item.token_embalagem == null
                                                ? {
                                                    transition: "0.5s",
                                                    height: "50px",
                                                    display: "block",
                                                  }
                                                : {
                                                    transition: "0.5s",
                                                    display: "block",
                                                  }
                                              : {
                                                  display: "none",
                                                }
                                          }
                                        >
                                          <RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductEmbHeader>
                                            <RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductEmbHeaderTitle
                                              data={toBase64(JSON.stringify(item))}
                                              onClick={
                                                item.token_embalagem == null
                                                  ? (e) => this.adicionaEmbalagem(e)
                                                  : () => {}
                                              }
                                            >
                                              {item.token_embalagem != null ? (
                                                <>
                                                  <p>EMBALAGEM</p>
                                                  <span
                                                    data={toBase64(JSON.stringify(item))}
                                                    onClick={(e) => this.deletaEmbalagem(e)}
                                                    className="icon icon-20 icon-garbage-white"
                                                  ></span>
                                                </>
                                              ) : (
                                                <>
                                                  <p
                                                    data={toBase64(
                                                      JSON.stringify(item)
                                                    )} /*onClick={(e)=>this.adicionaEmbalagem(e)}*/
                                                  >
                                                    ADICIONAR EMBALAGEM
                                                  </p>
                                                  <span
                                                    data={toBase64(JSON.stringify(item))}
                                                    /*onClick={(e)=>this.adicionaEmbalagem(e)}*/ className="icon icon-20 icon-plus-green"
                                                  ></span>
                                                </>
                                              )}
                                            </RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductEmbHeaderTitle>

                                            {this.state.loading_adiciona_embalagem.sequencia == item.sequencia &&
                                            this.state.loading_adiciona_embalagem.status ? (
                                              <RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductEmbHeaderLoading>
                                                <img alt="loadingball" src={loadingBall} />
                                              </RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductEmbHeaderLoading>
                                            ) : (
                                              <></>
                                            )}

                                            <RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductEmbHeaderConfig
                                              style={
                                                item.token_embalagem == null
                                                  ? {
                                                      transition: "0.5s",
                                                      height: "0px",
                                                    }
                                                  : {
                                                      transition: "0.5s",
                                                    }
                                              }
                                            >
                                              <RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductEmbHeaderConfigImage
                                                style={
                                                  item.token_embalagem == null
                                                    ? {
                                                        transition: "0.5s",
                                                        display: "none",
                                                      }
                                                    : {
                                                        transition: "1s",
                                                        display: "block",
                                                      }
                                                }
                                              >
                                                {item.codigo_cor_embalagem_selecionada != null &&
                                                item.codigo_impressao_embalagem_selecionada != null ? (
                                                  item.codigo_impressao_embalagem_selecionada.descricao_impressao ==
                                                  "BOX SEM IMPRESSÃO" ? (
                                                    <img
                                                      alt="embalagem"
                                                      src={
                                                        "https://innovationbrindes.com.br/images/embalagem" +
                                                        item.codigo_cor_embalagem_selecionada.imagem_box
                                                      }
                                                    />
                                                  ) : item.codigo_impressao_embalagem_selecionada.descricao_impressao ==
                                                    "LOCALIZADA" ? (
                                                    <img
                                                      alt="embalagem"
                                                      src={
                                                        "https://innovationbrindes.com.br/images/embalagem" +
                                                        item.codigo_cor_embalagem_selecionada.imagem_print
                                                      }
                                                    />
                                                  ) : (
                                                    <img
                                                      alt="embalagem"
                                                      src={
                                                        "https://innovationbrindes.com.br/images/embalagem" +
                                                        item.codigo_cor_embalagem_selecionada.imagem_plus +
                                                        "/plus/plus1.jpg"
                                                      }
                                                    />
                                                  )
                                                ) : (
                                                  <img
                                                    alt="box-branco"
                                                    src={
                                                      "https://innovationbrindes.com.br/images/embalagem/quadrada_pequena/box/box-branco.jpg"
                                                    }
                                                  />
                                                )}
                                              </RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductEmbHeaderConfigImage>
                                              <RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductEmbHeaderConfigOptions
                                                style={
                                                  item.token_embalagem == null
                                                    ? {
                                                        transition: "0.5s",
                                                        display: "none",
                                                      }
                                                    : {
                                                        transition: "1s",
                                                        display: "block",
                                                      }
                                                }
                                              >
                                                <RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductEmbHeaderConfigOptionsField>
                                                  <select
                                                    data={toBase64(JSON.stringify(item))}
                                                    onChange={(e) => this.selecionaGravacaoEmbalagem(e)}
                                                  >
                                                    {item.gravacao_embalagem != undefined ? (
                                                      item.gravacao_embalagem.map((data) => {
                                                        if (
                                                          parseInt(data.codigo_impressao) ==
                                                          parseInt(
                                                            item.codigo_impressao_embalagem_selecionada.codigo_impressao
                                                          )
                                                        ) {
                                                          return (
                                                            <option value={data.codigo_impressao}>
                                                              {data.descricao_impressao}
                                                            </option>
                                                          );
                                                        }
                                                      })
                                                    ) : (
                                                      <></>
                                                    )}
                                                    {item.gravacao_embalagem != undefined ? (
                                                      item.gravacao_embalagem.map((data) => {
                                                        if (
                                                          parseInt(data.codigo_impressao) !=
                                                          parseInt(
                                                            item.codigo_impressao_embalagem_selecionada.codigo_impressao
                                                          )
                                                        ) {
                                                          return (
                                                            <option value={data.codigo_impressao}>
                                                              {data.descricao_impressao}
                                                            </option>
                                                          );
                                                        }
                                                      })
                                                    ) : (
                                                      <></>
                                                    )}
                                                    {/* {this.state.prazos_produto.map(data=>{
                                                                                                                    if(parseInt(data.codigo) != parseInt(item.id_prazo_entrega)){
                                                                                                                        return <option value={data.codigo}>{data.descricao}</option>
                                                                                                                    }
                                                                                                                })}


                                                                                                                {item.gravacao_embalagem != undefined ?
                                                                                                                    item.gravacao_embalagem.map(data=>{
                                                                                                                        return <option value={data.codigo_impressao}>{data.descricao_impressao}</option>
                                                                                                                    }) : <option value={0}>Adicione Embalagem</option>
                                                                                                                } */}
                                                  </select>
                                                </RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductEmbHeaderConfigOptionsField>
                                                <RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductEmbHeaderConfigOptionsField>
                                                  <select
                                                    data={toBase64(JSON.stringify(item))}
                                                    onChange={(e) => this.selecionaCorEmbalagem(e)}
                                                  >
                                                    {/* {item.cores_embalagem != undefined ?
                                                                                                                    item.cores_embalagem.map(data=>{
                                                                                                                        return <option value={data.codigo_cor}>{data.descricao_cor}</option>
                                                                                                                    }) : <option value={0}>Adicione Embalagem</option>
                                                                                                                } */}

                                                    {item.cores_embalagem != undefined ? (
                                                      item.cores_embalagem.map((data) => {
                                                        if (
                                                          parseInt(data.codigo_cor) ==
                                                          parseInt(item.codigo_cor_embalagem_selecionada.codigo_cor)
                                                        ) {
                                                          return (
                                                            <option value={data.codigo_cor}>
                                                              {data.descricao_cor}
                                                            </option>
                                                          );
                                                        }
                                                      })
                                                    ) : (
                                                      <></>
                                                    )}
                                                    {item.cores_embalagem != undefined ? (
                                                      item.cores_embalagem.map((data) => {
                                                        if (
                                                          parseInt(data.codigo_cor) !=
                                                          parseInt(item.codigo_cor_embalagem_selecionada.codigo_cor)
                                                        ) {
                                                          return (
                                                            <option value={data.codigo_cor}>
                                                              {data.descricao_cor}
                                                            </option>
                                                          );
                                                        }
                                                      })
                                                    ) : (
                                                      <></>
                                                    )}
                                                  </select>
                                                </RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductEmbHeaderConfigOptionsField>
                                                <RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductEmbHeaderConfigOptionsCub>
                                                  <button>
                                                    <span className="icon icon-30 icon-eye-green"></span>
                                                    <p>
                                                      VER CUBAGEM
                                                      <span className="tooltiptext">
                                                        {item.token_embalagem != null &&
                                                        item.cubagem_embalagem != undefined ? (
                                                          <table>
                                                            <thead>
                                                              <tr>
                                                                {/* <th>Altura</th>
                                                                                                                                        <th>Largura</th>
                                                                                                                                        <th>Comprimento</th>
                                                                                                                                        <th>Peso Caixa</th> */}
                                                                <th>Qtd de Caixas</th>
                                                                <th>Dimensões caixa</th>
                                                                <th>Qtd por Caixa</th>
                                                                <th>Cubagem Unitaria</th>
                                                                <th>Cubagem Total</th>
                                                              </tr>
                                                            </thead>
                                                            <tbody>
                                                              <tr>
                                                                {/* <td>{item.cubagem_embalagem.Altura}</td>
                                                                                                                                        <td>{item.cubagem_embalagem.Largura}</td>
                                                                                                                                        <td>{item.cubagem_embalagem.Comprimento}</td>
                                                                                                                                        <td>{item.cubagem_embalagem.PesoCaixa}</td> */}
                                                                <td>{item.cubagem_embalagem.QtdCaixa}</td>
                                                                <td>{item.cubagem_embalagem.Caixa}</td>
                                                                <td>{item.cubagem_embalagem.QtdCaixa}</td>
                                                                <td>{item.cubagem_embalagem.CubagemUnitaria}</td>
                                                                <td>{item.cubagem_embalagem.CubagemTotal}</td>
                                                              </tr>
                                                            </tbody>
                                                          </table>
                                                        ) : (
                                                          <></>
                                                        )}
                                                      </span>
                                                    </p>
                                                  </button>
                                                </RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductEmbHeaderConfigOptionsCub>
                                              </RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductEmbHeaderConfigOptions>
                                            </RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductEmbHeaderConfig>
                                          </RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductEmbHeader>
                                          <RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductEmbConfig
                                            style={
                                              item.token_embalagem == null
                                                ? {
                                                    transition: "0.5s",
                                                    display: "none",
                                                  }
                                                : {
                                                    transition: "1s",
                                                    display: "flex",
                                                  }
                                            }
                                          >
                                            <RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductEmbConfigColumn>
                                              <RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductEmbConfigColumnField>
                                                <p>VALOR UNITÁRIO</p>
                                              </RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductEmbConfigColumnField>
                                              <RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductEmbConfigColumnField>
                                                <p>VALOR TOTAL:</p>
                                              </RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductEmbConfigColumnField>
                                            </RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductEmbConfigColumn>
                                            <RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductEmbConfigColumnLarge>
                                              <RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductEmbConfigColumnField>
                                                {item.codigo_impressao_embalagem_selecionada != undefined ? (
                                                  <p>
                                                    {item.codigo_impressao_embalagem_selecionada != undefined
                                                      ? item.codigo_impressao_embalagem_selecionada.valor != undefined
                                                        ? (
                                                            Math.round(
                                                              parseFloat(
                                                                item.codigo_impressao_embalagem_selecionada.valor.replace(
                                                                  ",",
                                                                  "."
                                                                )
                                                              ) * 100
                                                            ) / 100
                                                          ).toLocaleString("pt-BR", {
                                                            style: "currency",
                                                            currency: "BRL",
                                                          })
                                                        : "0,00"
                                                      : "0,00"}
                                                  </p>
                                                ) : (
                                                  <p>
                                                    {item.cubagem_embalagem != undefined
                                                      ? (
                                                          Math.round(
                                                            parseFloat(item.cubagem_embalagem.CubagemUnitaria) * 100
                                                          ) / 100
                                                        ).toLocaleString("pt-BR", {
                                                          style: "currency",
                                                          currency: "BRL",
                                                        })
                                                      : "0,00"}
                                                  </p>
                                                )}
                                              </RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductEmbConfigColumnField>
                                              <RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductEmbConfigColumnField>
                                                {item.codigo_impressao_embalagem_selecionada != undefined ? (
                                                  <p>
                                                    {item.codigo_impressao_embalagem_selecionada != undefined
                                                      ? item.codigo_impressao_embalagem_selecionada.valor != undefined
                                                        ? (
                                                            Math.round(
                                                              parseFloat(
                                                                item.codigo_impressao_embalagem_selecionada.valor.replace(
                                                                  ",",
                                                                  "."
                                                                )
                                                              ) *
                                                                parseFloat(item.qtd_negociada) *
                                                                100
                                                            ) / 100
                                                          ).toLocaleString("pt-BR", {
                                                            style: "currency",
                                                            currency: "BRL",
                                                          })
                                                        : "0,00"
                                                      : "0,00"}
                                                  </p>
                                                ) : (
                                                  <p>
                                                    {item.cubagem_embalagem != undefined
                                                      ? (
                                                          Math.round(
                                                            parseFloat(item.cubagem_embalagem.CubagemUnitaria) *
                                                              parseFloat(item.qtd_negociada) *
                                                              100
                                                          ) / 100
                                                        ).toLocaleString("pt-BR", {
                                                          style: "currency",
                                                          currency: "BRL",
                                                        })
                                                      : "R$ 0,00"}
                                                  </p>
                                                )}

                                                {/* <p>{item.cubagem_embalagem != undefined ? (Math.round((parseFloat(item.cubagem_embalagem.CubagemUnitaria)*parseFloat(item.qtd_negociada))*100)/100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) : 'R$ 0,00'}</p> */}
                                              </RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductEmbConfigColumnField>
                                            </RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductEmbConfigColumnLarge>
                                          </RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductEmbConfig>
                                        </RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductEmb>

                                        <RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductSubtitle>
                                          <p>FRETE</p>
                                        </RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductSubtitle>

                                        <RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductFrete
                                          style={
                                            item.cotacao_frete == undefined
                                              ? item.item_salvo != undefined && item.item_salvo
                                                ? {
                                                    transition: "0.4s",
                                                    height: "210px",
                                                  }
                                                : {
                                                    transition: "0.4s",
                                                    height: "125px",
                                                  }
                                              : {
                                                  transition: "0.4s",
                                                  height: "390px",
                                                }
                                          }
                                        >
                                          <RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductFreteDigiteCep>
                                            <RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductFreteDigiteCepColumn>
                                              <RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductFreteDigiteCepColumnField>
                                                <p>DIGITE O CEP:</p>
                                              </RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductFreteDigiteCepColumnField>
                                              <RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductFreteDigiteCepColumnField>
                                                <p>TIPO FRETE:</p>
                                              </RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductFreteDigiteCepColumnField>
                                              <RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductFreteDigiteCepColumnFieldLarge>
                                                <p>
                                                  {this.ifnull(item.endereco_selecionado, "") == ""
                                                    ? item.frete_site
                                                    : item.endereco_selecionado}
                                                </p>
                                              </RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductFreteDigiteCepColumnFieldLarge>
                                            </RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductFreteDigiteCepColumn>
                                            <RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductEmbConfigColumnLarge>
                                              <RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductFreteDigiteCepColumnFieldCep>
                                                <input
                                                  data={toBase64(JSON.stringify(item))}
                                                  onKeyPress={(e) => (e.key == "Enter" ? this.buscaCotacao(e) : null)}
                                                  onChange={(e) => this.changePasso(e, "cep_selecionado", "input")}
                                                  type="text"
                                                />
                                                <button
                                                  data={toBase64(JSON.stringify(item))}
                                                  onClick={(e) => this.buscaCotacao(e)}
                                                >
                                                  OK
                                                </button>
                                              </RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductFreteDigiteCepColumnFieldCep>
                                              <RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductFreteDigiteCepColumnFieldCep>
                                                <select
                                                  data={toBase64(JSON.stringify(item))}
                                                  onChange={(e) => this.changePasso(e, "cif_fob", "select")}
                                                  id={"cif-fob-" + item.codigo_produto + "-" + item.num_order}
                                                >
                                                  <option value={"C"}>CIF</option>
                                                  <option value={"F"}>FOB</option>
                                                  <option value={"T"}>TERCEIROS</option>
                                                  <option value={"S"}>SEM FRETE</option>
                                                </select>
                                              </RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductFreteDigiteCepColumnFieldCep>
                                              <RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductFreteDigiteCepColumnField></RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductFreteDigiteCepColumnField>
                                            </RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductEmbConfigColumnLarge>
                                          </RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductFreteDigiteCep>

                                          <RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductFreteGrid
                                            style={
                                              item.cotacao_frete != undefined || item.cotacao_frete != null
                                                ? {
                                                    transition: "0.3s",
                                                    height: "270px",
                                                  }
                                                : {
                                                    transition: "0.4s",
                                                    height: "0px",
                                                  }
                                            }
                                          >
                                            {item.cotacao_frete != undefined || item.cotacao_frete != null ? (
                                              <RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductFreteGridContent>
                                                {item.cidade != "São Paulo" ? (
                                                  <RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductFreteGridContentColumn>
                                                    <RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductFreteGridContentColumnCelColorGray>
                                                      <img alt="mais-barato" src={maisBarato} />
                                                    </RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductFreteGridContentColumnCelColorGray>
                                                    <RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductFreteGridContentColumnCelColorGray>
                                                      <p>{item.cotacao_frete[0].name.substring(0, 12) + "..."}</p>
                                                    </RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductFreteGridContentColumnCelColorGray>
                                                    <RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductFreteGridContentColumnCelColorGray>
                                                      <p>
                                                        De {item.cotacao_frete[0].min} a {item.cotacao_frete[0].max}{" "}
                                                        Dias
                                                      </p>
                                                    </RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductFreteGridContentColumnCelColorGray>
                                                    <RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductFreteGridContentColumnCelColorGray>
                                                      <p>{item.cotacao_frete[0].price}</p>
                                                    </RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductFreteGridContentColumnCelColorGray>
                                                    <RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductFreteGridContentColumnCelColorGray>
                                                      <input
                                                        checked={
                                                          item.frete_selecionado == undefined
                                                            ? false
                                                            : item.config_frete.type == item.cotacao_frete[0].type
                                                            ? true
                                                            : false
                                                        }
                                                        data={toBase64(JSON.stringify(item))}
                                                        value={JSON.stringify(item.cotacao_frete[0])}
                                                        onChange={(e) => this.changeInputFrete(e)}
                                                        type="radio"
                                                      />
                                                    </RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductFreteGridContentColumnCelColorGray>
                                                  </RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductFreteGridContentColumn>
                                                ) : (
                                                  <></>
                                                )}

                                                {item.cidade != "São Paulo" ? (
                                                  <RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductFreteGridContentColumn>
                                                    <RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductFreteGridContentColumnCel>
                                                      <img alt="mais-barato" src={maisRapido} />
                                                    </RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductFreteGridContentColumnCel>
                                                    <RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductFreteGridContentColumnCel>
                                                      <p>{item.cotacao_frete[1].name.substring(0, 12) + "..."}</p>
                                                    </RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductFreteGridContentColumnCel>
                                                    <RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductFreteGridContentColumnCel>
                                                      <p>
                                                        De {item.cotacao_frete[1].min} a {item.cotacao_frete[1].max}{" "}
                                                        Dias
                                                      </p>
                                                    </RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductFreteGridContentColumnCel>
                                                    <RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductFreteGridContentColumnCel>
                                                      <p>{item.cotacao_frete[1].price}</p>
                                                    </RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductFreteGridContentColumnCel>
                                                    <RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductFreteGridContentColumnCel>
                                                      <input
                                                        checked={
                                                          item.frete_selecionado == undefined
                                                            ? false
                                                            : item.config_frete.type == item.cotacao_frete[1].type
                                                            ? true
                                                            : false
                                                        }
                                                        data={toBase64(JSON.stringify(item))}
                                                        value={JSON.stringify(item.cotacao_frete[1])}
                                                        onChange={(e) => this.changeInputFrete(e)}
                                                        type="radio"
                                                      />
                                                    </RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductFreteGridContentColumnCel>
                                                  </RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductFreteGridContentColumn>
                                                ) : (
                                                  <></>
                                                )}

                                                <RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductFreteGridContentColumn>
                                                  <RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductFreteGridContentColumnCelColorGray>
                                                    <img alt="selo-gratis" src={clienteRetira} />
                                                  </RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductFreteGridContentColumnCelColorGray>
                                                  <RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductFreteGridContentColumnCelColorGray>
                                                    <p>CLIENTE RETIRA</p>
                                                  </RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductFreteGridContentColumnCelColorGray>
                                                  <RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductFreteGridContentColumnCelColorGray>
                                                    <p>De 1 a 2 Dias</p>
                                                  </RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductFreteGridContentColumnCelColorGray>
                                                  <RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductFreteGridContentColumnCelColorGray>
                                                    <img
                                                      alt="selo-gratis"
                                                      className="selo-gratis"
                                                      src={selogratisverde}
                                                    />
                                                  </RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductFreteGridContentColumnCelColorGray>
                                                  <RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductFreteGridContentColumnCelColorGray>
                                                    <input
                                                      checked={
                                                        item.frete_selecionado == undefined
                                                          ? false
                                                          : item.config_frete.type == "gratis-cliente-retira"
                                                          ? true
                                                          : false
                                                      }
                                                      data={toBase64(JSON.stringify(item))}
                                                      value={JSON.stringify({
                                                        name: "CLIENTE RETIRA",
                                                        max: "2",
                                                        min: "1",
                                                        price: "0",
                                                        type: "gratis-cliente-retira",
                                                        prazo_producao: item.cotacao_frete[0].prazo_producao,
                                                      })}
                                                      onChange={(e) => this.changeInputFrete(e)}
                                                      type="radio"
                                                    />
                                                  </RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductFreteGridContentColumnCelColorGray>
                                                </RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductFreteGridContentColumn>

                                                {item.cidade == "São Paulo" ? (
                                                  <RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductFreteGridContentColumn>
                                                    <RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductFreteGridContentColumnCelColorGray>
                                                      <img alt="nosso-carro" src={nossoCarro} />
                                                    </RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductFreteGridContentColumnCelColorGray>
                                                    <RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductFreteGridContentColumnCelColorGray>
                                                      <p>NOSSO CARRO</p>
                                                    </RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductFreteGridContentColumnCelColorGray>
                                                    <RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductFreteGridContentColumnCelColorGray>
                                                      <p>De 1 a 2 Dias</p>
                                                    </RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductFreteGridContentColumnCelColorGray>
                                                    <RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductFreteGridContentColumnCelColorGray>
                                                      <img className="selo-gratis" src={selogratislaranja} />
                                                    </RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductFreteGridContentColumnCelColorGray>
                                                    <RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductFreteGridContentColumnCelColorGray>
                                                      <input
                                                        checked={
                                                          item.frete_selecionado == undefined
                                                            ? false
                                                            : item.config_frete.type == "gratis-nosso-carro"
                                                            ? true
                                                            : false
                                                        }
                                                        data={toBase64(JSON.stringify(item))}
                                                        value={JSON.stringify({
                                                          name: "NOSSO CARRO",
                                                          max: "2",
                                                          min: "1",
                                                          price: "0",
                                                          type: "gratis-nosso-carro",
                                                          prazo_producao: item.cotacao_frete[0].prazo_producao,
                                                        })}
                                                        onChange={(e) => this.changeInputFrete(e)}
                                                        type="radio"
                                                      />
                                                    </RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductFreteGridContentColumnCelColorGray>
                                                  </RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductFreteGridContentColumn>
                                                ) : (
                                                  <></>
                                                )}
                                              </RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductFreteGridContent>
                                            ) : (
                                              <></>
                                            )}
                                            <RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductFreteGridResumo
                                              style={
                                                item.frete_selecionado != undefined ||
                                                item.frete_selecionado != null ||
                                                (item.item_salvo != undefined && item.item_salvo)
                                                  ? {
                                                      transition: "0.3s",
                                                      display: "block",
                                                    }
                                                  : {
                                                      transition: "0.4s",
                                                      display: "none",
                                                    }
                                              }
                                            >
                                              <RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductFreteGridResumoContent>
                                                <RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductFreteGridResumoContentRow>
                                                  <p>Valor total do item: </p>
                                                  <strong>
                                                    {(
                                                      Math.round(parseFloat(item.valor_total) * 100) / 100
                                                    ).toLocaleString("pt-BR", {
                                                      style: "currency",
                                                      currency: "BRL",
                                                    })}
                                                  </strong>
                                                </RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductFreteGridResumoContentRow>
                                                {item.dados_embalagem != undefined ? (
                                                  <RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductFreteGridResumoContentRow>
                                                    <p>Valor total da embalagem: </p>
                                                    <strong>
                                                      {(item.codigo_impressao_embalagem_selecionada != undefined
                                                        ? item.codigo_impressao_embalagem_selecionada.valor != undefined
                                                          ? parseFloat(
                                                              item.codigo_impressao_embalagem_selecionada.valor.replace(
                                                                ",",
                                                                "."
                                                              )
                                                            ) * parseFloat(item.qtd_negociada)
                                                          : 0
                                                        : 0
                                                      ).toLocaleString("pt-BR", {
                                                        style: "currency",
                                                        currency: "BRL",
                                                      })}
                                                    </strong>
                                                  </RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductFreteGridResumoContentRow>
                                                ) : (
                                                  <></>
                                                )}
                                                {item.frete_selecionado != undefined ||
                                                item.frete_selecionado != null ||
                                                (item.item_salvo != undefined && item.item_salvo) ? (
                                                  <>
                                                    <RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductFreteGridResumoContentRow>
                                                      <p>Valor do frete: </p>
                                                      {item.config_frete != undefined ? (
                                                        <strong>
                                                          {(
                                                            Math.round(
                                                              parseFloat(item.config_frete.preco_formatado) * 100
                                                            ) / 100
                                                          ).toLocaleString("pt-BR", {
                                                            style: "currency",
                                                            currency: "BRL",
                                                          })}
                                                        </strong>
                                                      ) : item.frete_site != null ? (
                                                        <strong>
                                                          {(
                                                            Math.round(
                                                              parseFloat(
                                                                item.frete_site
                                                                  .split("Preço: ")[1]
                                                                  .replaceAll("R$", "")
                                                                  .replaceAll(".", "")
                                                                  .replaceAll(",", ".")
                                                                  .trim()
                                                              ) * 100
                                                            ) / 100
                                                          ).toLocaleString("pt-BR", {
                                                            style: "currency",
                                                            currency: "BRL",
                                                          })}
                                                        </strong>
                                                      ) : (
                                                        <strong>0</strong>
                                                      )}
                                                    </RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductFreteGridResumoContentRow>
                                                    <RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductFreteGridResumoContentRow>
                                                      <p>Subtotal: </p>
                                                      {item.config_frete != undefined ? (
                                                        <strong>
                                                          {(
                                                            Math.round(
                                                              (parseFloat(item.valor_total) +
                                                                parseFloat(item.config_frete.preco_formatado)) *
                                                                100
                                                            ) /
                                                              100 +
                                                            (item.codigo_impressao_embalagem_selecionada != undefined
                                                              ? item.codigo_impressao_embalagem_selecionada.valor !=
                                                                undefined
                                                                ? parseFloat(
                                                                    item.codigo_impressao_embalagem_selecionada.valor.replace(
                                                                      ",",
                                                                      "."
                                                                    )
                                                                  ) * parseFloat(item.qtd_negociada)
                                                                : 0
                                                              : 0)
                                                          ).toLocaleString("pt-BR", {
                                                            style: "currency",
                                                            currency: "BRL",
                                                          })}
                                                        </strong>
                                                      ) : item.frete_site != null ? (
                                                        <strong>
                                                          {(
                                                            Math.round(
                                                              (parseFloat(item.valor_total) +
                                                                parseFloat(
                                                                  item.frete_site
                                                                    .split("Preço: ")[1]
                                                                    .replaceAll("R$", "")
                                                                    .replaceAll(".", "")
                                                                    .replaceAll(",", ".")
                                                                    .trim()
                                                                )) *
                                                                100
                                                            ) /
                                                              100 +
                                                            (item.codigo_impressao_embalagem_selecionada != undefined
                                                              ? item.codigo_impressao_embalagem_selecionada.valor !=
                                                                undefined
                                                                ? parseFloat(
                                                                    item.codigo_impressao_embalagem_selecionada.valor.replace(
                                                                      ",",
                                                                      "."
                                                                    )
                                                                  ) * parseFloat(item.qtd_negociada)
                                                                : 0
                                                              : 0)
                                                          ).toLocaleString("pt-BR", {
                                                            style: "currency",
                                                            currency: "BRL",
                                                          })}
                                                        </strong>
                                                      ) : (
                                                        <strong>
                                                          {(
                                                            Math.round(parseFloat(item.valor_total) * 100) / 100 +
                                                            (item.codigo_impressao_embalagem_selecionada != undefined
                                                              ? item.codigo_impressao_embalagem_selecionada.valor !=
                                                                undefined
                                                                ? parseFloat(
                                                                    item.codigo_impressao_embalagem_selecionada.valor.replace(
                                                                      ",",
                                                                      "."
                                                                    )
                                                                  ) * parseFloat(item.qtd_negociada)
                                                                : 0
                                                              : 0)
                                                          ).toLocaleString("pt-BR", {
                                                            style: "currency",
                                                            currency: "BRL",
                                                          })}
                                                        </strong>
                                                      )}
                                                    </RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductFreteGridResumoContentRow>
                                                  </>
                                                ) : (
                                                  <></>
                                                )}
                                              </RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductFreteGridResumoContent>
                                            </RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductFreteGridResumo>
                                          </RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductFreteGrid>

                                          {/* <div className="innovation-crm-register-budget__content__data-product__body__aba-products__content__body__product__config__column">
                                            <div className="innovation-crm-register-budget__content__data-product__body__aba-products__content__body__product__config__column__field">
                                                <p>DIGITE O CEP:</p>
                                            </div>
                                            <div className="innovation-crm-register-budget__content__data-product__body__aba-products__content__body__product__config__column__field innovation-crm-register-budget__content__data-product__body__aba-products__content__body__product__config__column__field--large">
                                                <p>{item.endereco_selecionado}</p>
                                            </div>
                                            <div className="innovation-crm-register-budget__content__data-product__body__aba-products__content__body__product__config__column__field innovation-crm-register-budget__content__data-product__body__aba-products__content__body__product__config__column__field--large-height">
                                                <p>FRETE:</p>
                                            </div>
                                        </div>
                                        <div className="innovation-crm-register-budget__content__data-product__body__aba-products__content__body__product__config__column innovation-crm-register-budget__content__data-product__body__aba-products__content__body__product__config__column--large">
                                            <div className="innovation-crm-register-budget__content__data-product__body__aba-products__content__body__product__config__column__field innovation-crm-register-budget__content__data-product__body__aba-products__content__body__product__config__column__field--cep">
                                                <input data={toBase64(JSON.stringify(item))} onChange={(e)=>this.changePasso(e,'cep_selecionado','input')} type="text"/>
                                                <button data={toBase64(JSON.stringify(item))} onClick={(e)=>this.buscaCotacao(e)}>OK</button>
                                            </div>
                                            <div className="innovation-crm-register-budget__content__data-product__body__aba-products__content__body__product__config__column__field">

                                            </div>
                                            <div className="innovation-crm-register-budget__content__data-product__body__aba-products__content__body__product__config__column__field innovation-crm-register-budget__content__data-product__body__aba-products__content__body__product__config__column__field--large-height">
                                                <select>
                                                    {item.cotacao_frete != undefined ?
                                                        item.cotacao_frete.map(data=>{
                                                            return  <>
                                                                    <option value={JSON.stringify(data)}>{data.name.length > 25 ? data.name.substr(0,25)+'..':data.name}</option>
                                                                    <option disabled>{data.max+' Dias '+'| '+data.price}</option>
                                                                    </>
                                                        }) : <option value={0}>Digite o cep</option>
                                                    }
                                                </select>
                                            </div>
                                        </div> */}
                                        </RegisterBudgetContentDataProductBodyAbaProductsContentBodyProductFrete>
                                        <RegisterBudgetContentDataProductControl
                                          style={
                                            item.frete_selecionado != undefined ||
                                            (item.item_carregado != undefined && item.item_carregado)
                                              ? {
                                                  transition: "0.2s",
                                                  display: "block",
                                                }
                                              : {
                                                  transition: "0.2s",
                                                  display: "none",
                                                }
                                          }
                                        >
                                          {this.state.loading_salvar_item.sequencia == item.sequencia &&
                                          this.state.loading_salvar_item.status ? (
                                            <RegisterBudgetContentDataProductControlLoading>
                                              <img alt="loading-ball" src={loadingBall} />
                                            </RegisterBudgetContentDataProductControlLoading>
                                          ) : (
                                            <button
                                              style={
                                                item.frete_selecionado != undefined ||
                                                (item.item_carregado != undefined && item.item_carregado)
                                                  ? {
                                                      transition: "0.4s",
                                                      transform: "scale(1,1)",
                                                    }
                                                  : {
                                                      transition: "0.4s",
                                                      transform: "scale(0,0)",
                                                    }
                                              }
                                              data={toBase64(JSON.stringify(item))}
                                              onClick={(e) => this.salvarItemProposta(e)}
                                            >
                                              <p data={toBase64(JSON.stringify(item))}>SALVAR ALTERAÇÕES</p>
                                            </button>
                                          )}

                                          <RegisterBudgetContentDataProductControlGrid
                                            style={
                                              item.item_salvo != undefined && item.item_salvo
                                                ? {
                                                    transition: "0.2s",
                                                    display: "flex",
                                                  }
                                                : {
                                                    transition: "0.2s",
                                                    display: "none",
                                                  }
                                            }
                                          >
                                            {/* <RegisterBudgetContentDataProductControlGridColumn>
                                                <RegisterBudgetContentDataProductControlGridColumnItem>
                                                    <span className="icon icon-35 icon-money-white"></span>
                                                </RegisterBudgetContentDataProductControlGridColumnItem>
                                                <RegisterBudgetContentDataProductControlGridColumnItem>
                                                    <p>Negociar produto</p>
                                                </RegisterBudgetContentDataProductControlGridColumnItem>
                                            </RegisterBudgetContentDataProductControlGridColumn> */}
                                            <RegisterBudgetContentDataProductControlGridColumn>
                                              <RegisterBudgetContentDataProductControlGridColumnItem>
                                                <span
                                                  data={toBase64(JSON.stringify(item))}
                                                  onClick={async (e) => this.duplicarProduto(e)}
                                                  className="icon icon-30 icon-duplicate-white"
                                                ></span>
                                              </RegisterBudgetContentDataProductControlGridColumnItem>
                                              <RegisterBudgetContentDataProductControlGridColumnItem>
                                                <p
                                                  data={toBase64(JSON.stringify(item))}
                                                  onClick={async (e) => this.duplicarProduto(e)}
                                                >
                                                  Duplicar produto
                                                </p>
                                              </RegisterBudgetContentDataProductControlGridColumnItem>
                                            </RegisterBudgetContentDataProductControlGridColumn>
                                            {/* <RegisterBudgetContentDataProductControlGridColumn>
                                                                                                    <RegisterBudgetContentDataProductControlGridColumnItem>
                                                                                                        <span className="icon icon-35 icon-layout-white"></span>
                                                                                                    </RegisterBudgetContentDataProductControlGridColumnItem>
                                                                                                    <RegisterBudgetContentDataProductControlGridColumnItem>
                                                                                                        <p>Solicitar layout</p>
                                                                                                    </RegisterBudgetContentDataProductControlGridColumnItem>
                                                                                                </RegisterBudgetContentDataProductControlGridColumn> */}
                                            <RegisterBudgetContentDataProductControlGridColumn>
                                              <RegisterBudgetContentDataProductControlGridColumnItem>
                                                <input type="radio" />
                                              </RegisterBudgetContentDataProductControlGridColumnItem>
                                              <RegisterBudgetContentDataProductControlGridColumnItemLast>
                                                <p>
                                                  Não exibir <br />
                                                  proposta
                                                </p>
                                              </RegisterBudgetContentDataProductControlGridColumnItemLast>
                                            </RegisterBudgetContentDataProductControlGridColumn>
                                          </RegisterBudgetContentDataProductControlGrid>
                                        </RegisterBudgetContentDataProductControl>
                                      </LinkOverlay>
                                    </RegisterBudgetContentDataProductBodyAbaProductsContentBodyProduct>
                                  );
                                }
                              })}
                            </RegisterBudgetContentDataProductBodyAbaProductsContentBody>
                          </RegisterBudgetContentDataProductBodyAbaProductsContent>
                        );
                      })}
                    </RegisterBudgetContentDataProductBodyAbaProducts>
                  </RegisterBudgetContentDataProductBody>
                  <RegisterBudgetContentDataProductBodyFooter style={control_css.data_product.footer}>
                    <RegisterBudgetContentDataProductBodyFooterContent
                      onClick={() =>
                        this.setState({
                          view_lista_produtos_modal: true,
                        })
                      }
                    >
                      <p>NOVO PRODUTO</p>
                    </RegisterBudgetContentDataProductBodyFooterContent>
                  </RegisterBudgetContentDataProductBodyFooter>
                </RegisterBudgetContentDataProduct>
                <RegisterBudgetContentDataProductBodyFooterContentDataTMK>
                  <RegisterBudgetContentDataProductBodyFooterContentDataTMKHeader
                    style={control_css.data_tmk.header}
                    onClick={this.state.codigo_proposta != null ? () => this.AbrirHistoricoTMK() : () => {}}
                  >
                    <RegisterBudgetContentDataProductBodyFooterContentDataTMKHeaderTitle>
                      <p>
                        HISTÓRICO <strong>TELE MKT</strong>
                      </p>
                    </RegisterBudgetContentDataProductBodyFooterContentDataTMKHeaderTitle>
                    <span style={control_css.data_tmk.arrow} className="icon icon-20 icon-arrow-down-white"></span>
                  </RegisterBudgetContentDataProductBodyFooterContentDataTMKHeader>
                  <RegisterBudgetContentDataProductBodyFooterContentDataTMKBody style={control_css.data_tmk.body}>
                    <RegisterBudgetContentDataProductBodyFooterContentDataTMKBodyContent
                      style={control_css.data_tmk.content}
                    >
                      <RegisterBudgetContentDataProductBodyFooterContentDataTMKBodyContentHeader>
                        <div></div>
                        {this.state.loading_tmk ? (
                          <RegisterBudgetContentDataProductBodyAbaProductsLoading>
                            <img alt="loading-ball" src={loadingBall} />
                          </RegisterBudgetContentDataProductBodyAbaProductsLoading>
                        ) : (
                          <RegisterBudgetContentDataProductBodyFooterContentDataTMKBodyContentHeaderContent>
                            <label>
                              <strong>Data para retornar:</strong>
                            </label>
                            <InputDataRetorno
                              w="200px"
                              id="data-tmk"
                              type="date"
                              onChange={(e) => this.handleDataRetorno(e)}
                            />
                            <RegisterBudgetContentDataProductBodyFooterContentDataTMKBodyContentHeaderContentField>
                              <label>
                                <strong>Funil de venda:</strong>
                              </label>
                              <Select
                                iconColor="#80bd01"
                                size="md"
                                id="funil-tmk"
                                onChange={(e) => this.selectFunilVenda(e)}
                              >
                                {funilVendas.map((data) => {
                                  return <option value={data.codigo_funil_venda}>{data.tipo_funil_venda}</option>;
                                })}
                              </Select>
                            </RegisterBudgetContentDataProductBodyFooterContentDataTMKBodyContentHeaderContentField>
                            <RegisterBudgetContentDataProductBodyFooterContentDataTMKBodyContentHeaderContentField>
                              <label>
                                <strong>Perdido:</strong>
                              </label>
                              <input
                                type="checkbox"
                                onClick={() =>
                                  this.setState({
                                    check_perdido: !this.state.check_perdido,
                                  })
                                }
                              />
                              <Select
                                size="md"
                                iconColor="#80bd01"
                                disabled={!this.state.check_perdido}
                                onChange={(e) => this.selectTipoMotivo(e)}
                              >
                                <option value=""></option>
                                {motivo_perda.map((data) => {
                                  return <option value={data.codigo_motivo}>{data.descricao_motivo}</option>;
                                })}
                              </Select>
                            </RegisterBudgetContentDataProductBodyFooterContentDataTMKBodyContentHeaderContentField>
                          </RegisterBudgetContentDataProductBodyFooterContentDataTMKBodyContentHeaderContent>
                        )}
                      </RegisterBudgetContentDataProductBodyFooterContentDataTMKBodyContentHeader>
                      <RegisterBudgetContentDataProductBodyFooterContentDataTMKBodyContentRow>
                        <RegisterBudgetContentDataProductBodyFooterContentDataTMKBodyContentRowContent>
                          <RegisterBudgetContentDataProductBodyFooterContentDataTMKBodyContentRowContentHighlight>
                            Registrar <strong>Histórico</strong>
                          </RegisterBudgetContentDataProductBodyFooterContentDataTMKBodyContentRowContentHighlight>
                          <RegisterBudgetContentDataProductBodyFooterContentDataTMKBodyContentRowContentInput
                            id="desc-tmk"
                            onChange={(e) => this.handleDescricaoTMK(e)}
                          ></RegisterBudgetContentDataProductBodyFooterContentDataTMKBodyContentRowContentInput>
                          <RegisterBudgetContentDataProductBodyFooterContentDataTMKBodyContentRowContentButton>
                            <button onClick={() => this.enviarTMK()}>ENVIAR</button>
                          </RegisterBudgetContentDataProductBodyFooterContentDataTMKBodyContentRowContentButton>
                        </RegisterBudgetContentDataProductBodyFooterContentDataTMKBodyContentRowContent>
                      </RegisterBudgetContentDataProductBodyFooterContentDataTMKBodyContentRow>
                      <RegisterBudgetContentDataProductBodyFooterContentDataTMKBodyContentGrid>
                        <RegisterBudgetContentDataProductBodyFooterContentDataTMKBodyContentGridContent>
                          {dadosHistorico.map((data) => {
                            return (
                              <RegisterBudgetContentDataProductBodyFooterContentDataTMKBodyContentGridContentCard>
                                <RegisterBudgetContentDataProductBodyFooterContentDataTMKBodyContentGridContentCardHeader>
                                  <RegisterBudgetContentDataProductBodyFooterContentDataTMKBodyContentGridContentCardHeaderColumn>
                                    <p>DATA DO HISTÓRICO</p>
                                    <p>{Moment(data.data_historico).format("DD/MM/YYYY")}</p>
                                  </RegisterBudgetContentDataProductBodyFooterContentDataTMKBodyContentGridContentCardHeaderColumn>
                                  <RegisterBudgetContentDataProductBodyFooterContentDataTMKBodyContentGridContentCardHeaderColumn>
                                    <p>HORÁRIO</p>
                                    <p>{Moment(data.data_historico).format("HH:mm:ss")}</p>
                                  </RegisterBudgetContentDataProductBodyFooterContentDataTMKBodyContentGridContentCardHeaderColumn>
                                  <RegisterBudgetContentDataProductBodyFooterContentDataTMKBodyContentGridContentCardHeaderColumn>
                                    <p>DATA PARA RETORNAR</p>
                                    <p>{Moment(data.data_retorno).format("DD/MM/YYYY")}</p>
                                  </RegisterBudgetContentDataProductBodyFooterContentDataTMKBodyContentGridContentCardHeaderColumn>
                                  <RegisterBudgetContentDataProductBodyFooterContentDataTMKBodyContentGridContentCardHeaderColumn>
                                    <p>ETAPA DO FUNIL DE VENDA</p>
                                    <p>{data.descricao_funil_venda.trim()}</p>
                                  </RegisterBudgetContentDataProductBodyFooterContentDataTMKBodyContentGridContentCardHeaderColumn>
                                  <RegisterBudgetContentDataProductBodyFooterContentDataTMKBodyContentGridContentCardHeaderColumn>
                                    <p>SE PERDIDO INDICAR O MOTIVO</p>
                                    <p></p>
                                  </RegisterBudgetContentDataProductBodyFooterContentDataTMKBodyContentGridContentCardHeaderColumn>
                                </RegisterBudgetContentDataProductBodyFooterContentDataTMKBodyContentGridContentCardHeader>
                                <RegisterBudgetContentDataProductBodyFooterContentDataTMKBodyContentGridContentCardObs>
                                  <RegisterBudgetContentDataProductBodyFooterContentDataTMKBodyContentGridContentCardObsHighlights>
                                    Observações
                                  </RegisterBudgetContentDataProductBodyFooterContentDataTMKBodyContentGridContentCardObsHighlights>
                                  <p>{data.observacao_historico}</p>
                                  <RegisterBudgetContentDataProductBodyFooterContentDataTMKBodyContentRowInformationPlus>
                                    <span className="icon icon-20 icon-plus-green"></span> Detalhes
                                  </RegisterBudgetContentDataProductBodyFooterContentDataTMKBodyContentRowInformationPlus>
                                </RegisterBudgetContentDataProductBodyFooterContentDataTMKBodyContentGridContentCardObs>
                              </RegisterBudgetContentDataProductBodyFooterContentDataTMKBodyContentGridContentCard>
                            );
                          })}
                        </RegisterBudgetContentDataProductBodyFooterContentDataTMKBodyContentGridContent>
                      </RegisterBudgetContentDataProductBodyFooterContentDataTMKBodyContentGrid>
                    </RegisterBudgetContentDataProductBodyFooterContentDataTMKBodyContent>
                  </RegisterBudgetContentDataProductBodyFooterContentDataTMKBody>
                </RegisterBudgetContentDataProductBodyFooterContentDataTMK>
                <ContentMarginBottom></ContentMarginBottom>
              </RegisterBudgetContent>
              <BudgetFooter style={control_css.footer.body}>
                <BudgetFooterContent>
                  <BudgetFooterContentItem onClick={() => this.verProposta()}>
                    <span onClick={() => this.verProposta()} className="icon icon-30 icon-visualizar-green"></span>
                    <p onClick={() => this.verProposta()}>
                      <strong onClick={() => this.verProposta()}>VISUALIZAR</strong> PROPOSTA
                    </p>
                  </BudgetFooterContentItem>
                  <BudgetFooterContentDivisor></BudgetFooterContentDivisor>
                  <BudgetFooterContentItem onClick={() => this.EnviarPropostaCliente()}>
                    <span className="icon icon-30 icon-enviar-green"></span>
                    <p>
                      <strong>ENVIAR</strong> PROPOSTA
                    </p>
                  </BudgetFooterContentItem>
                  <BudgetFooterContentDivisor></BudgetFooterContentDivisor>
                  <BudgetFooterContentItem onClick={() => this.GerarPedidoCliente()}>
                    <span className="icon icon-30 icon-gerar-pedido-green"></span>
                    <p>
                      <strong>GERAR</strong> PEDIDO
                    </p>
                  </BudgetFooterContentItem>
                </BudgetFooterContent>
              </BudgetFooter>
            </>
          )}
        </RegisterBudget>
      </>
    );
  }
}

class Modal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dados: [],
      view_loading: false,
      texto_buscado: "",
      codigo_parceiro: "",
      cpfcnpj_parceiro: "",
      nome_parceiro: "",
    };
    this.config = this.props.config;
  }

  componentDidMount() {
    if (this.props.title_filter == "sem filtro" || this.props.autosearch) {
      this.filtrar();
    }
  }

  filtrar = async () => {
    try {
      this.setState({ view_loading: true });
      // console.log(this.props.call.param);

      const response = await this.props.call.endpoint.post(
        "",
        "{" +
          this.props.call.param.map((data) => {
            return '"' + [data.field] + '":"' + this[this.ifnull(data.find, "")][this.ifnull(data.field, "")] + '"';
          }) +
          "}"
      );
      var data = response.data;
      this.setState({ dados: data, view_loading: false });
    } catch (error) {
      console.log(Object.keys(error), error.message);
    }
  };

  changeInputField = async (e, value) => {
    this.setState({ [value]: e.target.value });
    if (e.key == "Enter") {
      this.filtrar();
    }
  };

  ifnull(a, b) {
    if (a == undefined || a == null || a == "") {
      return b;
    } else {
      return a;
    }
  }

  render() {
    const { dados } = this.state;

    return (
      <RegisterBudgetModal>
        <RegisterBudgetModalContent style={this.props.width != undefined ? this.props.width : {}}>
          <RegisterBudgetModalContentFilter>
            <RegisterBudgetModalContentFilterSelector>
              {typeof this.props.title_filter == "object" ? (
                this.props.title_filter.data.map((data) => {
                  return (
                    <>
                      <label> {data.title}: </label>
                      <input
                        name={data.field}
                        type="text"
                        onKeyPress={(e) => this.changeInputField(e, data.field)}
                        onChange={(e) => this.changeInputField(e, data.field)}
                      />
                    </>
                  );
                })
              ) : (
                <>
                  {this.props.title_filter != "sem filtro" ? <label>{this.props.title_filter}: </label> : <div></div>}
                  {this.props.title_filter != "sem filtro" ? (
                    <input
                      name="texto_buscado"
                      type="text"
                      onKeyPress={(e) => this.changeInputField(e, "texto_buscado")}
                      onChange={(e) => this.changeInputField(e, "texto_buscado")}
                    />
                  ) : (
                    <div></div>
                  )}
                </>
              )}
            </RegisterBudgetModalContentFilterSelector>
            <RegisterBudgetResumeContentModalFilterButton onClick={() => this.filtrar()}>
              BUSCAR
            </RegisterBudgetResumeContentModalFilterButton>
            <RegisterBudgetResumeContentModalFilterButtonWhite onClick={() => this.props.FecharModal()}>
              FECHAR
            </RegisterBudgetResumeContentModalFilterButtonWhite>
          </RegisterBudgetModalContentFilter>
          <ModalContentGrid>
            <ModalContentGridLoading style={this.state.view_loading ? { display: "block" } : { display: "none" }}>
              <ModalContentGridLoadingContent>
                <img alt="loading" src={loading} />
              </ModalContentGridLoadingContent>
            </ModalContentGridLoading>
            <ModalContentGridColumn>
              <table>
                <thead>
                  <tr>
                    {this.props.redirect_to_request ? <th>Ver pedido</th> : <th></th>}
                    {this.props.grid.map((data) => {
                      return <th>{this.ifnull(data.title, "")}</th>;
                    })}
                  </tr>
                </thead>
                <tbody>
                  {dados.length != 0 ? (
                    dados.map((data) => {
                      return (
                        <tr>
                          <td className="checkbox-size">
                            <label className="control control--checkbox">
                              <input
                                type="checkbox"
                                onClick={(e) => this.props.seleciona(e)}
                                value={
                                  "{" +
                                  this.props.checkboxField.map((obj) => {
                                    return '"' + [obj.title] + '":"' + this.ifnull(data[obj.field], "") + '"';
                                  }) +
                                  "}"
                                }
                              />
                              <div className="control__indicator__orange"></div>
                            </label>
                          </td>
                          {this.props.grid.map((obj) => {
                            return <td>{this.ifnull(data[obj.field], "")}</td>;
                          })}
                        </tr>
                      );
                    })
                  ) : (
                    <div></div>
                  )}
                </tbody>
              </table>
            </ModalContentGridColumn>
          </ModalContentGrid>
        </RegisterBudgetModalContent>
      </RegisterBudgetModal>
    );
  }
}

class ModalParceiro extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dados: [],
      view_loading: false,
      texto_buscado: "",
    };
    this.config = this.props.config;
  }

  componentDidMount() {
    this.filtrar();
  }

  filtrar = async () => {
    try {
      const response = await dadosParceiro.get(
        this.config.codigo_parceiro + "/" + this.config.codigo_contato + "/" + this.config.numero_pedido
      );
      var dados = response.data;

      await this.setState({ dados: dados });
      this.getInformacoesEndereco();
    } catch (error) {
      console.log(Object.keys(error), error.message);
    }
  };

  getInformacoesEndereco = async (e) => {
    try {
      // var CEP_API = await fetch(`https://api.postmon.com.br/v1/cep/`+this.state.dados.cep);
      var CEP_API = await fetch(`https://viacep.com.br/ws/${this.state.dados.cep}/json/`);
      var CEP_API_REST = await CEP_API.json();

      var dados_parceiro = this.state.dados;

      dados_parceiro.bairro = CEP_API_REST.bairro;
      dados_parceiro.municipio = CEP_API_REST.localidade;
      dados_parceiro.uf = CEP_API_REST.uf;
      dados_parceiro.logradouro = CEP_API_REST.logradouro;

      await this.setState({ dados: dados_parceiro });
    } catch (error) {
      console.log(Object.keys(error), error.message);
    }
  };

  cpfCnpj = (v) => {
    //Remove tudo o que não é dígito
    v = v.replace(/\D/g, "");

    if (v.length < 14) {
      //CPF

      //Coloca um ponto entre o terceiro e o quarto dígitos
      v = v.replace(/(\d{3})(\d)/, "$1.$2");

      //Coloca um ponto entre o terceiro e o quarto dígitos
      //de novo (para o segundo bloco de números)
      v = v.replace(/(\d{3})(\d)/, "$1.$2");

      //Coloca um hífen entre o terceiro e o quarto dígitos
      v = v.replace(/(\d{3})(\d{1,2})$/, "$1-$2");
    } else {
      //CNPJ

      //Coloca ponto entre o segundo e o terceiro dígitos
      v = v.replace(/^(\d{2})(\d)/, "$1.$2");

      //Coloca ponto entre o quinto e o sexto dígitos
      v = v.replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3");

      //Coloca uma barra entre o oitavo e o nono dígitos
      v = v.replace(/\.(\d{3})(\d)/, ".$1/$2");

      //Coloca um hífen depois do bloco de quatro dígitos
      v = v.replace(/(\d{4})(\d)/, "$1-$2");
    }
    return v;
  };

  numeroTelefone = (v) => {
    //Remove tudo o que não é dígito
    v = v.replace(/\D/g, "");

    if (v.length == 11) {
      //CPF
      // 11959688769
      //Coloca um ponto entre o terceiro e o quarto dígitos
      v = v.replace(/(\d{0})(\d)/, "$1($2");

      //Coloca um ponto entre o terceiro e o quarto dígitos
      v = v.replace(/(\d{2})(\d)/, "$1) $2");

      //Coloca um ponto entre o terceiro e o quarto dígitos
      v = v.replace(/(\d{5})(\d)/, "$1-$2");

      // //Coloca um ponto entre o terceiro e o quarto dígitos
      // //de novo (para o segundo bloco de números)
      // v=v.replace(/(\d{4})(\d)/,"$1.$2")

      // //Coloca um hífen entre o terceiro e o quarto dígitos
      // v=v.replace(/(\d{3})(\d{1,2})$/,"$1-$2")
    } else {
      //CNPJ
      //Coloca ponto entre o segundo e o terceiro dígitos
      // v=v.replace(/^(\d{2})(\d)/,"$1.$2")
      // //Coloca ponto entre o quinto e o sexto dígitos
      // v=v.replace(/^(\d{2})\.(\d{3})(\d)/,"$1.$2.$3")
      // //Coloca uma barra entre o oitavo e o nono dígitos
      // v=v.replace(/\.(\d{3})(\d)/,".$1/$2")
      // //Coloca um hífen depois do bloco de quatro dígitos
      // v=v.replace(/(\d{4})(\d)/,"$1-$2")
    }
    return v;
  };

  render() {
    const { dados } = this.state;

    return (
      <RegisterBudgetModal>
        <RegisterBudgetModalContentParceiro>
          <RegisterBudgetModalContentFilterParceiro>
            <RegisterBudgetResumeContentFilterButton onClick={() => this.filtrar()}>
              BUSCAR
            </RegisterBudgetResumeContentFilterButton>
            <RegisterBudgetResumeContentFilterButtonWhite onClick={() => this.props.FecharModal()}>
              FECHAR
            </RegisterBudgetResumeContentFilterButtonWhite>
          </RegisterBudgetModalContentFilterParceiro>
          <RegisterBudgetModalContentDadosParceiro>
            <RegisterBudgetModalContentDadosParceiroColumn>
              <RegisterBudgetModalContentDadosParceiroColumnTitle>
                <strong>Cadastro Pessoa Jurídica</strong>
              </RegisterBudgetModalContentDadosParceiroColumnTitle>
              <RegisterBudgetModalContentDadosParceiroColumnSubtitle>
                <p>
                  <strong>Informações</strong>
                </p>
                <RegisterBudgetModalContentDadosParceiroColumnSublinhado />
              </RegisterBudgetModalContentDadosParceiroColumnSubtitle>
              <RegisterBudgetModalContentDadosParceiroColumnItem>
                <p>
                  CPF:{" "}
                  <strong>{dados.cpf_cnpj_parceiro != undefined ? this.cpfCnpj(dados.cpf_cnpj_parceiro) : ""}</strong>
                </p>
              </RegisterBudgetModalContentDadosParceiroColumnItem>
              <RegisterBudgetModalContentDadosParceiroColumnItem>
                <p>
                  Razão Social: <strong>{dados.razao_social_parceiro}</strong>
                </p>
              </RegisterBudgetModalContentDadosParceiroColumnItem>
              <RegisterBudgetModalContentDadosParceiroColumnItem>
                <p>
                  Inscrição Estadual: <strong>{dados.inscricao_estadual}</strong>
                </p>
              </RegisterBudgetModalContentDadosParceiroColumnItem>
              <SubtitleEnd>
                <p>
                  <strong>Endereço</strong>
                </p>
                <RegisterBudgetModalContentDadosParceiroColumnSublinhado />
              </SubtitleEnd>
              <RegisterBudgetModalContentDadosParceiroColumnItem>
                <p>
                  CEP: <strong>{dados.cep}</strong>
                </p>
              </RegisterBudgetModalContentDadosParceiroColumnItem>
              <RegisterBudgetModalContentDadosParceiroColumnItem>
                <p>
                  Logradouro: <strong>{dados.logradouro}</strong>
                </p>
              </RegisterBudgetModalContentDadosParceiroColumnItem>
              <RegisterBudgetModalContentDadosParceiroColumnItem>
                <p>
                  Número: <strong>{dados.numero}</strong>
                </p>
              </RegisterBudgetModalContentDadosParceiroColumnItem>
              <RegisterBudgetModalContentDadosParceiroColumnItem>
                <p>
                  Complemento: <strong>{dados.complemento}</strong>
                </p>
              </RegisterBudgetModalContentDadosParceiroColumnItem>
              <RegisterBudgetModalContentDadosParceiroColumnItem>
                <p>
                  Bairro: <strong>{dados.bairro}</strong>
                </p>
              </RegisterBudgetModalContentDadosParceiroColumnItem>
              <RegisterBudgetModalContentDadosParceiroColumnItem>
                <p>
                  Municipio: <strong>{dados.municipio}</strong>
                </p>
              </RegisterBudgetModalContentDadosParceiroColumnItem>
              <RegisterBudgetModalContentDadosParceiroColumnItem>
                <p>
                  UF: <strong>{dados.uf}</strong>
                </p>
              </RegisterBudgetModalContentDadosParceiroColumnItem>
            </RegisterBudgetModalContentDadosParceiroColumn>
            <RegisterBudgetModalContentDadosParceiroColumn>
              <RegisterBudgetModalContentDadosParceiroColumnTitle>
                <strong>Dados do contato</strong>
              </RegisterBudgetModalContentDadosParceiroColumnTitle>
              <RegisterBudgetModalContentDadosParceiroColumnSubtitle>
                <p>
                  <strong>Informações</strong>
                </p>
                <RegisterBudgetModalContentDadosParceiroColumnSublinhado />
              </RegisterBudgetModalContentDadosParceiroColumnSubtitle>
              <RegisterBudgetModalContentDadosParceiroColumnItem>
                <p>
                  Pessoa de contato: <strong>{dados.nome_contato}</strong>
                </p>
              </RegisterBudgetModalContentDadosParceiroColumnItem>
              <RegisterBudgetModalContentDadosParceiroColumnItem>
                <p>
                  Fixo:{" "}
                  <strong>
                    {dados.numero_telefone != undefined ? this.numeroTelefone(dados.numero_telefone) : ""}
                  </strong>
                </p>
              </RegisterBudgetModalContentDadosParceiroColumnItem>
              <RegisterBudgetModalContentDadosParceiroColumnItem>
                <p>
                  Celular:{" "}
                  <strong>{dados.numero_celular != undefined ? this.numeroTelefone(dados.numero_celular) : ""}</strong>
                </p>
              </RegisterBudgetModalContentDadosParceiroColumnItem>
              <RegisterBudgetModalContentDadosParceiroColumnItem>
                <p>
                  Email: <strong>{dados.email}</strong>
                </p>
              </RegisterBudgetModalContentDadosParceiroColumnItem>
              <RegisterBudgetModalContentDadosParceiroColumnItem>
                <p>
                  Classificação: <strong>{dados.classificacao_icms}</strong>
                </p>
              </RegisterBudgetModalContentDadosParceiroColumnItem>
              <RegisterBudgetModalContentDadosParceiroColumnItem>
                <p>
                  Origem: <strong>{dados.descricao_origem}</strong>
                </p>
              </RegisterBudgetModalContentDadosParceiroColumnItem>
            </RegisterBudgetModalContentDadosParceiroColumn>
          </RegisterBudgetModalContentDadosParceiro>
        </RegisterBudgetModalContentParceiro>
      </RegisterBudgetModal>
    );
  }
}

function ifnull(a, b) {
  if (a == undefined || a == null || a == "") {
    return b;
  } else {
    return a;
  }
}

class ModalCustom extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dados: [],
      view_loading: false,
      texto_buscado: "",
    };
  }

  ifnull(a, b) {
    if (a == undefined || a == null || a == "") {
      return b;
    } else {
      return a;
    }
  }

  getGridProdutoPorParametros = async () => {
    try {
      if (this.state.texto_buscado != "") {
        this.setState({ dados: [], view_loading: true });
        const response = await buscaProdutoPorParametros.post("listar-produto-por-parametros", {
          codigo_categoria: "",
          codigo_subcategoria: "",
          codigo_cor: "",
          codigo_impressao: "",
          quantidade: "",
          valor_inicial: "",
          valor_final: "",
          prazo_entrega: "",
          texto_buscado: this.state.texto_buscado,
        });
        var dados = await response.data;
        var produtos = [];

        for (var prod of dados) {
          if (prod.url_seo) {
            var url_seo = prod.url_seo.split("-");

            var referencia = prod.referencia.toString();
            var link =
              "/" +
              referencia.substring(referencia.length - 4) +
              "/" +
              url_seo.slice(0, url_seo.length - 1).join("-") +
              "-1-1.jpg";

            var preco_home = Math.round(parseFloat(prod.valor_venda) * 100) / 100;

            produtos.push({
              prod_nome: prod.nome,
              prod_cod: prod.referencia,
              url_prod: prod.url_seo,
              img_prod: link,
              referencia: prod.referencia,
              descricao: prod.descricao,
              caracteristicas: prod.caracteristicas,
              valor_home: preco_home.toString().replace(".", ","),
              selo: prod.ad_embalagem ? "S" : "N",
              segmento: prod.segmento,
              cores: this.ifnull(prod.rgb_cores, "").trim(),
              pdv: prod.ad_pdv,
              cubagem: prod.dimensoes,
              url_img: link,
              estoque: prod.estoque_disponivel,
            });
          }
        }

        await this.setState({ dados: produtos, view_loading: false });

        this.state.dados.sort(function (a, b) {
          var valor_a = parseFloat(a.valor_home.replace(".", "").replace(",", "."));
          var valor_b = parseFloat(b.valor_home.replace(".", "").replace(",", "."));

          if (a.estoque != 0) {
            if (valor_a < valor_b) {
              return 1;
            } else if (valor_a > valor_b) {
              return -1;
            }
          }

          return 0;
        });

        this.state.dados.sort(function (a, b) {
          var valor_a = parseFloat(a.valor_home.replace(".", "").replace(",", "."));
          var valor_b = parseFloat(b.valor_home.replace(".", "").replace(",", "."));
          if (a.estoque != 0) {
            if (valor_a < valor_b) {
              return -1;
            } else if (valor_a > valor_b) {
              return 1;
            }
          }

          return 0;
        });

        this.setState({ update: true });
      } else {
        alert("Digite o nome ou o código do produto.");
      }
    } catch (error) {
      console.log(Object.keys(error), error.message);
    }
  };

  handleFiltroProduto = async (e) => {
    this.setState({ texto_buscado: e.target.value });
    if (e.key == "Enter") {
      this.getGridProdutoPorParametros();
    }
  };

  selecionaProduto = async (e) => {
    this.props.selecionaProduto(e.target.attributes.data.value);
  };

  render() {
    const { dados } = this.state;

    return (
      <RegisterBudgetModalAbaProduto>
        <RegisterBudgetModalContentAbaProduto>
          <RegisterBudgetModalContentFilterProduct>
            <RegisterBudgetResumeContentFilterSelectorProduct>
              <label>NOME/COD. PRODUTO: </label>
              <input
                name="texto_buscado"
                type="text"
                onKeyPress={(e) => this.handleFiltroProduto(e)}
                onChange={(e) => this.handleFiltroProduto(e)}
              />
            </RegisterBudgetResumeContentFilterSelectorProduct>
            <RegisterBudgetResumeContentFilterButton onClick={() => this.getGridProdutoPorParametros()}>
              BUSCAR
            </RegisterBudgetResumeContentFilterButton>
            <RegisterBudgetResumeContentFilterButtonWhite onClick={() => this.props.fecharModalProduto()}>
              FECHAR
            </RegisterBudgetResumeContentFilterButtonWhite>
          </RegisterBudgetModalContentFilterProduct>

          <RegisterBudgetProdutoGridProdutos
            style={{
              height: 530 * (this.state.dados.length / 4) + "px",
            }}
          >
            <RegisterBudgetResumeLoading style={this.state.view_loading ? { display: "block" } : { display: "none" }}>
              <RegisterBudgetResumeLoadingContent>
                <img alt="loading" src={loading} />
              </RegisterBudgetResumeLoadingContent>
            </RegisterBudgetResumeLoading>
            {this.state.dados.map((data) => {
              return (
                <MontaProduto
                  prod_nome={data.prod_nome}
                  codigo_prod={data.prod_cod}
                  url_prod={data.url_prod}
                  img_prod={"https://innovationbrindes.com.br/images/produtos" + data.img_prod}
                  descricao={data.descricao}
                  caracteristicas={data.caracteristicas}
                  valor_home={data.valor_home}
                  selo={data.selo}
                  segmento={data.segmento}
                  ultrarapido={data.ultrarapido}
                  url_site={this.state.url_site}
                  ad_pdv={data.pdv}
                  cores={data.cores}
                  estoque={data.estoque}
                  selecionaProduto={this.selecionaProduto}
                />
              );
            })}
          </RegisterBudgetProdutoGridProdutos>
        </RegisterBudgetModalContentAbaProduto>
      </RegisterBudgetModalAbaProduto>
    );
  }
}

function ModalLayout(data) {
  var split_data = data.data_product.url_seo.split("-");
  split_data.pop();
  var url = split_data.join("-");
  var img =
    "https://innovationbrindes.com.br/images/produtos/" +
    data.data_product.referencia.toString().substr(data.data_product.referencia.length - 4) +
    "/" +
    url +
    "-1-1.jpg";

  return (
    <RegisterBudgetModal>
      <RegisterBudgetModalContentLayout>
        <RegisterBudgetModalContentHeader>
          <p>SOLICITAÇÃO DE LAYOUT / UPLOAD ARQUIVO</p>
          <span onClick={() => data.closeModalLayout()}>Fechar</span>
        </RegisterBudgetModalContentHeader>
        <RegisterBudgetModalContentDataProduct>
          <RegisterBudgetModalContentDataProductCardImage>
            <img alt="img" src={img} />
          </RegisterBudgetModalContentDataProductCardImage>
          <RegisterBudgetModalContentDataProductInfos>
            <RegisterBudgetModalContentDataProductInfosTitle>
              <p>
                {data.data_product.nome_produto} - {data.data_product.referencia}
              </p>
            </RegisterBudgetModalContentDataProductInfosTitle>
            <RegisterBudgetModalContentDataProductInfosLine>
              <RegisterBudgetModalContentDataProductInfosLineBlock>
                <p>COR DO BRINDE:</p>
              </RegisterBudgetModalContentDataProductInfosLineBlock>
              <RegisterBudgetModalContentDataProductInfosLineBlock>
                <p>{data.data_product.descricao_cor.toUpperCase()}</p>
              </RegisterBudgetModalContentDataProductInfosLineBlock>
            </RegisterBudgetModalContentDataProductInfosLine>
            <RegisterBudgetModalContentDataProductInfosLine>
              <RegisterBudgetModalContentDataProductInfosLineBlockNoneBgColor>
                <p>GRAVAÇÃO:</p>
              </RegisterBudgetModalContentDataProductInfosLineBlockNoneBgColor>
              <RegisterBudgetModalContentDataProductInfosLineBlockNoneBgColor>
                <p>{data.data_product.descricao_impressao.toUpperCase()}</p>
              </RegisterBudgetModalContentDataProductInfosLineBlockNoneBgColor>
            </RegisterBudgetModalContentDataProductInfosLine>
            <RegisterBudgetModalContentDataProductInfosLine>
              <RegisterBudgetModalContentDataProductInfosLineBlock>
                <p>IMPRESSÕES:</p>
              </RegisterBudgetModalContentDataProductInfosLineBlock>
              <RegisterBudgetModalContentDataProductInfosLineBlock>
                <p>{data.data_product.qtd_batida}</p>
              </RegisterBudgetModalContentDataProductInfosLineBlock>
            </RegisterBudgetModalContentDataProductInfosLine>
          </RegisterBudgetModalContentDataProductInfos>
        </RegisterBudgetModalContentDataProduct>
        <RegisterBudgetModalContentDataGrid>
          <RegisterBudgetModalContentDataGridControl>
            <button>Adicionar arquivo</button>
            <input
              id={"input-upload-file"}
              type="file"
              accept=".ai,.indd,.psd,.cdr,.jpg"
              onChange={(e) => data.uploadFileDrive(e)}
            />
            <p>
              Formato de arquivo aceitos: <strong>(AI,INDD,PSD,CDR,JPG)</strong>
            </p>
          </RegisterBudgetModalContentDataGridControl>
          <RegisterBudgetModalContentDataGridTable>
            <table>
              <thead>
                <th></th>
                <th>Quantidade de layouts</th>
                <th>Link dos layouts</th>
              </thead>
              <tbody>
                {data.data_layout != undefined ? (
                  <>
                    <td></td>
                    <td>{data.data_layout.quantidade}</td>
                    {data.data_layout.quantidade > 0 ? (
                      <td>
                        <a href={data.data_layout.link_drive} target="_blank" rel="noreferrer">
                          Acessar
                        </a>
                      </td>
                    ) : (
                      <td></td>
                    )}
                  </>
                ) : (
                  <></>
                )}
              </tbody>
            </table>
          </RegisterBudgetModalContentDataGridTable>
        </RegisterBudgetModalContentDataGrid>
        <RegisterBudgetModalContentFooter>
          <button>FINALIZAR</button>
        </RegisterBudgetModalContentFooter>
      </RegisterBudgetModalContentLayout>
    </RegisterBudgetModal>
  );
}

function MontaProduto(data) {
  if (data.cores != "") {
    var cores = data.cores.split(";");
  }

  if (data.ad_pdv != "S") {
    var visible = "block";
  } else {
    var visible = "none";
  }

  var seloprod = {};
  if (parseInt(data.estoque) == 0) {
    seloprod = {
      backgroundImage: 'url("/images/menu/selo-indisponivel.png")',
    };
  } else {
    if (data.segmento != "") {
      if (data.segmento == "N") {
        seloprod = {
          width: "78px",
          height: "21px",
          left: "120px",
          backgroundImage: 'url("/images/menu/NOVIDADE.png")',
        };
      } else if (data.segmento == "U") {
        seloprod = {
          backgroundImage: 'url("/images/menu/ultrarapido.png")',
        };
      } else if (data.segmento == "NN") {
        seloprod = {
          width: "78px",
          height: "21px",
          left: "120px",
          backgroundImage: 'url("/images/menu/NOVIDADE.png")',
        };
      } else if (data.segmento == "UN") {
        seloprod = {
          width: "78px",
          height: "21px",
          left: "120px",
          backgroundImage: 'url("/images/menu/NOVIDADE.png")',
        };
      }
    }
  }

  return (
    <RegisterBudgetProdutoGridProdutosProduto>
      <RegisterBudgetProdutoGridProdutosTitle>
        <strong>
          <h1>{data.prod_nome}</h1>
        </strong>
        <p style={{ top: "8px" }}>
          - {data.codigo_prod.toString().substring(data.codigo_prod.toString().length - 4, 100)} -
        </p>
      </RegisterBudgetProdutoGridProdutosTitle>
      <RegisterBudgetProdutoGridProdutosCardProd>
        <a>
          <RegisterBudgetProdutoGridProdutosCardProdImageProd
            alt="prod"
            data={data.codigo_prod}
            onClick={(e) => data.selecionaProduto(e)}
            src={data.img_prod}
          />
        </a>

        {data.selo == "S" ? (
          <div className="innovation-crm-register-budget__produto__grid-produtos__produto__card-prod-custom__selo-embalagem" />
        ) : (
          <div></div>
        )}
        {data.seloprod != "" ? (
          <div
            style={seloprod}
            className="innovation-crm-register-budget__produto__grid-produtos__produto__card-prod-custom__selo"
          />
        ) : (
          <div></div>
        )}

        <RegisterBudgetProdutoGridProdutosCardProdDesc>
          <p>{ifnull(data.caracteristicas, "").substring(0, 55)}...</p>
        </RegisterBudgetProdutoGridProdutosCardProdDesc>
        <RegisterBudgetProdutoGridProdutosCardProdCores>
          <RegisterBudgetProdutoGridProdutosCardProdCoresTitle>
            <p>
              <strong>Cores:</strong>
            </p>
          </RegisterBudgetProdutoGridProdutosCardProdCoresTitle>
          <RegisterBudgetProdutoGridProdutosCardProdCoresGridCores>
            <RegisterBudgetProdutoGridProdutosCardProdCoresGridCoresContent>
              {cores != undefined
                ? cores.map((data, idx) => {
                    if (idx == 0 || idx == 5 || idx == 10) {
                      if (data.trim() != "") {
                        if (data.split(":")[0].indexOf("/") != -1) {
                          if (
                            data.split(":")[1].split("/")[0] == "#ffffff" ||
                            data.split(":")[1].split("/")[1] == "#ffffff"
                          ) {
                            return (
                              <divRegisterBudgetProdutoGridProdutosCardProdCoresGridCoresContentCor
                                style={{
                                  marginLeft: "0px",
                                  backgroundImage:
                                    "linear-gradient(to right, " +
                                    data.split(":")[1].split("/")[0] +
                                    "," +
                                    data.split(":")[1].split("/")[0] +
                                    "," +
                                    data.split(":")[1].split("/")[0] +
                                    "," +
                                    data.split(":")[1].split("/")[0] +
                                    "," +
                                    data.split(":")[1].split("/")[0] +
                                    ", " +
                                    data.split(":")[1].split("/")[1] +
                                    "," +
                                    data.split(":")[1].split("/")[1] +
                                    "," +
                                    data.split(":")[1].split("/")[1] +
                                    "," +
                                    data.split(":")[1].split("/")[1] +
                                    "," +
                                    data.split(":")[1].split("/")[1] +
                                    ")",
                                  border: "1px solid rgb(180,180,180)",
                                }}
                                data-bs-toggle="tooltip"
                                data-bs-placement="top"
                                title={data.split(":")[0]}
                              ></divRegisterBudgetProdutoGridProdutosCardProdCoresGridCoresContentCor>
                            );
                          } else {
                            return (
                              <RegisterBudgetProdutoGridProdutosCardProdCoresGridCoresContentCor
                                style={{
                                  marginLeft: "0px",
                                  backgroundImage:
                                    "linear-gradient(to right, " +
                                    data.split(":")[1].split("/")[0] +
                                    "," +
                                    data.split(":")[1].split("/")[0] +
                                    "," +
                                    data.split(":")[1].split("/")[0] +
                                    "," +
                                    data.split(":")[1].split("/")[0] +
                                    "," +
                                    data.split(":")[1].split("/")[0] +
                                    ", " +
                                    data.split(":")[1].split("/")[1] +
                                    "," +
                                    data.split(":")[1].split("/")[1] +
                                    "," +
                                    data.split(":")[1].split("/")[1] +
                                    "," +
                                    data.split(":")[1].split("/")[1] +
                                    "," +
                                    data.split(":")[1].split("/")[1] +
                                    ")",
                                }}
                                data-bs-toggle="tooltip"
                                data-bs-placement="top"
                                title={data.split(":")[0]}
                              ></RegisterBudgetProdutoGridProdutosCardProdCoresGridCoresContentCor>
                            );
                          }
                        }

                        if (data.split(":")[1] == "#ffffff") {
                          return (
                            <RegisterBudgetProdutoGridProdutosCardProdCoresGridCoresContentCor
                              style={{
                                marginLeft: "0px",
                                backgroundColor: data.split(":")[1] + "",
                                border: "1px solid rgb(180,180,180)",
                              }}
                              data-bs-toggle="tooltip"
                              data-bs-placement="top"
                              title={data.split(":")[0]}
                            ></RegisterBudgetProdutoGridProdutosCardProdCoresGridCoresContentCor>
                          );
                        } else {
                          return (
                            <RegisterBudgetProdutoGridProdutosCardProdCoresGridCoresContentCor
                              style={{
                                marginLeft: "0px",
                                backgroundColor: data.split(":")[1] + "",
                              }}
                              data-bs-toggle="tooltip"
                              data-bs-placement="top"
                              title={data.split(":")[0]}
                            ></RegisterBudgetProdutoGridProdutosCardProdCoresGridCoresContentCor>
                          );
                        }
                      }
                    } else {
                      if (data.trim() != "") {
                        if (data.split(":")[0].indexOf("/") != -1) {
                          if (
                            data.split(":")[1].split("/")[0] == "#ffffff" ||
                            data.split(":")[1].split("/")[1] == "#ffffff"
                          ) {
                            return (
                              <RegisterBudgetProdutoGridProdutosCardProdCoresGridCoresContentCor
                                style={{
                                  backgroundImage:
                                    "linear-gradient(to right, " +
                                    data.split(":")[1].split("/")[0] +
                                    "," +
                                    data.split(":")[1].split("/")[0] +
                                    "," +
                                    data.split(":")[1].split("/")[0] +
                                    "," +
                                    data.split(":")[1].split("/")[0] +
                                    "," +
                                    data.split(":")[1].split("/")[0] +
                                    ", " +
                                    data.split(":")[1].split("/")[1] +
                                    "," +
                                    data.split(":")[1].split("/")[1] +
                                    "," +
                                    data.split(":")[1].split("/")[1] +
                                    "," +
                                    data.split(":")[1].split("/")[1] +
                                    "," +
                                    data.split(":")[1].split("/")[1] +
                                    ")",
                                  border: "1px solid rgb(180,180,180)",
                                }}
                                data-bs-toggle="tooltip"
                                data-bs-placement="top"
                                title={data.split(":")[0]}
                              ></RegisterBudgetProdutoGridProdutosCardProdCoresGridCoresContentCor>
                            );
                          } else {
                            return (
                              <RegisterBudgetProdutoGridProdutosCardProdCoresGridCoresContentCor
                                style={{
                                  backgroundImage:
                                    "linear-gradient(to right, " +
                                    data.split(":")[1].split("/")[0] +
                                    "," +
                                    data.split(":")[1].split("/")[0] +
                                    "," +
                                    data.split(":")[1].split("/")[0] +
                                    "," +
                                    data.split(":")[1].split("/")[0] +
                                    "," +
                                    data.split(":")[1].split("/")[0] +
                                    ", " +
                                    data.split(":")[1].split("/")[1] +
                                    "," +
                                    data.split(":")[1].split("/")[1] +
                                    "," +
                                    data.split(":")[1].split("/")[1] +
                                    "," +
                                    data.split(":")[1].split("/")[1] +
                                    "," +
                                    data.split(":")[1].split("/")[1] +
                                    ")",
                                }}
                                data-bs-toggle="tooltip"
                                data-bs-placement="top"
                                title={data.split(":")[0]}
                              ></RegisterBudgetProdutoGridProdutosCardProdCoresGridCoresContentCor>
                            );
                          }
                        }

                        if (data.split(":")[1] == "#ffffff") {
                          return (
                            <RegisterBudgetProdutoGridProdutosCardProdCoresGridCoresContentCor
                              style={{
                                backgroundColor: data.split(":")[1] + "",
                                border: "1px solid rgb(180,180,180)",
                              }}
                              data-bs-toggle="tooltip"
                              data-bs-placement="top"
                              title={data.split(":")[0]}
                            ></RegisterBudgetProdutoGridProdutosCardProdCoresGridCoresContentCor>
                          );
                        } else {
                          return (
                            <RegisterBudgetProdutoGridProdutosCardProdCoresGridCoresContentCor
                              style={{
                                backgroundColor: data.split(":")[1] + "",
                              }}
                              data-bs-toggle="tooltip"
                              data-bs-placement="top"
                              title={data.split(":")[0]}
                            ></RegisterBudgetProdutoGridProdutosCardProdCoresGridCoresContentCor>
                          );
                        }
                      }
                    }
                  })
                : null}
            </RegisterBudgetProdutoGridProdutosCardProdCoresGridCoresContent>
          </RegisterBudgetProdutoGridProdutosCardProdCoresGridCores>
        </RegisterBudgetProdutoGridProdutosCardProdCores>
        <RegisterBudgetProdutoGridProdutosCardProdValor>
          <RegisterBudgetProdutoGridProdutosCardProdValorContent>
            <p>
              {parseFloat(data.valor_home.replaceAll(".", "").replaceAll(",", ".")) != 0.0 ? (
                <div>
                  a partir de <br />
                  <strong>
                    R${" "}
                    {parseFloat(data.valor_home.replaceAll(".", "").replaceAll(",", ".")).toLocaleString("pt-br", {
                      minimumFractionDigits: 2,
                    })}
                    <br />
                  </strong>
                  <p style={{ fontSize: "11px" }}>gerado pela melhor oferta</p>
                </div>
              ) : (
                <div></div>
              )}
            </p>
          </RegisterBudgetProdutoGridProdutosCardProdValorContent>
        </RegisterBudgetProdutoGridProdutosCardProdValor>
      </RegisterBudgetProdutoGridProdutosCardProd>
      {parseInt(data.estoque) == 0 ? (
        <RegisterBudgetProdutoGridProdutosProdutoBNTConferirDisponivel>
          <a>
            <button>
              <strong>INDISPONÍVEL</strong>
            </button>
          </a>
        </RegisterBudgetProdutoGridProdutosProdutoBNTConferirDisponivel>
      ) : (
        <RegisterBudgetProdutoGridProdutosProdutoBNTConferir
          data={data.codigo_prod}
          onClick={(e) => data.selecionaProduto(e)}
        >
          <a data={data.codigo_prod}>
            <button data={data.codigo_prod}>
              <strong data={data.codigo_prod}>SELECIONAR</strong>
            </button>
          </a>
        </RegisterBudgetProdutoGridProdutosProdutoBNTConferir>
      )}
    </RegisterBudgetProdutoGridProdutosProduto>
  );
}

function DataCustomer(data) {
  var self = data.this;
  var control_css = data.control_css;
  var dados = data.dados;

  return (
    <RegisterBudgetContentDataCustomer>
      <RegisterBudgetContentDataCustomerHeader
        onClick={() =>
          self.setState({
            view_data_customer: !self.state.view_data_customer,
          })
        }
      >
        <RegisterBudgetContentDataCustomerHeaderTitle
          onClick={() =>
            self.setState({
              view_data_customer: !self.state.view_data_customer,
            })
          }
        >
          <p
            onClick={() =>
              self.setState({
                view_data_customer: !self.state.view_data_customer,
              })
            }
          >
            DADOS <strong>DO CLIENTE</strong>
          </p>
        </RegisterBudgetContentDataCustomerHeaderTitle>
        <span
          style={control_css.data_customer.arrow}
          onClick={() =>
            self.setState({
              view_data_customer: !self.state.view_data_customer,
            })
          }
          className="icon icon-20 icon-arrow-down-white"
        ></span>
      </RegisterBudgetContentDataCustomerHeader>
      <RegisterBudgetContentDataCustomerBody style={control_css.data_customer.body}>
        <RegisterBudgetContentDataCustomerBodyContent style={control_css.data_customer.content}>
          <RegisterBudgetContentDataCustomerBodyContentRow>
            <RegisterBudgetContentDataCustomerBodyContentRowSelectField>
              <label>Parceiro:</label>
              <RegisterBudgetContentDataCustomerBodyContentRowSelectFieldField
                style={control_css.data_customer.field_1}
                onClick={() =>
                  self.setState({
                    view_parceiros_modal: true,
                  })
                }
              >
                <RegisterBudgetContentDataCustomerBodyContentRowSelectFieldFieldText>
                  <p>
                    {dados.razao_social_parceiro != undefined
                      ? "(Cód.:" +
                        dados.codigo_parceiro +
                        ") " +
                        (dados.razao_social_parceiro.length > 22
                          ? dados.razao_social_parceiro.substring(0, 22) + "..."
                          : dados.razao_social_parceiro)
                      : ""}
                  </p>
                </RegisterBudgetContentDataCustomerBodyContentRowSelectFieldFieldText>
                <span className="icon icon-20 icon-edit-green-20"></span>
              </RegisterBudgetContentDataCustomerBodyContentRowSelectFieldField>
            </RegisterBudgetContentDataCustomerBodyContentRowSelectField>
            <RegisterBudgetContentDataCustomerBodyContentRowButton>
              {dados.cliente_especial == "S" ? <button>Cliente especial</button> : <></>}
            </RegisterBudgetContentDataCustomerBodyContentRowButton>
            <RegisterBudgetContentDataCustomerBodyContentRowButtonMedium>
              {dados.numero_contrato != "" && dados.numero_contrato != undefined && dados.numero_contrato != null ? (
                <button>{dados.numero_contrato}</button>
              ) : (
                <></>
              )}
            </RegisterBudgetContentDataCustomerBodyContentRowButtonMedium>
            <RegisterBudgetContentDataCustomerBodyContentRowInformation>
              <p>
                Total de orçamentos: <strong>{dados.quantidade_total_proposta}</strong>
              </p>
            </RegisterBudgetContentDataCustomerBodyContentRowInformation>
            <RegisterBudgetContentDataCustomerBodyContentRowInformation>
              <p>
                Total de pedidos: <strong>{dados.quantidade_total_pedido}</strong>
              </p>
            </RegisterBudgetContentDataCustomerBodyContentRowInformation>
          </RegisterBudgetContentDataCustomerBodyContentRow>
          <RegisterBudgetContentDataCustomerBodyContentRow>
            <RegisterBudgetContentDataCustomerBodyContentRowSelectField>
              <label>Contato:</label>
              <RegisterBudgetContentDataCustomerBodyContentRowSelectFieldField
                style={control_css.data_customer.field_2}
                onClick={() =>
                  self.setState({
                    view_contatos_modal: true,
                  })
                }
              >
                <RegisterBudgetContentDataCustomerBodyContentRowSelectFieldFieldText>
                  <p>{dados.nome_contato}</p>
                </RegisterBudgetContentDataCustomerBodyContentRowSelectFieldFieldText>
                <span className="icon icon-20 icon-edit-green-20"></span>
              </RegisterBudgetContentDataCustomerBodyContentRowSelectFieldField>
            </RegisterBudgetContentDataCustomerBodyContentRowSelectField>
            <RegisterBudgetContentDataCustomerBodyContentRowButton></RegisterBudgetContentDataCustomerBodyContentRowButton>
            <RegisterBudgetContentDataCustomerBodyContentRowButtonMedium></RegisterBudgetContentDataCustomerBodyContentRowButtonMedium>
            <RegisterBudgetContentDataCustomerBodyContentRowInformation></RegisterBudgetContentDataCustomerBodyContentRowInformation>
            <RegisterBudgetContentDataCustomerBodyContentRowInformation style={control_css.data_customer.custom}>
              <p>
                {dados.quantidade_total_pedido} pedidos fechados | totalizando{" "}
                {!isNaN(parseFloat(dados.valor_total_pedido))
                  ? parseFloat(dados.valor_total_pedido).toLocaleString("pt-BR", {
                      style: "currency",
                      currency: "BRL",
                    })
                  : null}
              </p>
              <RegisterBudgetContentDataCustomerBodyContentRowInformationPlus
                onClick={
                  dados.nome_contato != null
                    ? () =>
                        self.setState({
                          view_total_pedidos_modal: true,
                        })
                    : () => {}
                }
              >
                <span
                  onClick={
                    dados.nome_contato != null
                      ? () =>
                          self.setState({
                            view_total_pedidos_modal: true,
                          })
                      : () => {}
                  }
                  className="icon icon-20 icon-plus-green"
                ></span>{" "}
                Detalhes
              </RegisterBudgetContentDataCustomerBodyContentRowInformationPlus>
            </RegisterBudgetContentDataCustomerBodyContentRowInformation>
          </RegisterBudgetContentDataCustomerBodyContentRow>
          <RegisterBudgetContentDataCustomerBodyContentRowGray style={control_css.data_customer.custom}>
            <RegisterBudgetContentDataCustomerBodyContentRowTextFieldSmall>
              <p>
                Telefone: <br /> {dados.telefone_contato}
              </p>
            </RegisterBudgetContentDataCustomerBodyContentRowTextFieldSmall>
            <RegisterBudgetContentDataCustomerBodyContentRowTextFieldSmall>
              <p>
                Celular: <br /> {dados.celular_contato}
              </p>
            </RegisterBudgetContentDataCustomerBodyContentRowTextFieldSmall>
            <RegisterBudgetContentDataCustomerBodyContentRowTextField>
              <p>
                Email: <br /> {dados.email_contato}
              </p>
            </RegisterBudgetContentDataCustomerBodyContentRowTextField>
            <RegisterBudgetContentDataCustomerBodyContentRowTextField>
              <p>
                Histórico de pagamento: <br /> <strong>{dados.situacao_pagamento}</strong>
              </p>
            </RegisterBudgetContentDataCustomerBodyContentRowTextField>
            <RegisterBudgetContentDataCustomerBodyContentRowTextField>
              <p>
                Obs financeiro: <br /> <strong>{dados.observacao_admin}</strong>
              </p>
            </RegisterBudgetContentDataCustomerBodyContentRowTextField>
          </RegisterBudgetContentDataCustomerBodyContentRowGray>
          <RegisterBudgetContentDataCustomerBodyContentRowButtonBTN style={control_css.data_customer.custom}>
            <RegisterBudgetContentDataCustomerBodyContentRowButtonRegister>
              <button onClick={dados.nome_contato != null ? () => self.visualizarDadosParceiro() : () => {}}>
                VISUALIZAR CADASTRO COMPLETO / EDITAR CADASTRO
              </button>
            </RegisterBudgetContentDataCustomerBodyContentRowButtonRegister>
          </RegisterBudgetContentDataCustomerBodyContentRowButtonBTN>
        </RegisterBudgetContentDataCustomerBodyContent>
      </RegisterBudgetContentDataCustomerBody>
    </RegisterBudgetContentDataCustomer>
  );
}

function DataProposal(data) {
  var self = data.this;
  var control_css = data.control_css;
  var dados = data.dados;
  var listaDeEmpresa = data.listaDeEmpresa;
  return (
    <RegisterBudgetContentProposal>
      <RegisterBudgetContentProposalHeader
        style={control_css.data_proposal.header}
        onClick={
          dados.nome_contato != null
            ? () =>
                self.setState({
                  view_data_proposal: !self.state.view_data_proposal,
                })
            : () => {}
        }
      >
        <RegisterBudgetContentProposalHeaderTitle
          onClick={
            dados.nome_contato != null
              ? () =>
                  self.setState({
                    view_data_proposal: !self.state.view_data_proposal,
                  })
              : () => {}
          }
        >
          <p
            onClick={
              dados.nome_contato != null
                ? () =>
                    self.setState({
                      view_data_proposal: !self.state.view_data_proposal,
                    })
                : () => {}
            }
          >
            DADOS <strong>DA PROPOSTA</strong>
          </p>
        </RegisterBudgetContentProposalHeaderTitle>
        <span
          style={control_css.data_proposal.arrow}
          onClick={
            dados.nome_contato != null
              ? () =>
                  self.setState({
                    view_data_proposal: !self.state.view_data_proposal,
                  })
              : () => {}
          }
          className="icon icon-20 icon-arrow-down-white"
        ></span>
      </RegisterBudgetContentProposalHeader>
      <RegisterBudgetContentProposalBody style={control_css.data_proposal.body}>
        <RegisterBudgetContentProposalBodyContent style={control_css.data_proposal.content}>
          <RegisterBudgetContentProposalBodyContentColumn>
            <RegisterBudgetContentProposalBodyContentColumnField>
              <label>Faturamento:</label>
              <RegisterBudgetContentProposalBodyContentColumnSelectFieldFieldArrow>
                <RegisterBudgetContentProposalBodyContentColumnSelectFieldFieldSelect
                  id="selectEmpresa"
                  onChange={(e) => self.selectEmpresa(e)}
                >
                  {listaDeEmpresa.map((data) => {
                    return <option value={data.codigo_empresa}>{data.nome_empresa.trim()}</option>;
                  })}
                </RegisterBudgetContentProposalBodyContentColumnSelectFieldFieldSelect>
              </RegisterBudgetContentProposalBodyContentColumnSelectFieldFieldArrow>
            </RegisterBudgetContentProposalBodyContentColumnField>
            <RegisterBudgetContentProposalBodyContentColumnField>
              <label>Cond. Pgto.:</label>
              <RegisterBudgetContentProposalBodyContentColumnSelectFieldField
                style={control_css.data_proposal.field_1}
                onClick={() =>
                  self.setState({
                    view_condicao_modal: true,
                  })
                }
              >
                <RegisterBudgetContentProposalBodyContentColumnSelectFieldFieldText>
                  <p>{dados.condicao_pagamento}</p>
                </RegisterBudgetContentProposalBodyContentColumnSelectFieldFieldText>
                <span className="icon icon-20 icon-edit-green-20"></span>
              </RegisterBudgetContentProposalBodyContentColumnSelectFieldField>
            </RegisterBudgetContentProposalBodyContentColumnField>
            <RegisterBudgetContentProposalBodyContentColumnField>
              <label>Estimativa:</label>
              <RegisterBudgetContentProposalBodyContentColumnSelectFieldFieldArrow>
                <RegisterBudgetContentProposalBodyContentColumnSelectFieldFieldSelect
                  style={control_css.data_proposal.field_2}
                  id="selectEstimativa"
                  onChange={(e) => self.selectEstimativa(e)}
                >
                  <option value={0}>Selecionar estimativa</option>
                  <option value={1}>Propostas até R$ 1 mil</option>
                  <option value={2}>Propostas até R$ 5 mil</option>
                  <option value={3}>Propostas até R$ 10 mil</option>
                  <option value={4}>Propostas até R$ 30 mil</option>
                  <option value={5}>Propostas acima R$ 30 mil</option>
                </RegisterBudgetContentProposalBodyContentColumnSelectFieldFieldSelect>
              </RegisterBudgetContentProposalBodyContentColumnSelectFieldFieldArrow>
            </RegisterBudgetContentProposalBodyContentColumnField>
            <RegisterBudgetContentProposalBodyContentColumnSelectFieldCustom>
              <label>Proposta especial:</label>
              <RegisterBudgetContentProposalBodyContentColumnSelectFieldFieldBorderNone>
                <input
                  checked={dados.proposta_especial == "S" ? true : false}
                  type="radio"
                  onClick={(e) => data.changeFieldSpecialProposal(e)}
                />
              </RegisterBudgetContentProposalBodyContentColumnSelectFieldFieldBorderNone>
            </RegisterBudgetContentProposalBodyContentColumnSelectFieldCustom>
            <RegisterBudgetContentProposalBodyContentColumnFunnel>
              <RegisterBudgetContentProposalBodyContentColumnFunnelContent>
                <p>ETAPA DO FUNIL DE VENDAS</p> <br />
                <RegisterBudgetContentProposalBodyContentColumnFunnelContentDetailsRow>
                  <div className={dados.st_funil_vendas >= 0 ? "green" : "item"}></div>
                  <div className={dados.st_funil_vendas >= 1 ? "linegreen" : "line"}></div>

                  <div className={dados.st_funil_vendas >= 1 ? "green" : "item"}></div>
                  <div className={dados.st_funil_vendas >= 2 ? "linegreen" : "line"}></div>

                  <div className={dados.st_funil_vendas >= 2 ? "green" : "item"}></div>
                  <div className={dados.st_funil_vendas >= 3 ? "linegreen" : "line"}></div>

                  <div className={dados.st_funil_vendas >= 3 ? "green" : "item"}></div>
                  <div className={dados.st_funil_vendas >= 4 ? "linegreen" : "line"}></div>

                  <div className={dados.st_funil_vendas >= 4 ? "green" : "item"}></div>
                </RegisterBudgetContentProposalBodyContentColumnFunnelContentDetailsRow>
                <RegisterBudgetContentProposalBodyContentColumnFunnelContentDetailsDivisor />
                <span className="">
                  <strong>{dados.descricao_funil_vendas}</strong>
                </span>
              </RegisterBudgetContentProposalBodyContentColumnFunnelContent>
            </RegisterBudgetContentProposalBodyContentColumnFunnel>
            <RegisterBudgetContentDataCustomerBodyContentRowButtonRegister style={control_css.data_proposal.custom}>
              <button onClick={self.state.estimativa_selecionada != 0 ? () => self.salvarCabecalho() : () => {}}>
                <span></span>
                SALVAR ALTERAÇÕES
              </button>
            </RegisterBudgetContentDataCustomerBodyContentRowButtonRegister>
          </RegisterBudgetContentProposalBodyContentColumn>
          <RegisterBudgetContentProposalBodyContentColumnLarge style={control_css.data_proposal.custom}>
            <RegisterBudgetContentProposalBodyContentColumnInfo>
              <RegisterBudgetContentProposalBodyContentColumnInfoTextFixedWidth>
                <RegisterBudgetContentProposalBodyContentColumnInfoTextHighlights>
                  Observação do cliente:
                </RegisterBudgetContentProposalBodyContentColumnInfoTextHighlights>
                <RegisterBudgetContentProposalBodyContentColumnInfoInputsObs>
                  {dados.observacao_cliente}
                </RegisterBudgetContentProposalBodyContentColumnInfoInputsObs>
              </RegisterBudgetContentProposalBodyContentColumnInfoTextFixedWidth>

              <RegisterBudgetContentDataProductBodyFooterContentDataTMKBodyContentRowInformationPlus>
                <span className="icon icon-20 icon-plus-green"></span> Detalhes
              </RegisterBudgetContentDataProductBodyFooterContentDataTMKBodyContentRowInformationPlus>
            </RegisterBudgetContentProposalBodyContentColumnInfo>

            <RegisterBudgetContentProposalBodyContentColumnInfo>
              <RegisterBudgetContentProposalBodyContentColumnInfoTextFixedWidth>
                <RegisterBudgetContentProposalBodyContentColumnInfoTextHighlights>
                  Observações gerais:
                </RegisterBudgetContentProposalBodyContentColumnInfoTextHighlights>
                <RegisterBudgetContentProposalBodyContentColumnInfoInputsObsTextarea
                  disabled={self.state.estimativa_selecionada == 0 ? true : false}
                  onChange={(e) => self.changeObs(e, "observacao")}
                  value={dados.observacao}
                  placeholder="Digite aqui uma observação geral sobre esta proposta..."
                ></RegisterBudgetContentProposalBodyContentColumnInfoInputsObsTextarea>
              </RegisterBudgetContentProposalBodyContentColumnInfoTextFixedWidth>

              <RegisterBudgetContentDataProductBodyFooterContentDataTMKBodyContentRowInformationPlus>
                <span className="icon icon-20 icon-plus-green"></span> Detalhes
              </RegisterBudgetContentDataProductBodyFooterContentDataTMKBodyContentRowInformationPlus>
            </RegisterBudgetContentProposalBodyContentColumnInfo>

            <RegisterBudgetContentProposalBodyContentColumnInfo>
              <RegisterBudgetContentProposalBodyContentColumnInfoTextFixedWidth>
                <RegisterBudgetContentProposalBodyContentColumnInfoTextHighlights>
                  Detalhes da proposta:
                </RegisterBudgetContentProposalBodyContentColumnInfoTextHighlights>
                <RegisterBudgetContentProposalBodyContentColumnInfoInputsObsTextarea
                  disabled={self.state.estimativa_selecionada == 0 ? true : false}
                  onChange={(e) => self.changeObs(e, "detalhe_proposta")}
                  value={dados.detalhe_proposta}
                  placeholder="Digite aqui uma observação detalhada sobre esta proposta..."
                ></RegisterBudgetContentProposalBodyContentColumnInfoInputsObsTextarea>
              </RegisterBudgetContentProposalBodyContentColumnInfoTextFixedWidth>

              <RegisterBudgetContentDataProductBodyFooterContentDataTMKBodyContentRowInformationPlus>
                <span className="icon icon-20 icon-plus-green"></span> Detalhes
              </RegisterBudgetContentDataProductBodyFooterContentDataTMKBodyContentRowInformationPlus>
            </RegisterBudgetContentProposalBodyContentColumnInfo>
          </RegisterBudgetContentProposalBodyContentColumnLarge>
        </RegisterBudgetContentProposalBodyContent>
      </RegisterBudgetContentProposalBody>
    </RegisterBudgetContentProposal>
  );
}

function toBase64(str) {
  return window.btoa(unescape(encodeURIComponent(str)));
}

function fromBase64(str) {
  return decodeURIComponent(escape(window.atob(str)));
}
export default CadastroOrcamento;
